import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var _Hl, _cL, _vw;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var If = Object.create;
var nn = Object.defineProperty,
    Ff = Object.defineProperties,
    Sf = Object.getOwnPropertyDescriptor,
    Ef = Object.getOwnPropertyDescriptors,
    Nf = Object.getOwnPropertyNames,
    Gn = Object.getOwnPropertySymbols,
    Bf = Object.getPrototypeOf,
    Os = Object.prototype.hasOwnProperty,
    tc = Object.prototype.propertyIsEnumerable;

var oc = function oc(e, t, o) {
  return t in e ? nn(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : e[t] = o;
},
    i = function i(e, t) {
  for (var o in t || (t = {})) {
    Os.call(t, o) && oc(e, o, t[o]);
  }

  if (Gn) {
    var _iterator = _createForOfIteratorHelper(Gn(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        tc.call(t, o) && oc(e, o, t[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    E = function E(e, t) {
  return Ff(e, Ef(t));
},
    Lf = function Lf(e) {
  return nn(e, "__esModule", {
    value: !0
  });
},
    n = function n(e, t) {
  return nn(e, "name", {
    value: t,
    configurable: !0
  });
};

var rc = function rc(e) {
  return typeof e == "symbol" ? e : e + "";
},
    f = function f(e, t) {
  var o = {};

  for (var r in e) {
    Os.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  }

  if (e != null && Gn) {
    var _iterator2 = _createForOfIteratorHelper(Gn(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var r = _step2.value;
        t.indexOf(r) < 0 && tc.call(e, r) && (o[r] = e[r]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return o;
};

var kf = function kf(e, t) {
  return function () {
    return e && (t = e(e = 0)), t;
  };
};

var wf = function wf(e, t) {
  return function () {
    return t || e((t = {
      exports: {}
    }).exports, t), t.exports;
  };
};

var Af = function Af(e, t, o, r) {
  if (t && typeof t == "object" || typeof t == "function") {
    var _iterator3 = _createForOfIteratorHelper(Nf(t)),
        _step3;

    try {
      var _loop = function _loop() {
        var a = _step3.value;
        !Os.call(e, a) && (o || a !== "default") && nn(e, a, {
          get: function get() {
            return t[a];
          },
          enumerable: !(r = Sf(t, a)) || r.enumerable
        });
      };

      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return e;
},
    $f = function $f(e, t) {
  return Af(Lf(nn(e != null ? If(Bf(e)) : {}, "default", !t && e && e.__esModule ? {
    get: function get() {
      return e.default;
    },
    enumerable: !0
  } : {
    value: e,
    enumerable: !0
  })), e);
};

var l = kf(function () {});
var Mc = wf(function (Ei) {
  "use strict";

  l();
  Ei.match = ST;
  Ei.parse = Ac;
  var xT = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
      CT = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
      vT = /^(?:(min|max)-)?(.+)/,
      IT = /(em|rem|px|cm|mm|in|pt|pc)?$/,
      FT = /(dpi|dpcm|dppx)?$/;

  function ST(e, t) {
    return Ac(e).some(function (o) {
      var r = o.inverse,
          a = o.type === "all" || t.type === o.type;
      if (a && r || !(a || r)) return !1;
      var s = o.expressions.every(function (p) {
        var c = p.feature,
            d = p.modifier,
            m = p.value,
            u = t[c];
        if (!u) return !1;

        switch (c) {
          case "orientation":
          case "scan":
            return u.toLowerCase() === m.toLowerCase();

          case "width":
          case "height":
          case "device-width":
          case "device-height":
            m = Dc(m), u = Dc(u);
            break;

          case "resolution":
            m = Oc(m), u = Oc(u);
            break;

          case "aspect-ratio":
          case "device-aspect-ratio":
          case "device-pixel-ratio":
            m = $c(m), u = $c(u);
            break;

          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            m = parseInt(m, 10) || 1, u = parseInt(u, 10) || 0;
            break;
        }

        switch (d) {
          case "min":
            return u >= m;

          case "max":
            return u <= m;

          default:
            return u === m;
        }
      });
      return s && !r || !s && r;
    });
  }

  n(ST, "matchQuery");

  function Ac(e) {
    return e.split(",").map(function (t) {
      t = t.trim();
      var o = t.match(xT),
          r = o[1],
          a = o[2],
          s = o[3] || "",
          p = {};
      return p.inverse = !!r && r.toLowerCase() === "not", p.type = a ? a.toLowerCase() : "all", s = s.match(/\([^\)]+\)/g) || [], p.expressions = s.map(function (c) {
        var d = c.match(CT),
            m = d[1].toLowerCase().match(vT);
        return {
          modifier: m[1],
          feature: m[2],
          value: d[2]
        };
      }), p;
    });
  }

  n(Ac, "parseQuery");

  function $c(e) {
    var t = Number(e),
        o;
    return t || (o = e.match(/^(\d+)\s*\/\s*(\d+)$/), t = o[1] / o[2]), t;
  }

  n($c, "toDecimal");

  function Oc(e) {
    var t = parseFloat(e),
        o = String(e).match(FT)[1];

    switch (o) {
      case "dpcm":
        return t / 2.54;

      case "dppx":
        return t * 96;

      default:
        return t;
    }
  }

  n(Oc, "toDpi");

  function Dc(e) {
    var t = parseFloat(e),
        o = String(e).match(IT)[1];

    switch (o) {
      case "em":
        return t * 16;

      case "rem":
        return t * 16;

      case "cm":
        return t * 96 / 2.54;

      case "mm":
        return t * 96 / 2.54 / 10;

      case "in":
        return t * 96;

      case "pt":
        return t * 72;

      case "pc":
        return t * 72 / 12;

      default:
        return t;
    }
  }

  n(Dc, "toPx");
});
l();
l();
import * as jo from "react";
import { useRef as zB, useEffect as Yd } from "react";
import Jl from "prop-types";
import { Card as WB, Avatar as qB } from "@mui/material";
import { styled as jB } from "@mui/material/styles";
import UB from "@mui/icons-material/Lock";
import { useNavigate as XB } from "react-router-dom";
import { useCheckAuth as QB } from "ra-core";
l();
import * as qo from "react";
import { styled as LB } from "@mui/material/styles";
import kB from "prop-types";
import { Button as wB, CardContent as AB, CircularProgress as $B } from "@mui/material";
import { Form as OB, required as Kd, useTranslate as DB, useLogin as MB, useNotify as VB, useSafeSetState as _B } from "ra-core";
l();
import * as Vt from "react";
import { cloneElement as nx, Children as ax, useEffect as rm, useRef as sx } from "react";
import ix from "clsx";
import { isRequired as lx, FieldTitle as px, composeSyncValidators as cx, useApplyInputDefaultValues as mx, useGetValidationErrorMessage as dx, useResourceContext as ux } from "ra-core";
import { useFieldArray as fx, useFormContext as gx, useWatch as yx } from "react-hook-form";
import { InputLabel as bx, FormControl as hx, FormHelperText as Rx } from "@mui/material";
import Tx from "lodash/isEqual";
l();
import * as Dt from "react";
import { styled as AR } from "@mui/material/styles";
import { Children as $R, memo as OR } from "react";
import Io from "prop-types";
import { AppBar as DR, Toolbar as MR, Typography as VR, useMediaQuery as _R } from "@mui/material";
import { ComponentPropType as HR } from "ra-core";
l();
import * as Jn from "react";
import { styled as Df } from "@mui/material/styles";
import { IconButton as Mf, Tooltip as Vf } from "@mui/material";
import _f from "@mui/icons-material/Menu";
import { useTranslate as Hf } from "ra-core";
l();
import { useStore as Of } from "ra-core";
var ht = n(function () {
  return Of("sidebar.open", !0);
}, "useSidebarState");
var nc = n(function (e) {
  var t = Hf(),
      o = e.className,
      _ht = ht(),
      _ht2 = _slicedToArray(_ht, 2),
      r = _ht2[0],
      a = _ht2[1];

  return Jn.createElement(Vf, {
    className: o,
    title: t(r ? "ra.action.close_menu" : "ra.action.open_menu", {
      _: "Open/Close menu"
    }),
    enterDelay: 500
  }, Jn.createElement(zf, {
    color: "inherit",
    onClick: function onClick() {
      return a(!r);
    },
    size: "large"
  }, Jn.createElement(_f, {
    classes: {
      root: r ? Kn.menuButtonIconOpen : Kn.menuButtonIconClosed
    }
  })));
}, "SidebarToggleButton"),
    Ds = "RaSidebarToggleButton",
    Kn = {
  menuButtonIconClosed: "".concat(Ds, "-menuButtonIconClosed"),
  menuButtonIconOpen: "".concat(Ds, "-menuButtonIconOpen")
},
    zf = Df(Mf, {
  name: Ds,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref) {
  var _ref2;

  var e = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(Kn.menuButtonIconClosed), {
    transition: e.transitions.create(["transform"], {
      easing: e.transitions.easing.sharp,
      duration: e.transitions.duration.leavingScreen
    }),
    transform: "rotate(0deg)"
  }), _defineProperty(_ref2, "& .".concat(Kn.menuButtonIconOpen), {
    transition: e.transitions.create(["transform"], {
      easing: e.transitions.easing.sharp,
      duration: e.transitions.duration.leavingScreen
    }),
    transform: "rotate(180deg)"
  }), _ref2;
});
l();
import * as ia from "react";
import { styled as Jh } from "@mui/material/styles";
import yi from "prop-types";
import Kh from "clsx";
import { useTheme as Yh } from "@mui/material/styles";
import Zh from "@mui/material/CircularProgress";
import { useLoading as eR } from "ra-core";
l();
l();
import * as Ms from "react";
import { memo as Kf } from "react";
import Vs from "prop-types";
import Yf from "@mui/icons-material/Queue";
import { Link as Zf } from "react-router-dom";
import { stringify as eg } from "query-string";
import { useResourceContext as tg, useRecordContext as og, useCreatePath as rg } from "ra-core";
l();
import * as an from "react";
import kt from "prop-types";
import { Button as Wf, Tooltip as qf, IconButton as ac, useMediaQuery as jf } from "@mui/material";
import { styled as Uf } from "@mui/material/styles";
import { useTranslate as Xf } from "ra-core";
var U = n(function (e) {
  var T = e,
      _T$alignIcon = T.alignIcon,
      t = _T$alignIcon === void 0 ? "left" : _T$alignIcon,
      o = T.children,
      r = T.className,
      a = T.disabled,
      s = T.label,
      _T$color = T.color,
      p = _T$color === void 0 ? "primary" : _T$color,
      _T$size = T.size,
      c = _T$size === void 0 ? "small" : _T$size,
      d = T.to,
      m = f(T, ["alignIcon", "children", "className", "disabled", "label", "color", "size", "to"]),
      u = Xf(),
      g = s ? u(s, {
    _: s
  }) : void 0,
      y = Jf(d),
      b = jf(function (x) {
    return x.breakpoints.down("sm");
  }),
      P = sn(m);
  return b ? s && !a ? an.createElement(qf, {
    title: g
  }, an.createElement(ac, E(i(i({
    "aria-label": g,
    className: r,
    color: p
  }, P), y), {
    size: "large"
  }), o)) : an.createElement(ac, E(i(i({
    className: r,
    color: p,
    disabled: a
  }, P), y), {
    size: "large"
  }), o) : an.createElement(Gf, i(i({
    className: r,
    color: p,
    size: c,
    "aria-label": g,
    disabled: a,
    startIcon: t === "left" && o ? o : void 0,
    endIcon: t === "right" && o ? o : void 0
  }, P), y), g);
}, "Button"),
    sn = n(function (d) {
  var m = d,
      e = m.invalid,
      t = m.pristine,
      o = m.record,
      r = m.redirect,
      a = m.resource,
      s = m.mutationMode,
      p = m.hasCreate,
      c = f(m, ["invalid", "pristine", "record", "redirect", "resource", "mutationMode", "hasCreate"]);
  return c;
}, "sanitizeButtonRestProps");
U.propTypes = {
  alignIcon: kt.oneOf(["left", "right"]),
  children: kt.element,
  className: kt.string,
  color: kt.oneOfType([kt.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), kt.string]),
  disabled: kt.bool,
  label: kt.string,
  size: kt.oneOf(["small", "medium", "large"])
};
var Qf = "RaButton",
    Gf = Uf(Wf, {
  name: Qf,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  "&.MuiButton-sizeSmall": {
    lineHeight: 1.5
  }
}),
    Jf = n(function (e) {
  if (e == null) return;
  if (typeof e == "string") return {
    to: e
  };
  var s = e,
      t = s.redirect,
      o = s.replace,
      r = s.state;
  return {
    to: f(s, ["redirect", "replace", "state"]),
    redirect: t,
    replace: o,
    state: r
  };
}, "getLinkParams");
var sc = n(function (e) {
  var m = e,
      _m$label = m.label,
      t = _m$label === void 0 ? "ra.action.clone" : _m$label,
      _m$scrollToTop = m.scrollToTop,
      o = _m$scrollToTop === void 0 ? !0 : _m$scrollToTop,
      _m$icon = m.icon,
      r = _m$icon === void 0 ? ng : _m$icon,
      a = f(m, ["label", "scrollToTop", "icon"]),
      s = tg(e),
      p = og(e),
      d = rg()({
    resource: s,
    type: "create"
  });
  return Ms.createElement(U, i({
    component: Zf,
    to: p ? {
      pathname: d,
      search: eg({
        source: JSON.stringify(sg(p))
      }),
      state: {
        _scrollToTop: o
      }
    } : d,
    label: t,
    onClick: ag
  }, ig(a)), r);
}, "CloneButton"),
    ng = Ms.createElement(Yf, null),
    ag = n(function (e) {
  return e.stopPropagation();
}, "stopPropagation"),
    sg = n(function (o) {
  var r = o,
      e = r.id,
      t = f(r, ["id"]);
  return t;
}, "omitId"),
    ig = n(function (r) {
  var a = r,
      e = a.resource,
      t = a.record,
      o = f(a, ["resource", "record"]);
  return o;
}, "sanitizeRestProps");
sc.propTypes = {
  icon: Vs.element,
  label: Vs.string,
  record: Vs.any
};
var lg = Kf(sc);
l();
import * as Yn from "react";
import { styled as pg } from "@mui/material/styles";
import { memo as cg } from "react";
import Zn from "prop-types";
import { Fab as mg, useMediaQuery as dg } from "@mui/material";
import ug from "@mui/icons-material/Add";
import fg from "clsx";
import { Link as ic } from "react-router-dom";
import { useTranslate as gg, useResourceContext as yg, useCreatePath as bg } from "ra-core";
var lc = n(function (e) {
  var g = e,
      t = g.className,
      _g$icon = g.icon,
      o = _g$icon === void 0 ? hg : _g$icon,
      _g$label = g.label,
      r = _g$label === void 0 ? "ra.action.create" : _g$label,
      _g$scrollToTop = g.scrollToTop,
      a = _g$scrollToTop === void 0 ? !0 : _g$scrollToTop,
      s = g.variant,
      p = f(g, ["className", "icon", "label", "scrollToTop", "variant"]),
      c = yg(e),
      d = bg(),
      m = gg();
  return dg(function (y) {
    return y.breakpoints.down("md");
  }) ? Yn.createElement(Rg, i({
    component: ic,
    to: d({
      resource: c,
      type: "create"
    }),
    state: pc[String(a)],
    color: "primary",
    className: fg(_s.floating, t),
    "aria-label": r && m(r)
  }, sn(p)), o) : Yn.createElement(U, i({
    component: ic,
    to: d({
      resource: c,
      type: "create"
    }),
    state: pc[String(a)],
    className: t,
    label: r,
    variant: s
  }, p), o);
}, "CreateButton"),
    pc = {
  true: {
    _scrollToTop: !0
  },
  false: {}
},
    hg = Yn.createElement(ug, null);
lc.propTypes = {
  resource: Zn.string,
  className: Zn.string,
  icon: Zn.element,
  label: Zn.string
};
var cc = "RaCreateButton",
    _s = {
  floating: "".concat(cc, "-floating")
},
    Rg = pg(mg, {
  name: cc,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref3) {
  var e = _ref3.theme;
  return _defineProperty({}, "&.".concat(_s.floating), {
    color: e.palette.getContrastText(e.palette.primary.main),
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 60,
    left: "auto",
    position: "fixed",
    zIndex: 1e3
  });
}),
    ln = cg(lc, function (e, t) {
  return e.resource === t.resource && e.label === t.label && e.translate === t.translate && e.disabled === t.disabled;
});
l();
import * as Hs from "react";
import { memo as Tg } from "react";
import ea from "prop-types";
import Pg from "@mui/icons-material/RemoveRedEye";
import { Link as xg } from "react-router-dom";
import { useResourceContext as Cg, useRecordContext as vg, useCreatePath as Ig } from "ra-core";
var mc = n(function (e) {
  var d = e,
      _d$icon = d.icon,
      t = _d$icon === void 0 ? Sg : _d$icon,
      _d$label = d.label,
      o = _d$label === void 0 ? "ra.action.show" : _d$label,
      _d$scrollToTop = d.scrollToTop,
      r = _d$scrollToTop === void 0 ? !0 : _d$scrollToTop,
      a = f(d, ["icon", "label", "scrollToTop"]),
      s = Cg(e),
      p = vg(e),
      c = Ig();
  return p ? Hs.createElement(U, i({
    component: xg,
    to: c({
      type: "show",
      resource: s,
      id: p.id
    }),
    state: Fg[String(r)],
    label: o,
    onClick: Eg
  }, a), t) : null;
}, "ShowButton"),
    Fg = {
  true: {
    _scrollToTop: !0
  },
  false: {}
},
    Sg = Hs.createElement(Pg, null),
    Eg = n(function (e) {
  return e.stopPropagation();
}, "stopPropagation");
mc.propTypes = {
  icon: ea.element,
  label: ea.string,
  record: ea.any,
  scrollToTop: ea.bool
};
var Ng = Tg(mc, function (e, t) {
  return e.resource === t.resource && (e.record && t.record ? e.record.id === t.record.id : e.record == t.record) && e.label === t.label && e.disabled === t.disabled;
}),
    zs = Ng;
l();
import * as ze from "react";
import { memo as Bg } from "react";
import { Button as Lg, Menu as kg, MenuItem as wg, Tooltip as Ag, IconButton as $g, useMediaQuery as Og } from "@mui/material";
import { styled as Dg } from "@mui/material/styles";
import Mg from "@mui/icons-material/Sort";
import Vg from "@mui/icons-material/ArrowDropDown";
import { useListSortContext as _g, useTranslate as Hg, getFieldLabelTranslationArgs as dc, shallowEqual as zg } from "ra-core";
var Wg = n(function (e) {
  var t = e.fields,
      _e$label = e.label,
      o = _e$label === void 0 ? "ra.sort.sort_by" : _e$label,
      _e$icon = e.icon,
      r = _e$icon === void 0 ? qg : _e$icon,
      _g2 = _g(),
      a = _g2.resource,
      s = _g2.sort,
      p = _g2.setSort,
      c = Hg(),
      d = Og(function (T) {
    return T.breakpoints.down("sm");
  }),
      _ze$useState = ze.useState(null),
      _ze$useState2 = _slicedToArray(_ze$useState, 2),
      m = _ze$useState2[0],
      u = _ze$useState2[1],
      g = n(function (T) {
    u(T.currentTarget);
  }, "handleClick"),
      y = n(function () {
    u(null);
  }, "handleClose"),
      b = n(function (T) {
    var x = T.currentTarget.dataset.sort;
    p({
      field: x,
      order: x === s.field ? uc(s.order) : "ASC"
    }), u(null);
  }, "handleChangeSort"),
      P = c(o, {
    field: c.apply(void 0, _toConsumableArray(dc({
      resource: a,
      source: s.field
    }))),
    order: c("ra.sort.".concat(s.order)),
    _: o
  });

  return ze.createElement(ze.Fragment, null, d ? ze.createElement(Ag, {
    title: P
  }, ze.createElement($g, {
    "aria-label": P,
    color: "primary",
    onClick: g,
    size: "large"
  }, r)) : ze.createElement(Ug, {
    "aria-controls": "simple-menu",
    "aria-haspopup": "true",
    color: "primary",
    onClick: g,
    startIcon: r,
    endIcon: ze.createElement(Vg, null),
    size: "small"
  }, P), ze.createElement(kg, {
    id: "simple-menu",
    anchorEl: m,
    keepMounted: !0,
    open: Boolean(m),
    onClose: y
  }, t.map(function (T) {
    return ze.createElement(wg, {
      onClick: b,
      "data-sort": T,
      key: T
    }, c.apply(void 0, _toConsumableArray(dc({
      resource: a,
      source: T
    }))), " ", c("ra.sort.".concat(s.field === T ? uc(s.order) : "ASC")));
  })));
}, "SortButton"),
    qg = ze.createElement(Mg, null),
    uc = n(function (e) {
  return e === "ASC" ? "DESC" : "ASC";
}, "inverseOrder"),
    jg = n(function (e, t) {
  return zg(e.fields, t.fields);
}, "arePropsEqual"),
    Ug = Dg(Lg, {
  name: "RaSortButton",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  "&.MuiButton-sizeSmall": {
    lineHeight: 1.5
  },
  "& .MuiButton-endIcon": {
    ml: 0
  }
}),
    Xg = Bg(Wg, jg);
l();
import * as Us from "react";
import Zo from "prop-types";
l();
import * as pn from "react";
import { Fragment as Qg } from "react";
import Xt from "prop-types";
import Gg from "@mui/icons-material/Delete";
import fc from "inflection";
import { alpha as Jg, styled as Kg } from "@mui/material/styles";
import { useDeleteMany as Yg, useListContext as Zg, useNotify as ey, useRefresh as ty, useResourceContext as oy, useTranslate as ry, useUnselectAll as ny, useSafeSetState as ay } from "ra-core";
var Ws = n(function (e) {
  var F = e,
      _F$confirmTitle = F.confirmTitle,
      t = _F$confirmTitle === void 0 ? "ra.message.bulk_delete_title" : _F$confirmTitle,
      _F$confirmContent = F.confirmContent,
      o = _F$confirmContent === void 0 ? "ra.message.bulk_delete_content" : _F$confirmContent,
      _F$icon = F.icon,
      r = _F$icon === void 0 ? py : _F$icon,
      _F$label = F.label,
      a = _F$label === void 0 ? "ra.action.delete" : _F$label,
      _F$mutationMode = F.mutationMode,
      s = _F$mutationMode === void 0 ? "pessimistic" : _F$mutationMode,
      p = F.onClick,
      c = f(F, ["confirmTitle", "confirmContent", "icon", "label", "mutationMode", "onClick"]),
      _Zg = Zg(e),
      d = _Zg.selectedIds,
      _ay = ay(!1),
      _ay2 = _slicedToArray(_ay, 2),
      m = _ay2[0],
      u = _ay2[1],
      g = ey(),
      y = oy(e),
      b = ny(y),
      P = ty(),
      T = ry(),
      _Yg = Yg(y, {
    ids: d
  }, {
    onSuccess: function onSuccess() {
      P(), g("ra.notification.deleted", {
        type: "info",
        messageArgs: {
          smart_count: d.length
        }
      }), b(), u(!1);
    },
    onError: function onError(S) {
      g(typeof S == "string" ? S : S.message || "ra.notification.http_error", {
        type: "warning",
        messageArgs: {
          _: typeof S == "string" ? S : S && S.message ? S.message : void 0
        }
      }), u(!1);
    },
    mutationMode: s
  }),
      _Yg2 = _slicedToArray(_Yg, 2),
      x = _Yg2[0],
      C = _Yg2[1].isLoading,
      v = n(function (S) {
    u(!0), S.stopPropagation();
  }, "handleClick"),
      I = n(function () {
    u(!1);
  }, "handleDialogClose"),
      N = n(function (S) {
    x(), typeof p == "function" && p(S);
  }, "handleDelete");

  return pn.createElement(Qg, null, pn.createElement(ly, i({
    onClick: v,
    label: a
  }, sy(c)), r), pn.createElement(xo, {
    isOpen: m,
    loading: C,
    title: t,
    content: o,
    translateOptions: {
      smart_count: d.length,
      name: T("resources.".concat(y, ".forcedCaseName"), {
        smart_count: d.length,
        _: fc.humanize(T("resources.".concat(y, ".name"), {
          smart_count: d.length,
          _: fc.inflect(y, d.length)
        }), !0)
      })
    },
    onConfirm: N,
    onClose: I
  }));
}, "BulkDeleteWithConfirmButton"),
    sy = n(function (s) {
  var p = s,
      e = p.classes,
      t = p.filterValues,
      o = p.label,
      r = p.selectedIds,
      a = f(p, ["classes", "filterValues", "label", "selectedIds"]);
  return a;
}, "sanitizeRestProps"),
    iy = "RaBulkDeleteWithConfirmButton",
    ly = Kg(U, {
  name: iy,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref5) {
  var e = _ref5.theme;
  return {
    color: e.palette.error.main,
    "&:hover": {
      backgroundColor: Jg(e.palette.error.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  };
}),
    py = pn.createElement(Gg, null);
Ws.propTypes = {
  confirmTitle: Xt.string,
  confirmContent: Xt.string,
  icon: Xt.element,
  label: Xt.string,
  mutationMode: Xt.oneOf(["pessimistic", "optimistic", "undoable"]),
  resource: Xt.string,
  selectedIds: Xt.arrayOf(Xt.any)
};
l();
import * as qs from "react";
import { styled as cy } from "@mui/material/styles";
import cn from "prop-types";
import my from "@mui/icons-material/Delete";
import { alpha as dy } from "@mui/material/styles";
import { useDeleteMany as uy, useRefresh as fy, useNotify as gy, useUnselectAll as yy, useResourceContext as by, useListContext as hy } from "ra-core";
var js = n(function (e) {
  var b = e,
      _b$label = b.label,
      t = _b$label === void 0 ? "ra.action.delete" : _b$label,
      _b$icon = b.icon,
      o = _b$icon === void 0 ? Ry : _b$icon,
      r = b.onClick,
      a = f(b, ["label", "icon", "onClick"]),
      _hy = hy(e),
      s = _hy.selectedIds,
      p = gy(),
      c = by(e),
      d = yy(c),
      m = fy(),
      _uy = uy(),
      _uy2 = _slicedToArray(_uy, 2),
      u = _uy2[0],
      g = _uy2[1].isLoading;

  return qs.createElement(xy, i({
    onClick: n(function (P) {
      u(c, {
        ids: s
      }, {
        onSuccess: function onSuccess() {
          p("ra.notification.deleted", {
            type: "info",
            messageArgs: {
              smart_count: s.length
            },
            undoable: !0
          }), d();
        },
        onError: function onError(T) {
          p(typeof T == "string" ? T : T.message || "ra.notification.http_error", {
            type: "warning",
            messageArgs: {
              _: typeof T == "string" ? T : T && T.message ? T.message : void 0
            }
          }), m();
        },
        mutationMode: "undoable"
      }), typeof r == "function" && r(P);
    }, "handleClick"),
    label: t,
    disabled: g
  }, Ty(a)), o);
}, "BulkDeleteWithUndoButton"),
    Ry = qs.createElement(my, null),
    Ty = n(function (s) {
  var p = s,
      e = p.classes,
      t = p.filterValues,
      o = p.label,
      r = p.selectedIds,
      a = f(p, ["classes", "filterValues", "label", "selectedIds"]);
  return a;
}, "sanitizeRestProps"),
    Py = "RaBulkDeleteWithUndoButton",
    xy = cy(U, {
  name: Py,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref6) {
  var e = _ref6.theme;
  return {
    color: e.palette.error.main,
    "&:hover": {
      backgroundColor: dy(e.palette.error.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  };
});
js.propTypes = {
  label: cn.string,
  resource: cn.string,
  selectedIds: cn.arrayOf(cn.any),
  icon: cn.element
};
var Xs = n(function (o) {
  var r = o,
      _r$mutationMode = r.mutationMode,
      e = _r$mutationMode === void 0 ? "undoable" : _r$mutationMode,
      t = f(r, ["mutationMode"]);
  return e === "undoable" ? Us.createElement(js, i({}, t)) : Us.createElement(Ws, i({
    mutationMode: e
  }, t));
}, "BulkDeleteButton");
Xs.propTypes = {
  label: Zo.string,
  resource: Zo.string,
  selectedIds: Zo.arrayOf(Zo.any),
  mutationMode: Zo.oneOf(["pessimistic", "optimistic", "undoable"]),
  icon: Zo.element
};
l();
import * as Qs from "react";
import { useCallback as Cy } from "react";
import er from "prop-types";
import vy from "@mui/icons-material/GetApp";
import { fetchRelatedRecords as Iy, useDataProvider as Fy, useNotify as Sy, useListContext as Ey } from "ra-core";
var Ny = n(function (e) {
  var b = e,
      t = b.onClick,
      _b$label2 = b.label,
      o = _b$label2 === void 0 ? "ra.action.export" : _b$label2,
      _b$icon2 = b.icon,
      r = _b$icon2 === void 0 ? By : _b$icon2,
      a = b.exporter,
      s = f(b, ["onClick", "label", "icon", "exporter"]),
      _Ey = Ey(e),
      p = _Ey.exporter,
      c = _Ey.resource,
      d = _Ey.selectedIds,
      m = a || p,
      u = Fy(),
      g = Sy(),
      y = Cy(function (P) {
    m && u.getMany(c, {
      ids: d
    }).then(function (_ref7) {
      var T = _ref7.data;
      return m(T, Iy(u), u, c);
    }).catch(function (T) {
      console.error(T), g("ra.notification.http_error", {
        type: "warning"
      });
    }), typeof t == "function" && t(P);
  }, [u, m, g, t, c, d]);

  return Qs.createElement(U, i({
    onClick: y,
    label: o
  }, Ly(s)), r);
}, "BulkExportButton"),
    By = Qs.createElement(vy, null),
    Ly = n(function (a) {
  var s = a,
      e = s.filterValues,
      t = s.selectedIds,
      o = s.resource,
      r = f(s, ["filterValues", "selectedIds", "resource"]);
  return r;
}, "sanitizeRestProps");
Ny.propTypes = {
  exporter: er.func,
  label: er.string,
  resource: er.string,
  selectedIds: er.arrayOf(er.any),
  icon: er.element
};
l();
import * as Ys from "react";
import or from "prop-types";
l();
import * as mn from "react";
import { Fragment as ky, useState as wy } from "react";
import wt from "prop-types";
import Ay from "@mui/icons-material/Update";
import gc from "inflection";
import { alpha as $y, styled as Oy } from "@mui/material/styles";
import { useListContext as Dy, useTranslate as My, useUpdateMany as Vy, useRefresh as _y, useNotify as Hy, useUnselectAll as zy, useResourceContext as Wy } from "ra-core";
var Gs = n(function (e) {
  var t = Hy(),
      o = _y(),
      r = My(),
      a = Wy(e),
      s = zy(a),
      _wy = wy(!1),
      _wy2 = _slicedToArray(_wy, 2),
      p = _wy2[0],
      c = _wy2[1],
      _Dy = Dy(e),
      d = _Dy.selectedIds,
      k = e,
      _k$confirmTitle = k.confirmTitle,
      m = _k$confirmTitle === void 0 ? "ra.message.bulk_update_title" : _k$confirmTitle,
      _k$confirmContent = k.confirmContent,
      u = _k$confirmContent === void 0 ? "ra.message.bulk_update_content" : _k$confirmContent,
      g = k.data,
      _k$icon = k.icon,
      y = _k$icon === void 0 ? Xy : _k$icon,
      _k$label = k.label,
      b = _k$label === void 0 ? "ra.action.update" : _k$label,
      _k$mutationMode = k.mutationMode,
      P = _k$mutationMode === void 0 ? "pessimistic" : _k$mutationMode,
      T = k.onClick,
      _k$onSuccess = k.onSuccess,
      x = _k$onSuccess === void 0 ? n(function () {
    o(), t("ra.notification.updated", {
      type: "info",
      messageArgs: {
        smart_count: d.length
      }
    }), s(), c(!1);
  }, "onSuccess") : _k$onSuccess,
      _k$onError = k.onError,
      C = _k$onError === void 0 ? n(function (B) {
    t(typeof B == "string" ? B : B.message || "ra.notification.http_error", {
      type: "warning",
      messageArgs: {
        _: typeof B == "string" ? B : B && B.message ? B.message : void 0
      }
    }), c(!1);
  }, "onError") : _k$onError,
      v = f(k, ["confirmTitle", "confirmContent", "data", "icon", "label", "mutationMode", "onClick", "onSuccess", "onError"]),
      _Vy = Vy(a, {
    ids: d,
    data: g
  }, {
    onSuccess: x,
    onError: C,
    mutationMode: P
  }),
      _Vy2 = _slicedToArray(_Vy, 2),
      I = _Vy2[0],
      N = _Vy2[1].isLoading,
      F = n(function (B) {
    c(!0), B.stopPropagation();
  }, "handleClick"),
      S = n(function () {
    c(!1);
  }, "handleDialogClose"),
      L = n(function (B) {
    I(), typeof T == "function" && T(B);
  }, "handleUpdate");

  return mn.createElement(ky, null, mn.createElement(Uy, i({
    onClick: F,
    label: b
  }, qy(v)), y), mn.createElement(xo, {
    isOpen: p,
    loading: N,
    title: m,
    content: u,
    translateOptions: {
      smart_count: d.length,
      name: r("resources.".concat(a, ".forcedCaseName"), {
        smart_count: d.length,
        _: gc.humanize(r("resources.".concat(a, ".name"), {
          smart_count: d.length,
          _: gc.inflect(a, d.length)
        }), !0)
      })
    },
    onConfirm: L,
    onClose: S
  }));
}, "BulkUpdateWithConfirmButton"),
    qy = n(function (s) {
  var p = s,
      e = p.filterValues,
      t = p.label,
      o = p.onSuccess,
      r = p.onError,
      a = f(p, ["filterValues", "label", "onSuccess", "onError"]);
  return a;
}, "sanitizeRestProps");
Gs.propTypes = {
  confirmTitle: wt.string,
  confirmContent: wt.string,
  label: wt.string,
  resource: wt.string,
  selectedIds: wt.arrayOf(wt.any),
  icon: wt.element,
  data: wt.any.isRequired,
  mutationMode: wt.oneOf(["pessimistic", "optimistic", "undoable"])
};
var jy = "RaBulkUpdateWithConfirmButton",
    Uy = Oy(U, {
  name: jy,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref8) {
  var e = _ref8.theme;
  return {
    color: e.palette.primary.main,
    "&:hover": {
      backgroundColor: $y(e.palette.primary.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  };
}),
    Xy = mn.createElement(Ay, null);
l();
import * as Js from "react";
import { styled as Qy } from "@mui/material/styles";
import tr from "prop-types";
import Gy from "@mui/icons-material/Update";
import { alpha as Jy } from "@mui/material/styles";
import { useUpdateMany as Ky, useRefresh as Yy, useNotify as Zy, useUnselectAll as eb, useResourceContext as tb, useListContext as ob } from "ra-core";
var Ks = n(function (e) {
  var _ob = ob(e),
      t = _ob.selectedIds,
      o = Zy(),
      r = tb(e),
      a = eb(r),
      s = Yy(),
      x = e,
      p = x.data,
      _x$label = x.label,
      c = _x$label === void 0 ? "ra.action.update" : _x$label,
      _x$icon = x.icon,
      d = _x$icon === void 0 ? rb : _x$icon,
      m = x.onClick,
      _x$onSuccess = x.onSuccess,
      u = _x$onSuccess === void 0 ? n(function () {
    o("ra.notification.updated", {
      type: "info",
      messageArgs: {
        smart_count: t.length
      },
      undoable: !0
    }), a(), s();
  }, "onSuccess") : _x$onSuccess,
      _x$onError = x.onError,
      g = _x$onError === void 0 ? n(function (C) {
    o(typeof C == "string" ? C : C.message || "ra.notification.http_error", {
      type: "warning",
      messageArgs: {
        _: typeof C == "string" ? C : C && C.message ? C.message : void 0
      }
    }), s();
  }, "onError") : _x$onError,
      y = f(x, ["data", "label", "icon", "onClick", "onSuccess", "onError"]),
      _Ky = Ky(r, {
    ids: t,
    data: p
  }, {
    onSuccess: u,
    onError: g,
    mutationMode: "undoable"
  }),
      _Ky2 = _slicedToArray(_Ky, 2),
      b = _Ky2[0],
      P = _Ky2[1].isLoading;

  return Js.createElement(sb, i({
    onClick: n(function (C) {
      b(), typeof m == "function" && m(C);
    }, "handleClick"),
    label: c,
    disabled: P
  }, nb(y)), d);
}, "BulkUpdateWithUndoButton"),
    rb = Js.createElement(Gy, null),
    nb = n(function (p) {
  var c = p,
      e = c.filterValues,
      t = c.label,
      o = c.selectedIds,
      r = c.onSuccess,
      a = c.onError,
      s = f(c, ["filterValues", "label", "selectedIds", "onSuccess", "onError"]);
  return s;
}, "sanitizeRestProps");
Ks.propTypes = {
  label: tr.string,
  resource: tr.string,
  selectedIds: tr.arrayOf(tr.any),
  icon: tr.element,
  data: tr.any.isRequired
};
var ab = "RaBulkUpdateWithUndoButton",
    sb = Qy(U, {
  name: ab,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref9) {
  var e = _ref9.theme;
  return {
    color: e.palette.primary.main,
    "&:hover": {
      backgroundColor: Jy(e.palette.primary.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  };
});
var yc = n(function (e) {
  var r = e,
      t = r.mutationMode,
      o = f(r, ["mutationMode"]);
  return t === "undoable" ? Ys.createElement(Ks, i({}, o)) : Ys.createElement(Gs, i({
    mutationMode: t
  }, o));
}, "BulkUpdateButton");
yc.propTypes = {
  label: or.string,
  resource: or.string,
  selectedIds: or.arrayOf(or.any),
  mutationMode: or.oneOf(["pessimistic", "optimistic", "undoable"]),
  icon: or.element
};
yc.defaultProps = {
  mutationMode: "undoable",
  data: []
};
l();
import * as oi from "react";
import $t from "prop-types";
import { useRecordContext as Nb, useSaveContext as Bb } from "ra-core";
l();
import * as Zs from "react";
import { styled as ib } from "@mui/material/styles";
import At from "prop-types";
import { alpha as lb } from "@mui/material/styles";
import pb from "@mui/icons-material/Delete";
import cb from "clsx";
import { useDeleteWithUndoController as mb, useRecordContext as db, useResourceContext as ub } from "ra-core";
var ei = n(function (e) {
  var y = e,
      _y$label = y.label,
      t = _y$label === void 0 ? "ra.action.delete" : _y$label,
      o = y.className,
      _y$icon = y.icon,
      r = _y$icon === void 0 ? fb : _y$icon,
      a = y.onClick,
      _y$redirect = y.redirect,
      s = _y$redirect === void 0 ? "list" : _y$redirect,
      p = y.mutationOptions,
      c = f(y, ["label", "className", "icon", "onClick", "redirect", "mutationOptions"]),
      d = db(e),
      m = ub(e),
      _mb = mb({
    record: d,
    resource: m,
    redirect: s,
    onClick: a,
    mutationOptions: p
  }),
      u = _mb.isLoading,
      g = _mb.handleDelete;

  return Zs.createElement(yb, i({
    onClick: g,
    disabled: u,
    label: t,
    className: cb("ra-delete-button", o),
    key: "button"
  }, c), r);
}, "DeleteWithUndoButton"),
    fb = Zs.createElement(pb, null);
ei.propTypes = {
  className: At.string,
  label: At.string,
  record: At.any,
  redirect: At.oneOfType([At.string, At.bool, At.func]),
  resource: At.string,
  icon: At.element
};
var gb = "RaDeleteWithUndoButton",
    yb = ib(U, {
  name: gb,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref10) {
  var e = _ref10.theme;
  return {
    color: e.palette.error.main,
    "&:hover": {
      backgroundColor: lb(e.palette.error.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  };
});
l();
import ta, { Fragment as bb } from "react";
import { styled as hb } from "@mui/material/styles";
import We from "prop-types";
import { alpha as Rb } from "@mui/material/styles";
import Tb from "@mui/icons-material/Delete";
import Pb from "clsx";
import bc from "inflection";
import { useDeleteWithConfirmController as xb, useRecordContext as Cb, useResourceContext as vb, useTranslate as Ib } from "ra-core";
var ti = n(function (e) {
  var N = e,
      t = N.className,
      _N$confirmTitle = N.confirmTitle,
      o = _N$confirmTitle === void 0 ? "ra.message.delete_title" : _N$confirmTitle,
      _N$confirmContent = N.confirmContent,
      r = _N$confirmContent === void 0 ? "ra.message.delete_content" : _N$confirmContent,
      _N$icon = N.icon,
      a = _N$icon === void 0 ? Fb : _N$icon,
      _N$label = N.label,
      s = _N$label === void 0 ? "ra.action.delete" : _N$label,
      _N$mutationMode = N.mutationMode,
      p = _N$mutationMode === void 0 ? "pessimistic" : _N$mutationMode,
      c = N.onClick,
      _N$redirect = N.redirect,
      d = _N$redirect === void 0 ? "list" : _N$redirect,
      _N$translateOptions = N.translateOptions,
      m = _N$translateOptions === void 0 ? {} : _N$translateOptions,
      u = N.mutationOptions,
      g = f(N, ["className", "confirmTitle", "confirmContent", "icon", "label", "mutationMode", "onClick", "redirect", "translateOptions", "mutationOptions"]),
      y = Ib(),
      b = Cb(e),
      P = vb(e),
      _xb = xb({
    record: b,
    redirect: d,
    mutationMode: p,
    onClick: c,
    mutationOptions: u,
    resource: P
  }),
      T = _xb.open,
      x = _xb.isLoading,
      C = _xb.handleDialogOpen,
      v = _xb.handleDialogClose,
      I = _xb.handleDelete;

  return ta.createElement(bb, null, ta.createElement(Eb, i({
    onClick: C,
    label: s,
    className: Pb("ra-delete-button", t),
    key: "button"
  }, g), a), ta.createElement(xo, {
    isOpen: T,
    loading: x,
    title: o,
    content: r,
    translateOptions: i({
      name: y("resources.".concat(P, ".forcedCaseName"), {
        smart_count: 1,
        _: bc.humanize(y("resources.".concat(P, ".name"), {
          smart_count: 1,
          _: bc.singularize(P)
        }), !0)
      }),
      id: b.id
    }, m),
    onConfirm: I,
    onClose: v
  }));
}, "DeleteWithConfirmButton"),
    Fb = ta.createElement(Tb, null);
ti.propTypes = {
  className: We.string,
  confirmTitle: We.string,
  confirmContent: We.string,
  label: We.string,
  mutationMode: We.oneOf(["pessimistic", "optimistic", "undoable"]),
  record: We.any,
  redirect: We.oneOfType([We.string, We.bool, We.func]),
  resource: We.string,
  icon: We.element,
  translateOptions: We.object
};
var Sb = "RaDeleteWithConfirmButton",
    Eb = hb(U, {
  name: Sb,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref11) {
  var e = _ref11.theme;
  return {
    color: e.palette.error.main,
    "&:hover": {
      backgroundColor: Rb(e.palette.error.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  };
});
var ri = n(function (e) {
  var p = e,
      t = p.mutationMode,
      o = f(p, ["mutationMode"]),
      r = Nb(e),
      a = Bb(e);
  if (!r || r.id == null) return null;
  var s = t || ((a == null ? void 0 : a.mutationMode) ? a.mutationMode : "undoable");
  return s === "undoable" ? oi.createElement(ei, i({
    record: r
  }, o)) : oi.createElement(ti, i({
    mutationMode: s,
    record: r
  }, o));
}, "DeleteButton");
ri.propTypes = {
  label: $t.string,
  mutationMode: $t.oneOf(["pessimistic", "optimistic", "undoable"]),
  record: $t.any,
  redirect: $t.oneOfType([$t.string, $t.bool, $t.func]),
  resource: $t.string,
  icon: $t.element
};
l();
import * as ni from "react";
import oa from "prop-types";
import Lb from "@mui/icons-material/Create";
import { Link as kb } from "react-router-dom";
import { useResourceContext as wb, useRecordContext as Ab, useCreatePath as $b } from "ra-core";
var ai = n(function (e) {
  var d = e,
      _d$icon2 = d.icon,
      t = _d$icon2 === void 0 ? Db : _d$icon2,
      _d$label2 = d.label,
      o = _d$label2 === void 0 ? "ra.action.edit" : _d$label2,
      _d$scrollToTop2 = d.scrollToTop,
      r = _d$scrollToTop2 === void 0 ? !0 : _d$scrollToTop2,
      a = f(d, ["icon", "label", "scrollToTop"]),
      s = wb(e),
      p = Ab(e),
      c = $b();
  return p ? ni.createElement(U, i({
    component: kb,
    to: c({
      type: "edit",
      resource: s,
      id: p.id
    }),
    state: Ob[String(r)],
    label: o,
    onClick: Mb
  }, a), t) : null;
}, "EditButton"),
    Ob = {
  true: {
    _scrollToTop: !0
  },
  false: {}
},
    Db = ni.createElement(Lb, null),
    Mb = n(function (e) {
  return e.stopPropagation();
}, "stopPropagation");
ai.propTypes = {
  icon: oa.element,
  label: oa.string,
  record: oa.any,
  scrollToTop: oa.bool
};
l();
import * as si from "react";
import { useCallback as Vb } from "react";
import Ot from "prop-types";
import _b from "@mui/icons-material/GetApp";
import { fetchRelatedRecords as Hb, useDataProvider as zb, useNotify as Wb, useListContext as qb, useResourceContext as jb } from "ra-core";
var ii = n(function (e) {
  var C = e,
      _C$maxResults = C.maxResults,
      t = _C$maxResults === void 0 ? 1e3 : _C$maxResults,
      o = C.onClick,
      _C$label = C.label,
      r = _C$label === void 0 ? "ra.action.export" : _C$label,
      _C$icon = C.icon,
      a = _C$icon === void 0 ? Ub : _C$icon,
      s = C.exporter,
      p = f(C, ["maxResults", "onClick", "label", "icon", "exporter"]),
      _qb = qb(e),
      c = _qb.filter,
      d = _qb.filterValues,
      m = _qb.sort,
      u = _qb.exporter,
      g = _qb.total,
      y = jb(e),
      b = s || u,
      P = zb(),
      T = Wb(),
      x = Vb(function (v) {
    P.getList(y, {
      sort: m,
      filter: c ? i(i({}, d), c) : d,
      pagination: {
        page: 1,
        perPage: t
      }
    }).then(function (_ref12) {
      var I = _ref12.data;
      return b && b(I, Hb(P), P, y);
    }).catch(function (I) {
      console.error(I), T("ra.notification.http_error", {
        type: "warning"
      });
    }), typeof o == "function" && o(v);
  }, [P, b, c, d, t, T, o, y, m]);

  return si.createElement(U, i({
    onClick: x,
    label: r,
    disabled: g === 0
  }, Xb(p)), a);
}, "ExportButton"),
    Ub = si.createElement(_b, null),
    Xb = n(function (r) {
  var a = r,
      e = a.filterValues,
      t = a.resource,
      o = f(a, ["filterValues", "resource"]);
  return o;
}, "sanitizeRestProps");
ii.propTypes = {
  exporter: Ot.func,
  filterValues: Ot.object,
  label: Ot.string,
  maxResults: Ot.number,
  resource: Ot.string,
  sort: Ot.exact({
    field: Ot.string,
    order: Ot.string
  }),
  icon: Ot.element
};
l();
import * as dn from "react";
import { IconButton as Qb, Tooltip as Gb } from "@mui/material";
import { useTranslate as Jb } from "ra-core";
var li = n(function (r) {
  var a = r,
      e = a.label,
      t = a.onClick,
      o = f(a, ["label", "onClick"]);

  var s = Jb(),
      _dn$useState = dn.useState(!1),
      _dn$useState2 = _slicedToArray(_dn$useState, 2),
      p = _dn$useState2[0],
      c = _dn$useState2[1],
      d = n(function () {
    c(!1);
  }, "handleClose"),
      m = n(function () {
    c(!0);
  }, "handleOpen"),
      u = s(e, {
    _: e
  });

  return dn.createElement(Gb, {
    title: u,
    open: p,
    onOpen: m,
    onClose: d
  }, dn.createElement(Qb, E(i({
    "aria-label": u,
    onClick: n(function (y) {
      d(), t(y);
    }, "handleClick")
  }, o), {
    size: "large"
  })));
}, "IconButtonWithTooltip");
l();
import * as Qt from "react";
import { useState as Kb } from "react";
import { useLocaleState as Yb } from "ra-core";
import { Box as Zb, Button as eh, Menu as th, MenuItem as oh, styled as rh } from "@mui/material";
import nh from "@mui/icons-material/Translate";
import ah from "@mui/icons-material/ExpandMore";
var z0 = n(function (_ref13) {
  var e = _ref13.languages;

  var _Kb = Kb(null),
      _Kb2 = _slicedToArray(_Kb, 2),
      t = _Kb2[0],
      o = _Kb2[1],
      _Yb = Yb(),
      _Yb2 = _slicedToArray(_Yb, 2),
      r = _Yb2[0],
      a = _Yb2[1],
      s = n(function (m) {
    var u = e.find(function (g) {
      return g.locale === m;
    });
    return u ? u.name : "";
  }, "getNameForLocale"),
      p = n(function (m) {
    return function () {
      a(m), o(null);
    };
  }, "changeLocale"),
      c = n(function (m) {
    o(m.currentTarget);
  }, "handleLanguageClick"),
      d = n(function () {
    o(null);
  }, "handleClose");

  return Qt.createElement(sh, null, Qt.createElement(eh, {
    color: "inherit",
    "aria-controls": "simple-menu",
    "aria-label": "",
    "aria-haspopup": "true",
    onClick: c
  }, Qt.createElement(nh, null), Qt.createElement("div", {
    className: Rc.selectedLanguage
  }, s(r)), Qt.createElement(ah, {
    fontSize: "small"
  })), Qt.createElement(th, {
    id: "simple-menu",
    anchorEl: t,
    keepMounted: !0,
    open: Boolean(t),
    onClose: d
  }, e.map(function (m) {
    return Qt.createElement(oh, {
      key: m.locale,
      onClick: p(m.locale)
    }, m.name);
  })));
}, "LocalesMenuButton"),
    hc = "RaLocalesMenuButton",
    Rc = {
  selectedLanguage: "".concat(hc, "-selectedLanguage")
},
    sh = rh(Zb, {
  name: hc,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref14) {
  var e = _ref14.theme;
  return _defineProperty({}, "& .".concat(Rc.selectedLanguage), {
    marginLeft: e.spacing(1)
  });
});
l();
import * as pi from "react";
import Tc from "prop-types";
import ih from "@mui/icons-material/List";
import { Link as lh } from "react-router-dom";
import { useResourceContext as ph, useCreatePath as ch } from "ra-core";
var ci = n(function (e) {
  var c = e,
      _c$icon = c.icon,
      t = _c$icon === void 0 ? dh : _c$icon,
      _c$label = c.label,
      o = _c$label === void 0 ? "ra.action.list" : _c$label,
      _c$scrollToTop = c.scrollToTop,
      r = _c$scrollToTop === void 0 ? !0 : _c$scrollToTop,
      a = f(c, ["icon", "label", "scrollToTop"]),
      s = ph(e),
      p = ch();
  return pi.createElement(U, i({
    component: lh,
    to: p({
      type: "list",
      resource: s
    }),
    state: mh[String(r)],
    label: o
  }, a), t);
}, "ListButton"),
    mh = {
  true: {
    _scrollToTop: !0
  },
  false: {}
},
    dh = pi.createElement(ih, null);
ci.propTypes = {
  icon: Tc.element,
  label: Tc.string
};
l();
import * as mi from "react";
import { useCallback as uh } from "react";
import di from "prop-types";
import fh from "@mui/icons-material/Refresh";
import { useRefresh as gh } from "ra-core";
var yh = n(function (e) {
  var c = e,
      _c$label2 = c.label,
      t = _c$label2 === void 0 ? "ra.action.refresh" : _c$label2,
      _c$icon2 = c.icon,
      o = _c$icon2 === void 0 ? bh : _c$icon2,
      r = c.onClick,
      a = f(c, ["label", "icon", "onClick"]),
      s = gh(),
      p = uh(function (d) {
    d.preventDefault(), s(), typeof r == "function" && r(d);
  }, [s, r]);
  return mi.createElement(U, i({
    label: t,
    onClick: p
  }, a), o);
}, "RefreshButton"),
    bh = mi.createElement(fh, null);
yh.propTypes = {
  label: di.string,
  icon: di.element,
  onClick: di.func
};
l();
import * as ra from "react";
import { useCallback as hh } from "react";
import ui from "prop-types";
import Rh from "@mui/material/Tooltip";
import Th from "@mui/material/IconButton";
import Ph from "@mui/icons-material/Refresh";
import { useRefresh as xh, useTranslate as Ch } from "ra-core";
var fi = n(function (e) {
  var m = e,
      _m$label2 = m.label,
      t = _m$label2 === void 0 ? "ra.action.refresh" : _m$label2,
      _m$icon2 = m.icon,
      o = _m$icon2 === void 0 ? vh : _m$icon2,
      r = m.onClick,
      a = m.className,
      s = f(m, ["label", "icon", "onClick", "className"]),
      p = xh(),
      c = Ch(),
      d = hh(function (u) {
    u.preventDefault(), p(), typeof r == "function" && r(u);
  }, [p, r]);
  return ra.createElement(Rh, {
    title: t && c(t, {
      _: t
    })
  }, ra.createElement(Th, E(i({
    "aria-label": t && c(t, {
      _: t
    }),
    className: a,
    color: "inherit",
    onClick: d
  }, s), {
    size: "large"
  }), o));
}, "RefreshIconButton"),
    vh = ra.createElement(Ph, null);
fi.propTypes = {
  className: ui.string,
  label: ui.string,
  icon: ui.element
};
l();
import * as na from "react";
import { useCallback as Pc } from "react";
import { styled as Ih } from "@mui/material/styles";
import Co from "prop-types";
import { Button as Fh, CircularProgress as Sh } from "@mui/material";
import Eh from "@mui/icons-material/Save";
import { useFormContext as Nh, useFormState as Bh } from "react-hook-form";
import { useSaveContext as Lh, useTranslate as kh, warning as wh, setSubmissionErrors as Ah } from "ra-core";
var gi = n(function (e) {
  var k = e,
      _k$color = k.color,
      t = _k$color === void 0 ? "primary" : _k$color,
      _k$icon2 = k.icon,
      o = _k$icon2 === void 0 ? $h : _k$icon2,
      r = k.invalid,
      _k$label2 = k.label,
      a = _k$label2 === void 0 ? "ra.action.save" : _k$label2,
      s = k.onClick,
      p = k.mutationOptions,
      c = k.saving,
      d = k.disabled,
      _k$type = k.type,
      m = _k$type === void 0 ? "submit" : _k$type,
      u = k.transform,
      _k$variant = k.variant,
      g = _k$variant === void 0 ? "contained" : _k$variant,
      _k$alwaysEnable = k.alwaysEnable,
      y = _k$alwaysEnable === void 0 ? !1 : _k$alwaysEnable,
      b = f(k, ["color", "icon", "invalid", "label", "onClick", "mutationOptions", "saving", "disabled", "type", "transform", "variant", "alwaysEnable"]),
      P = kh(),
      T = Nh(),
      x = Lh(),
      _Bh = Bh(),
      C = _Bh.isDirty,
      v = _Bh.isValidating,
      I = Mh(y === !1 || y === void 0 ? void 0 : !y, d || !C || v || (x == null ? void 0 : x.saving));

  wh(m === "submit" && (p && (p.onSuccess || p.onError) || u), 'Cannot use <SaveButton mutationOptions> props on a button of type "submit". To override the default mutation options on a particular save button, set the <SaveButton type="button"> prop, or set mutationOptions in the main view component (<Create> or <Edit>).');
  var N = Pc( /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(B) {
      var M;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = x == null ? void 0 : x.save;

              if (!_context.t0) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return x.save(B, E(i({}, p), {
                transform: u
              }));

            case 4:
              M = _context.sent;

            case 5:
              M != null && Ah(M, T.setError);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x2) {
      return _ref16.apply(this, arguments);
    };
  }(), [T.setError, x, p, u]),
      F = Pc( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(B) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              s && s(B);
              _context2.t0 = !B.defaultPrevented && m === "button";

              if (!_context2.t0) {
                _context2.next = 6;
                break;
              }

              B.stopPropagation();
              _context2.next = 6;
              return T.handleSubmit(N)(B);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3) {
      return _ref17.apply(this, arguments);
    };
  }(), [s, m, T, N]),
      S = a && P(a, {
    _: a
  }),
      L = typeof c != "undefined" ? c : x == null ? void 0 : x.saving;
  return na.createElement(Dh, i({
    variant: g,
    type: m,
    color: t,
    "aria-label": S,
    disabled: I,
    onClick: F
  }, sn(b)), L ? na.createElement(Sh, {
    size: 18,
    thickness: 2
  }) : o, S);
}, "SaveButton"),
    $h = na.createElement(Eh, null);
gi.propTypes = {
  className: Co.string,
  invalid: Co.bool,
  label: Co.string,
  saving: Co.bool,
  variant: Co.oneOf(["text", "outlined", "contained"]),
  icon: Co.element,
  alwaysEnable: Co.bool
};
var Oh = "RaSaveButton",
    Dh = Ih(Fh, {
  name: Oh,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref18) {
  var _ref19;

  var e = _ref18.theme;
  return _ref19 = {
    position: "relative"
  }, _defineProperty(_ref19, "& .MuiSvgIcon-root, & .MuiIcon-root, & .MuiCircularProgress-root", {
    marginRight: e.spacing(1)
  }), _defineProperty(_ref19, "& .MuiSvgIcon-root, & .MuiIcon-root", {
    fontSize: 18
  }), _ref19;
}),
    Mh = n(function (e, t) {
  return typeof e == "undefined" ? t : e;
}, "valueOrDefault");
l();
import Vh from "react";
import { styled as _h } from "@mui/material/styles";
import { useTranslate as Hh } from "ra-core";

var xc = n(function () {
  var e = Hh();
  return Vh.createElement(Wh, {
    onClick: qh,
    className: "skip-nav-button",
    label: e("ra.navigation.skip_nav"),
    variant: "contained"
  });
}, "SkipNavigationButton"),
    zh = "RaSkipNavigationButton",
    Wh = _h(U, {
  name: zh,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref20) {
  var e = _ref20.theme;
  return {
    position: "fixed",
    padding: e.spacing(1),
    backgroundColor: e.palette.background.default,
    color: e.palette.getContrastText(e.palette.background.default),
    transition: e.transitions.create(["top", "opacity"], {
      easing: e.transitions.easing.easeIn,
      duration: e.transitions.duration.leavingScreen
    }),
    left: e.spacing(2),
    top: e.spacing(-10),
    zIndex: 5e3,
    "&:hover": {
      opacity: .8,
      backgroundColor: e.palette.background.default
    },
    "&:focus": {
      top: e.spacing(2),
      transition: e.transitions.create(["top", "opacity"], {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.enteringScreen
      })
    }
  };
}),
    qh = n(function () {
  if (typeof document == "undefined") return;
  var e = document.getElementById("main-content");

  if (!e) {
    process.env.NODE_ENV !== "production" && console.warn('No element with id "main-content" was found. Ensure the element that contains your main content has an id of "main-content".');
    return;
  }

  e.setAttribute("tabIndex", "-1"), e.focus(), e.blur(), e.removeAttribute("tabIndex");
}, "skipToContent");

l();
import aa from "react";
import { Tooltip as jh, IconButton as Uh } from "@mui/material";
import Xh from "@mui/icons-material/Brightness4";
import Qh from "@mui/icons-material/Brightness7";
import { useTranslate as Gh } from "ra-core";
var W_ = n(function (e) {
  var t = Gh(),
      o = e.darkTheme,
      r = e.lightTheme,
      _sa = sa(r),
      _sa2 = _slicedToArray(_sa, 2),
      a = _sa2[0],
      s = _sa2[1],
      p = n(function () {
    s((a == null ? void 0 : a.palette.mode) === "dark" ? r : o);
  }, "handleTogglePaletteType"),
      c = t("ra.action.toggle_theme", {
    _: "Toggle Theme"
  });

  return aa.createElement(jh, {
    title: c,
    enterDelay: 300
  }, aa.createElement(Uh, {
    color: "inherit",
    onClick: p,
    "aria-label": c
  }, (a == null ? void 0 : a.palette.mode) === "dark" ? aa.createElement(Qh, null) : aa.createElement(Xh, null)));
}, "ToggleThemeButton");
var bi = n(function (e) {
  var p = e,
      t = p.className,
      o = p.sx,
      r = f(p, ["className", "sx"]),
      a = eR(),
      s = Yh();
  return ia.createElement(tR, {
    className: t,
    sx: o
  }, a ? ia.createElement(Zh, i({
    className: Kh("app-loader", la.loader),
    color: "inherit",
    size: s.spacing(2),
    thickness: 6
  }, r)) : ia.createElement(fi, {
    className: la.loadedIcon
  }));
}, "LoadingIndicator");
bi.propTypes = {
  classes: yi.object,
  className: yi.string,
  width: yi.string
};
var hi = "RaLoadingIndicator",
    la = {
  loader: "".concat(hi, "-loader"),
  loadedIcon: "".concat(hi, "-loadedIcon")
},
    tR = Jh("div", {
  name: hi,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref21) {
  var _ref22;

  var e = _ref21.theme;
  return _ref22 = {}, _defineProperty(_ref22, "& .".concat(la.loader), {
    marginLeft: e.spacing(2),
    marginRight: e.spacing(2)
  }), _defineProperty(_ref22, "& .".concat(la.loadedIcon), {}), _ref22;
});
l();
import * as lt from "react";
import { useCallback as fR, useMemo as gR, useState as yR } from "react";
import { styled as bR } from "@mui/material/styles";
import ca from "prop-types";
import { useAuthProvider as hR, useGetIdentity as RR, useTranslate as TR } from "ra-core";
import { Tooltip as PR, IconButton as xR, Menu as CR, Button as vR, Avatar as Sc, useMediaQuery as IR } from "@mui/material";
import FR from "@mui/icons-material/AccountCircle";
l();
import * as Cc from "react";
l();
import { createContext as oR } from "react";
var pa = oR(void 0);
var vc = n(function (_ref23) {
  var e = _ref23.children,
      t = _ref23.value;
  return Cc.createElement(pa.Provider, {
    value: t
  }, e);
}, "UserMenuContextProvider");
l();
import * as vo from "react";
import { styled as rR } from "@mui/material/styles";
import { useCallback as nR } from "react";
import Ri from "prop-types";
import { ListItemIcon as aR, ListItemText as sR, MenuItem as iR, useMediaQuery as lR } from "@mui/material";
import pR from "@mui/icons-material/PowerSettingsNew";
import cR from "clsx";
import { useTranslate as mR, useLogout as dR } from "ra-core";
var Ti = vo.forwardRef(n(function (t, o) {
  var g = t,
      r = g.className,
      a = g.redirectTo,
      s = g.icon,
      p = f(g, ["className", "redirectTo", "icon"]),
      c = lR(function (y) {
    return y.breakpoints.down("sm");
  }),
      d = mR(),
      m = dR(),
      u = nR(function () {
    return m(null, a, !1);
  }, [a, m]);
  return vo.createElement(uR, i({
    className: cR("logout", r),
    onClick: u,
    ref: o,
    component: c ? "span" : "li"
  }, p), vo.createElement(aR, {
    className: Fc.icon
  }, s || vo.createElement(pR, null)), vo.createElement(sR, null, d("ra.auth.logout")));
}, "Logout"));
Ti.propTypes = {
  className: Ri.string,
  redirectTo: Ri.string,
  icon: Ri.element
};
var Ic = "RaLogout",
    Fc = {
  icon: "".concat(Ic, "-icon")
},
    uR = rR(iR, {
  name: Ic,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref24) {
  var e = _ref24.theme;
  return _defineProperty({
    color: e.palette.text.secondary
  }, "& .".concat(Fc.icon), {
    minWidth: e.spacing(5)
  });
});
var ma = n(function (e) {
  var _yR = yR(null),
      _yR2 = _slicedToArray(_yR, 2),
      t = _yR2[0],
      o = _yR2[1],
      r = TR(),
      _RR = RR(),
      a = _RR.isLoading,
      s = _RR.identity,
      p = hR(),
      c = IR(function (x) {
    return x.breakpoints.up("sm");
  }),
      _e$children = e.children,
      d = _e$children === void 0 ? p ? lt.createElement(Ti, null) : null : _e$children,
      m = e.className,
      _e$label2 = e.label,
      u = _e$label2 === void 0 ? "ra.auth.user_menu" : _e$label2,
      _e$icon2 = e.icon,
      g = _e$icon2 === void 0 ? ER : _e$icon2,
      y = n(function (x) {
    return o(x.currentTarget);
  }, "handleMenu"),
      b = fR(function () {
    return o(null);
  }, []),
      P = gR(function () {
    return {
      onClose: b
    };
  }, [b]);

  if (!d) return null;
  var T = Boolean(t);
  return lt.createElement(SR, {
    className: m
  }, c && !a && (s == null ? void 0 : s.fullName) ? lt.createElement(vR, {
    "aria-label": u && r(u, {
      _: u
    }),
    className: un.userButton,
    color: "inherit",
    startIcon: s.avatar ? lt.createElement(Sc, {
      className: un.avatar,
      src: s.avatar,
      alt: s.fullName
    }) : g,
    onClick: y
  }, s.fullName) : lt.createElement(PR, {
    title: u && r(u, {
      _: u
    })
  }, lt.createElement(xR, {
    "aria-label": u && r(u, {
      _: u
    }),
    "aria-owns": T ? "menu-appbar" : null,
    "aria-haspopup": !0,
    color: "inherit",
    onClick: y,
    size: "large"
  }, !a && (s == null ? void 0 : s.avatar) ? lt.createElement(Sc, {
    className: un.avatar,
    src: s.avatar,
    alt: s.fullName
  }) : g)), lt.createElement(vc, {
    value: P
  }, lt.createElement(CR, {
    id: "menu-appbar",
    disableScrollLock: !0,
    anchorEl: t,
    anchorOrigin: NR,
    transformOrigin: BR,
    open: T,
    onClose: b
  }, d)));
}, "UserMenu");
ma.propTypes = {
  children: ca.node,
  classes: ca.object,
  label: ca.string,
  icon: ca.node
};
var Pi = "RaUserMenu",
    un = {
  userButton: "".concat(Pi, "-userButton"),
  avatar: "".concat(Pi, "-avatar")
},
    SR = bR("div", {
  name: Pi,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref26) {
  var _ref27;

  var e = _ref26.theme;
  return _ref27 = {}, _defineProperty(_ref27, "& .".concat(un.userButton), {
    textTransform: "none"
  }), _defineProperty(_ref27, "& .".concat(un.avatar), {
    width: e.spacing(4),
    height: e.spacing(4)
  }), _ref27;
}),
    ER = lt.createElement(FR, null),
    NR = {
  vertical: "bottom",
  horizontal: "right"
},
    BR = {
  vertical: "top",
  horizontal: "right"
};
l();
import * as Ec from "react";
import LR from "prop-types";
import kR from "@mui/material/useScrollTrigger";
import wR from "@mui/material/Slide";
var xi = n(function (e) {
  var t = e.children,
      o = kR();
  return Ec.createElement(wR, {
    appear: !1,
    direction: "down",
    in: !o
  }, t);
}, "HideOnScroll");
xi.propTypes = {
  children: LR.node.isRequired
};
var Ci = OR(function (e) {
  var u = e,
      t = u.children,
      o = u.className,
      _u$color = u.color,
      r = _u$color === void 0 ? "secondary" : _u$color,
      a = u.open,
      s = u.title,
      _u$userMenu = u.userMenu,
      p = _u$userMenu === void 0 ? zR : _u$userMenu,
      _u$container = u.container,
      c = _u$container === void 0 ? xi : _u$container,
      d = f(u, ["children", "className", "color", "open", "title", "userMenu", "container"]),
      m = _R(function (g) {
    return g.breakpoints.down("sm");
  });

  return Dt.createElement(c, {
    className: o
  }, Dt.createElement(WR, i({
    className: So.appBar,
    color: r
  }, d), Dt.createElement(MR, {
    disableGutters: !0,
    variant: m ? "regular" : "dense",
    className: So.toolbar
  }, Dt.createElement(nc, {
    className: So.menuButton
  }), $R.count(t) === 0 ? Dt.createElement(VR, {
    variant: "h6",
    color: "inherit",
    className: So.title,
    id: "react-admin-title"
  }) : t, Dt.createElement(bi, null), typeof p == "boolean" ? p === !0 ? Dt.createElement(ma, null) : null : p)));
});
Ci.propTypes = {
  children: Io.node,
  className: Io.string,
  color: Io.oneOf(["default", "inherit", "primary", "secondary", "transparent"]),
  container: HR,
  open: Io.bool,
  userMenu: Io.oneOfType([Io.element, Io.bool])
};
var zR = Dt.createElement(ma, null),
    Fo = "RaAppBar",
    So = {
  appBar: "".concat(Fo, "-appBar"),
  toolbar: "".concat(Fo, "-toolbar"),
  menuButton: "".concat(Fo, "-menuButton"),
  menuButtonIconClosed: "".concat(Fo, "-menuButtonIconClosed"),
  menuButtonIconOpen: "".concat(Fo, "-menuButtonIconOpen"),
  title: "".concat(Fo, "-title")
},
    WR = AR(DR, {
  name: Fo,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref28) {
  var _ref29;

  var e = _ref28.theme;
  return _ref29 = {}, _defineProperty(_ref29, "& .".concat(So.toolbar), {
    paddingRight: 24
  }), _defineProperty(_ref29, "& .".concat(So.menuButton), {
    marginLeft: "0.2em",
    marginRight: "0.2em"
  }), _defineProperty(_ref29, "& .".concat(So.title), {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }), _ref29;
});
l();
import * as Nc from "react";
import { styled as qR } from "@mui/material/styles";
import vi from "prop-types";
import jR from "@mui/material/CardContent";
var UR = n(function (e) {
  var t = e.className,
      o = e.children;
  return Nc.createElement(XR, {
    className: t
  }, o);
}, "CardContentInner");
UR.propTypes = {
  className: vi.string,
  classes: vi.object,
  children: vi.node
};
var Bc = "RaCardContentInner",
    xH = {
  root: "".concat(Bc, "-root")
},
    XR = qR(jR, {
  name: Bc,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref30) {
  var e = _ref30.theme;
  return {
    paddingTop: 0,
    paddingBottom: 0,
    "&:first-of-type": {
      paddingTop: 16
    },
    "&:last-child": _defineProperty({
      paddingBottom: 16
    }, e.breakpoints.only("xs"), {
      paddingBottom: 70
    })
  };
});
l();
import * as Rt from "react";
import { styled as QR } from "@mui/material/styles";
import { useCallback as Lc } from "react";
import qe from "prop-types";
import GR from "@mui/material/Dialog";
import JR from "@mui/material/DialogActions";
import KR from "@mui/material/DialogContent";
import YR from "@mui/material/DialogContentText";
import ZR from "@mui/material/DialogTitle";
import kc from "@mui/material/Button";
import { alpha as eT } from "@mui/material/styles";
import tT from "@mui/icons-material/CheckCircle";
import oT from "@mui/icons-material/ErrorOutline";
import rT from "clsx";
import { useTranslate as nT } from "ra-core";
var xo = n(function (e) {
  var _rT;

  var t = e.className,
      _e$isOpen = e.isOpen,
      o = _e$isOpen === void 0 ? !1 : _e$isOpen,
      r = e.loading,
      a = e.title,
      s = e.content,
      _e$cancel = e.cancel,
      p = _e$cancel === void 0 ? "ra.action.cancel" : _e$cancel,
      _e$confirm = e.confirm,
      c = _e$confirm === void 0 ? "ra.action.confirm" : _e$confirm,
      _e$confirmColor = e.confirmColor,
      d = _e$confirmColor === void 0 ? "primary" : _e$confirmColor,
      _e$ConfirmIcon = e.ConfirmIcon,
      m = _e$ConfirmIcon === void 0 ? tT : _e$ConfirmIcon,
      _e$CancelIcon = e.CancelIcon,
      u = _e$CancelIcon === void 0 ? oT : _e$CancelIcon,
      g = e.onClose,
      y = e.onConfirm,
      _e$translateOptions = e.translateOptions,
      b = _e$translateOptions === void 0 ? {} : _e$translateOptions,
      P = e.sx,
      T = nT(),
      x = Lc(function (v) {
    v.stopPropagation(), y(v);
  }, [y]),
      C = Lc(function (v) {
    v.stopPropagation();
  }, []);
  return Rt.createElement(aT, {
    className: t,
    open: o,
    onClose: g,
    onClick: C,
    "aria-labelledby": "alert-dialog-title",
    sx: P
  }, Rt.createElement(ZR, {
    id: "alert-dialog-title"
  }, T(a, i({
    _: a
  }, b))), Rt.createElement(KR, null, typeof s == "string" ? Rt.createElement(YR, null, T(s, i({
    _: s
  }, b))) : s), Rt.createElement(JR, null, Rt.createElement(kc, {
    disabled: r,
    onClick: g
  }, Rt.createElement(u, {
    className: Eo.iconPaddingStyle
  }), T(p, {
    _: p
  })), Rt.createElement(kc, {
    disabled: r,
    onClick: x,
    className: rT("ra-confirm", (_rT = {}, _defineProperty(_rT, Eo.confirmWarning, d === "warning"), _defineProperty(_rT, Eo.confirmPrimary, d === "primary"), _rT)),
    autoFocus: !0
  }, Rt.createElement(m, {
    className: Eo.iconPaddingStyle
  }), T(c, {
    _: c
  }))));
}, "Confirm");
xo.propTypes = {
  cancel: qe.string,
  className: qe.string,
  confirm: qe.string,
  confirmColor: qe.string,
  ConfirmIcon: qe.elementType,
  CancelIcon: qe.elementType,
  content: qe.node.isRequired,
  isOpen: qe.bool,
  loading: qe.bool,
  onClose: qe.func.isRequired,
  onConfirm: qe.func.isRequired,
  title: qe.string.isRequired,
  sx: qe.any
};
var da = "RaConfirm",
    Eo = {
  confirmPrimary: "".concat(da, "-confirmPrimary"),
  confirmWarning: "".concat(da, "-confirmWarning"),
  iconPaddingStyle: "".concat(da, "-iconPaddingStyle")
},
    aT = QR(GR, {
  name: da,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref31) {
  var _ref32;

  var e = _ref31.theme;
  return _ref32 = {}, _defineProperty(_ref32, "& .".concat(Eo.confirmPrimary), {
    color: e.palette.primary.main
  }), _defineProperty(_ref32, "& .".concat(Eo.confirmWarning), {
    color: e.palette.error.main,
    "&:hover": {
      backgroundColor: eT(e.palette.error.main, .12),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }
  }), _defineProperty(_ref32, "& .".concat(Eo.iconPaddingStyle), {
    paddingRight: "0.5em"
  }), _ref32;
});
l();
import * as Fi from "react";
import ga from "prop-types";
import RT from "@mui/icons-material/Dashboard";
import { useTranslate as TT, useBasename as PT } from "ra-core";
l();
import ua, { forwardRef as wc, useCallback as sT } from "react";
import { styled as iT } from "@mui/material/styles";
import Gt from "prop-types";
import lT from "clsx";
import { Link as pT, useMatch as cT } from "react-router-dom";
import { MenuItem as mT, ListItemIcon as dT, Tooltip as uT, useMediaQuery as fT } from "@mui/material";
import { useTranslate as gT, useBasename as yT } from "ra-core";
var fn = wc(function (e, t) {
  var v = e,
      o = v.className,
      r = v.primaryText,
      a = v.leftIcon,
      s = v.onClick,
      p = v.sidebarIsOpen,
      c = v.tooltipProps,
      d = f(v, ["className", "primaryText", "leftIcon", "onClick", "sidebarIsOpen", "tooltipProps"]),
      m = fT(function (I) {
    return I.breakpoints.down("md");
  }),
      u = gT(),
      g = yT(),
      _ht3 = ht(),
      _ht4 = _slicedToArray(_ht3, 2),
      y = _ht4[0],
      b = _ht4[1],
      P = sT(function (I) {
    m && b(!1), s && s(I);
  }, [b, m, s]),
      T = (typeof e.to == "string" ? e.to : e.to.pathname) || "",
      x = cT({
    path: T,
    end: T === "".concat(g, "/")
  }),
      C = n(function () {
    return ua.createElement(bT, E(i({
      className: lT(o, _defineProperty({}, fa.active, !!x)),
      component: hT,
      ref: t,
      tabIndex: 0
    }, d), {
      onClick: P
    }), a && ua.createElement(dT, {
      className: fa.icon
    }, a), typeof r == "string" ? u(r, {
      _: r
    }) : r);
  }, "renderMenuItem");

  return y ? C() : ua.createElement(uT, i({
    title: typeof r == "string" ? u(r, {
      _: r
    }) : r,
    placement: "right"
  }, c), C());
});
fn.propTypes = {
  className: Gt.string,
  leftIcon: Gt.element,
  onClick: Gt.func,
  primaryText: Gt.node,
  to: Gt.oneOfType([Gt.string, Gt.object]).isRequired,
  sidebarIsOpen: Gt.bool
};
var Ii = "RaMenuItemLink",
    fa = {
  active: "".concat(Ii, "-active"),
  icon: "".concat(Ii, "-icon")
},
    bT = iT(mT, {
  name: Ii,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref33) {
  var _ref34;

  var e = _ref33.theme;
  return _ref34 = {
    color: e.palette.text.secondary
  }, _defineProperty(_ref34, "&.".concat(fa.active), {
    color: e.palette.text.primary
  }), _defineProperty(_ref34, "& .".concat(fa.icon), {
    minWidth: e.spacing(5)
  }), _ref34;
}),
    hT = wc(function (e, t) {
  return ua.createElement(pT, i({
    ref: t
  }, e));
});
var Si = n(function (e) {
  var s = e,
      t = s.locale,
      o = f(s, ["locale"]),
      r = TT(),
      a = PT();
  return Fi.createElement(fn, i({
    to: "".concat(a, "/"),
    primaryText: r("ra.page.dashboard"),
    leftIcon: Fi.createElement(RT, null)
  }, o));
}, "DashboardMenuItem");
Si.propTypes = {
  locale: ga.string,
  onClick: ga.func,
  dense: ga.bool,
  sidebarIsOpen: ga.bool
};
l();

var _c = $f(Mc());

import * as Vc from "react";
import { createTheme as ET, ThemeProvider as NT } from "@mui/material/styles";
var pz = n(function (_ref35) {
  var _ref35$width = _ref35.width,
      e = _ref35$width === void 0 ? "md" : _ref35$width,
      t = _ref35.children;
  var o = ET(),
      r = n(function (a) {
    return {
      matches: _c.default.match(a, {
        width: o.breakpoints.values[e]
      })
    };
  }, "ssrMatchMedia");
  return Vc.createElement(NT, {
    theme: E(i({}, o), {
      components: {
        MuiUseMediaQuery: {
          defaultProps: {
            ssrMatchMedia: r,
            matchMedia: r
          }
        }
      }
    })
  }, t);
}, "DeviceTestWrapper");
l();
import * as K from "react";
import { Fragment as OT } from "react";
import { styled as DT } from "@mui/material/styles";
import Bi from "prop-types";
import { Button as MT, Accordion as VT, AccordionDetails as _T, AccordionSummary as HT, Typography as zc } from "@mui/material";
import zT from "@mui/icons-material/Report";
import WT from "@mui/icons-material/ExpandMore";
import qT from "@mui/icons-material/History";
import { useTranslate as jT } from "ra-core";
l();
import * as Ni from "react";
import { createPortal as BT } from "react-dom";
import rr from "prop-types";
import { useTranslate as LT, warning as kT } from "ra-core";
var je = n(function (e) {
  var d = e,
      t = d.className,
      o = d.defaultTitle,
      r = d.title,
      a = f(d, ["className", "defaultTitle", "title"]),
      s = LT(),
      p = typeof document != "undefined" ? document.getElementById("react-admin-title") : null;
  if (!p) return null;
  kT(!o && !r, "Missing title prop in <Title> element");
  var c = r ? typeof r == "string" ? Ni.createElement("span", i({
    className: t
  }, a), s(r, {
    _: r
  })) : r : Ni.createElement("span", i({
    className: t
  }, a), o);
  return BT(c, p);
}, "Title"),
    No = rr.oneOfType([rr.string, rr.element]);
je.propTypes = {
  defaultTitle: rr.string,
  className: rr.string,
  record: rr.any,
  title: No
};
l();
import { useEffect as wT, useRef as AT } from "react";
import { useLocation as $T } from "react-router";
var Hc = n(function (e) {
  var _$T = $T(),
      t = _$T.pathname,
      o = AT(t);

  wT(function () {
    t !== o.current && e();
  }, [t, e]);
}, "useResetErrorBoundaryOnLocationChange");
var Li = n(function (e) {
  var m = e,
      t = m.error,
      o = m.errorComponent,
      r = m.errorInfo,
      a = m.resetErrorBoundary,
      s = m.className,
      p = m.title,
      c = f(m, ["error", "errorComponent", "errorInfo", "resetErrorBoundary", "className", "title"]),
      d = jT();
  return Hc(a), o ? K.createElement(o, {
    error: t,
    errorInfo: r,
    title: p
  }) : K.createElement(OT, null, p && K.createElement(je, {
    title: p
  }), K.createElement(UT, i({
    className: s
  }, c), K.createElement("h1", {
    className: Me.title,
    role: "alert"
  }, K.createElement(zT, {
    className: Me.icon
  }), d("ra.page.error")), K.createElement("div", null, d("ra.message.error")), process.env.NODE_ENV !== "production" && K.createElement(K.Fragment, null, K.createElement(VT, {
    className: Me.panel
  }, K.createElement(HT, {
    expandIcon: K.createElement(WT, null),
    className: Me.panelSumary
  }, d(t.message, {
    _: t.message
  })), K.createElement(_T, {
    className: Me.panelDetails
  }, K.createElement("p", null, d(t.message, {
    _: t.message
  })), K.createElement("p", null, r == null ? void 0 : r.componentStack))), K.createElement("div", {
    className: Me.advice
  }, K.createElement(zc, {
    align: "center"
  }, "Need help with this error? Try the following:"), K.createElement(zc, {
    component: "div"
  }, K.createElement("ul", null, K.createElement("li", null, "Check the", " ", K.createElement("a", {
    href: "https://marmelab.com/react-admin/Readme.html"
  }, "react-admin documentation")), K.createElement("li", null, "Search on", " ", K.createElement("a", {
    href: "https://stackoverflow.com/questions/tagged/react-admin"
  }, "StackOverflow"), " ", "for community answers"), K.createElement("li", null, "Get help from the core team via", " ", K.createElement("a", {
    href: "https://marmelab.com/ra-enterprise/#fromsww"
  }, "react-admin Enterprise Edition")))))), K.createElement("div", {
    className: Me.toolbar
  }, K.createElement(MT, {
    variant: "contained",
    startIcon: K.createElement(qT, null),
    onClick: XT
  }, d("ra.action.back")))));
}, "Error");
Li.propTypes = {
  className: Bi.string,
  error: Bi.object.isRequired,
  errorInfo: Bi.object,
  title: No
};
var Mt = "RaError",
    Me = {
  container: "".concat(Mt, "-container"),
  title: "".concat(Mt, "-title"),
  icon: "".concat(Mt, "-icon"),
  panel: "".concat(Mt, "-panel"),
  panelSumary: "".concat(Mt, "-panelSumary"),
  panelDetails: "".concat(Mt, "-panelDetails"),
  toolbar: "".concat(Mt, "-toolbar"),
  advice: "".concat(Mt, "-advice")
},
    UT = DT("div", {
  name: Mt,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref36) {
  var _ref37;

  var e = _ref36.theme;
  return _ref37 = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, _defineProperty(_ref37, e.breakpoints.down("md"), {
    padding: "1em"
  }), _defineProperty(_ref37, "fontFamily", "Roboto, sans-serif"), _defineProperty(_ref37, "opacity", .5), _defineProperty(_ref37, "& .".concat(Me.title), {
    display: "flex",
    alignItems: "center"
  }), _defineProperty(_ref37, "& .".concat(Me.icon), {
    width: "2em",
    height: "2em",
    marginRight: "0.5em"
  }), _defineProperty(_ref37, "& .".concat(Me.panel), {
    marginTop: "1em",
    maxWidth: "60em"
  }), _defineProperty(_ref37, "& .".concat(Me.panelSumary), {
    userSelect: "all"
  }), _defineProperty(_ref37, "& .".concat(Me.panelDetails), {
    whiteSpace: "pre-wrap"
  }), _defineProperty(_ref37, "& .".concat(Me.toolbar), {
    marginTop: "2em"
  }), _defineProperty(_ref37, "& .".concat(Me.advice), {
    marginTop: "2em"
  }), _ref37;
});

function XT() {
  window.history.go(-1);
}

n(XT, "goBack");
l();
import Tt, { useState as sP } from "react";
import { ErrorBoundary as iP } from "react-error-boundary";
import lP from "clsx";
import { styled as pP } from "@mui/material/styles";
l();
import * as nr from "react";
import { styled as QT } from "@mui/material/styles";
import GT from "prop-types";
import { Drawer as JT, useMediaQuery as Wc } from "@mui/material";
import qc from "lodash/get";
import { useLocale as KT } from "ra-core";
var ki = n(function (e) {
  var u = e,
      t = u.children,
      o = u.closedSize,
      r = u.size,
      a = f(u, ["children", "closedSize", "size"]),
      s = Wc(function (g) {
    return g.breakpoints.down("sm");
  }),
      p = Wc(function (g) {
    return g.breakpoints.down("md");
  }),
      _ht5 = ht(),
      _ht6 = _slicedToArray(_ht5, 2),
      c = _ht6[0],
      d = _ht6[1];

  KT();
  var m = n(function () {
    return d(!c);
  }, "toggleSidebar");
  return s ? nr.createElement(wi, i({
    variant: "temporary",
    open: c,
    onClose: m,
    classes: Ce
  }, a), t) : p ? nr.createElement(wi, i({
    variant: "permanent",
    open: c,
    onClose: m,
    classes: Ce
  }, a), nr.createElement("div", {
    className: Ce.fixed
  }, t)) : nr.createElement(wi, i({
    variant: "permanent",
    open: c,
    onClose: m,
    classes: Ce
  }, a), nr.createElement("div", {
    className: Ce.fixed
  }, t));
}, "Sidebar");
ki.propTypes = {
  children: GT.node.isRequired
};
var Ue = "RaSidebar",
    Ce = {
  docked: "".concat(Ue, "-docked"),
  paper: "".concat(Ue, "-paper"),
  paperAnchorLeft: "".concat(Ue, "-paperAnchorLeft"),
  paperAnchorRight: "".concat(Ue, "-paperAnchorRight"),
  paperAnchorTop: "".concat(Ue, "-paperAnchorTop"),
  paperAnchorBottom: "".concat(Ue, "-paperAnchorBottom"),
  paperAnchorDockedLeft: "".concat(Ue, "-paperAnchorDockedLeft"),
  paperAnchorDockedTop: "".concat(Ue, "-paperAnchorDockedTop"),
  paperAnchorDockedRight: "".concat(Ue, "-paperAnchorDockedRight"),
  paperAnchorDockedBottom: "".concat(Ue, "-paperAnchorDockedBottom"),
  modal: "".concat(Ue, "-modal"),
  fixed: "".concat(Ue, "-fixed")
},
    wi = QT(JT, {
  name: Ue,
  slot: "Root",
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref38) {
  var _MuiPaperRoot, _ref39;

  var e = _ref38.open,
      t = _ref38.theme;
  return _ref39 = {
    height: "calc(100vh - 3em)"
  }, _defineProperty(_ref39, "& .".concat(Ce.docked), {}), _defineProperty(_ref39, "& .".concat(Ce.paper), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorLeft), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorRight), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorTop), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorBottom), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorDockedLeft), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorDockedTop), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorDockedRight), {}), _defineProperty(_ref39, "& .".concat(Ce.paperAnchorDockedBottom), {}), _defineProperty(_ref39, "& .".concat(Ce.modal), {}), _defineProperty(_ref39, "& .".concat(Ce.fixed), {
    position: "fixed",
    height: "calc(100vh - 3em)",
    overflowX: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  }), _defineProperty(_ref39, "& .MuiPaper-root", (_MuiPaperRoot = {
    position: "relative",
    width: e ? qc(t, "sidebar.width", Ai) : qc(t, "sidebar.closedWidth", $i),
    transition: t.transitions.create("width", {
      easing: t.transitions.easing.sharp,
      duration: t.transitions.duration.leavingScreen
    }),
    backgroundColor: "transparent",
    borderRight: "none"
  }, _defineProperty(_MuiPaperRoot, t.breakpoints.only("xs"), {
    marginTop: 0,
    height: "100vh",
    position: "inherit",
    backgroundColor: t.palette.background.default
  }), _defineProperty(_MuiPaperRoot, t.breakpoints.up("md"), {
    border: "none"
  }), _defineProperty(_MuiPaperRoot, "zIndex", "inherit"), _MuiPaperRoot)), _ref39;
}),
    Ai = 240,
    $i = 55;
l();
import * as Jt from "react";
import { createElement as YT } from "react";
import { styled as ZT } from "@mui/material/styles";
import Oi from "prop-types";
import jc from "lodash/get";
import eP from "@mui/icons-material/ViewList";
import tP from "clsx";
import { useResourceDefinitions as oP, useGetResourceLabel as rP, useCreatePath as nP } from "ra-core";
var Di = n(function (e) {
  var _tP;

  var t = oP(),
      o = rP(),
      r = nP(),
      u = e,
      a = u.hasDashboard,
      s = u.dense,
      _u$children = u.children,
      p = _u$children === void 0 ? Jt.createElement(Jt.Fragment, null, a && Jt.createElement(Si, {
    dense: s
  }), Object.keys(t).filter(function (g) {
    return t[g].hasList;
  }).map(function (g) {
    return Jt.createElement(fn, {
      key: g,
      to: r({
        resource: g,
        type: "list"
      }),
      state: {
        _scrollToTop: !0
      },
      primaryText: o(g, 2),
      leftIcon: t[g].icon ? YT(t[g].icon) : Jt.createElement(eP, null),
      dense: s
    });
  })) : _u$children,
      c = u.className,
      d = f(u, ["hasDashboard", "dense", "children", "className"]),
      _ht7 = ht(),
      _ht8 = _slicedToArray(_ht7, 1),
      m = _ht8[0];

  return Jt.createElement(aP, i({
    className: tP((_tP = {}, _defineProperty(_tP, ya.open, m), _defineProperty(_tP, ya.closed, !m), _tP), c)
  }, d), p);
}, "Menu");
Di.propTypes = {
  className: Oi.string,
  dense: Oi.bool,
  hasDashboard: Oi.bool
};
var Mi = "RaMenu",
    ya = {
  open: "".concat(Mi, "-open"),
  closed: "".concat(Mi, "-closed")
},
    aP = ZT("div", {
  name: Mi,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref40) {
  var _ref41;

  var e = _ref40.theme;
  return _ref41 = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginTop: "0.5em",
    marginBottom: "1em"
  }, _defineProperty(_ref41, e.breakpoints.only("xs"), {
    marginTop: 0
  }), _defineProperty(_ref41, "transition", e.transitions.create("width", {
    easing: e.transitions.easing.sharp,
    duration: e.transitions.duration.leavingScreen
  })), _defineProperty(_ref41, "&.".concat(ya.open), {
    width: jc(e, "sidebar.width", Ai)
  }), _defineProperty(_ref41, "&.".concat(ya.closed), {
    width: jc(e, "sidebar.closedWidth", $i)
  }), _ref41;
});
var Uc = n(function (e) {
  var P = e,
      _P$appBar = P.appBar,
      t = _P$appBar === void 0 ? Ci : _P$appBar,
      o = P.children,
      r = P.className,
      a = P.dashboard,
      s = P.error,
      _P$menu = P.menu,
      p = _P$menu === void 0 ? Di : _P$menu,
      _P$sidebar = P.sidebar,
      c = _P$sidebar === void 0 ? ki : _P$sidebar,
      d = P.title,
      m = f(P, ["appBar", "children", "className", "dashboard", "error", "menu", "sidebar", "title"]),
      _ht9 = ht(),
      _ht10 = _slicedToArray(_ht9, 1),
      u = _ht10[0],
      _sP = sP(null),
      _sP2 = _slicedToArray(_sP, 2),
      g = _sP2[0],
      y = _sP2[1],
      b = n(function (T, x) {
    y(x);
  }, "handleError");

  return Tt.createElement(cP, i({
    className: lP("layout", r)
  }, m), Tt.createElement(xc, null), Tt.createElement("div", {
    className: ar.appFrame
  }, Tt.createElement(t, {
    open: u,
    title: d
  }), Tt.createElement("main", {
    className: ar.contentWithSidebar
  }, Tt.createElement(c, null, Tt.createElement(p, {
    hasDashboard: !!a
  })), Tt.createElement("div", {
    id: "main-content",
    className: ar.content
  }, Tt.createElement(iP, {
    onError: b,
    fallbackRender: function fallbackRender(_ref42) {
      var T = _ref42.error,
          x = _ref42.resetErrorBoundary;
      return Tt.createElement(Li, {
        error: T,
        errorComponent: s,
        errorInfo: g,
        resetErrorBoundary: x,
        title: d
      });
    }
  }, o)))));
}, "Layout"),
    ba = "RaLayout",
    ar = {
  appFrame: "".concat(ba, "-appFrame"),
  contentWithSidebar: "".concat(ba, "-contentWithSidebar"),
  content: "".concat(ba, "-content")
},
    cP = pP("div", {
  name: ba,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref43) {
  var _$concat, _$concat2, _ref44;

  var e = _ref43.theme;
  return _ref44 = {
    display: "flex",
    flexDirection: "column",
    zIndex: 1,
    minHeight: "100vh",
    backgroundColor: e.palette.background.default,
    position: "relative",
    minWidth: "fit-content",
    width: "100%",
    color: e.palette.getContrastText(e.palette.background.default)
  }, _defineProperty(_ref44, "& .".concat(ar.appFrame), (_$concat = {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  }, _defineProperty(_$concat, e.breakpoints.up("xs"), {
    marginTop: e.spacing(6)
  }), _defineProperty(_$concat, e.breakpoints.down("sm"), {
    marginTop: e.spacing(7)
  }), _$concat)), _defineProperty(_ref44, "& .".concat(ar.contentWithSidebar), {
    display: "flex",
    flexGrow: 1
  }), _defineProperty(_ref44, "& .".concat(ar.content), (_$concat2 = {
    backgroundColor: e.palette.background.default,
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexBasis: 0
  }, _defineProperty(_$concat2, e.breakpoints.up("xs"), {
    paddingRight: e.spacing(2),
    paddingLeft: e.spacing(1)
  }), _defineProperty(_$concat2, e.breakpoints.down("md"), {
    padding: 0
  }), _$concat2)), _ref44;
});
l();
import * as Xc from "react";
import { styled as mP } from "@mui/material/styles";
import dP from "@mui/material/LinearProgress";
import Qc from "prop-types";
import { useTimeout as uP } from "ra-core";
var Be = n(function (o) {
  var r = o,
      _r$timeout = r.timeout,
      e = _r$timeout === void 0 ? 1e3 : _r$timeout,
      t = f(r, ["timeout"]);
  var c = t,
      a = c.className,
      s = f(c, ["className"]);
  return uP(e) ? Xc.createElement(gP, i({
    className: a
  }, s)) : null;
}, "LinearProgress");
Be.propTypes = {
  className: Qc.string,
  timeout: Qc.number
};
Be.displayName = "LinearProgress";
var fP = "RaLinearProgress",
    gP = mP(dP, {
  name: fP,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref45) {
  var e = _ref45.theme;
  return {
    margin: "".concat(e.spacing(1), " 0"),
    width: e.spacing(20)
  };
});
l();
import * as sr from "react";
import { styled as yP } from "@mui/material/styles";
import Vi from "prop-types";
import bP from "@mui/material/CircularProgress";
import { useTranslate as hP } from "ra-core";
var ha = n(function (e) {
  var t = e.className,
      _e$loadingPrimary = e.loadingPrimary,
      o = _e$loadingPrimary === void 0 ? "ra.page.loading" : _e$loadingPrimary,
      _e$loadingSecondary = e.loadingSecondary,
      r = _e$loadingSecondary === void 0 ? "ra.message.loading" : _e$loadingSecondary,
      a = hP();
  return sr.createElement(RP, {
    className: t
  }, sr.createElement("div", {
    className: Ta.message
  }, sr.createElement(bP, {
    className: Ta.icon,
    color: "primary"
  }), sr.createElement("h1", null, a(o)), sr.createElement("div", null, a(r), ".")));
}, "Loading");
ha.propTypes = {
  className: Vi.string,
  loadingPrimary: Vi.string,
  loadingSecondary: Vi.string
};
ha.defaultProps = {
  loadingPrimary: "ra.page.loading",
  loadingSecondary: "ra.message.loading"
};
var Ra = "RaLoading",
    Ta = {
  root: "".concat(Ra, "-root"),
  icon: "".concat(Ra, "-icon"),
  message: "".concat(Ra, "-message")
},
    RP = yP("div", {
  name: Ra,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref46) {
  var _ref47;

  var e = _ref46.theme;
  return _ref47 = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, _defineProperty(_ref47, e.breakpoints.up("md"), {
    height: "100%"
  }), _defineProperty(_ref47, e.breakpoints.down("xl"), {
    height: "100vh",
    marginTop: "-3em"
  }), _defineProperty(_ref47, "& .".concat(Ta.icon), {
    width: "9em",
    height: "9em"
  }), _defineProperty(_ref47, "& .".concat(Ta.message), {
    textAlign: "center",
    fontFamily: "Roboto, sans-serif",
    opacity: .5,
    margin: "0 1em"
  }), _ref47;
});
l();
import * as Gc from "react";
import Pa from "prop-types";

var _i = n(function (r) {
  var a = r,
      _a$loadingPrimary = a.loadingPrimary,
      e = _a$loadingPrimary === void 0 ? "ra.page.loading" : _a$loadingPrimary,
      _a$loadingSecondary = a.loadingSecondary,
      t = _a$loadingSecondary === void 0 ? "ra.message.loading" : _a$loadingSecondary,
      o = f(a, ["loadingPrimary", "loadingSecondary"]);
  return Gc.createElement(ha, i({
    loadingPrimary: e,
    loadingSecondary: t
  }, o));
}, "LoadingPage");

_i.propTypes = {
  theme: Pa.object,
  className: Pa.string,
  loadingPrimary: Pa.string,
  loadingSecondary: Pa.string
};
l();
import * as Pt from "react";
import { styled as TP } from "@mui/material/styles";
import Hi from "prop-types";
import PP from "@mui/material/Button";
import xP from "@mui/icons-material/HotTub";
import CP from "@mui/icons-material/History";
import { useAuthenticated as vP, useTranslate as IP } from "ra-core";
var zi = n(function (e) {
  var s = e,
      t = s.className,
      o = s.title,
      r = f(s, ["className", "title"]),
      a = IP();
  return vP(), Pt.createElement(SP, i({
    className: t
  }, FP(r)), Pt.createElement(je, {
    defaultTitle: o
  }), Pt.createElement("div", {
    className: ir.message
  }, Pt.createElement(xP, {
    className: ir.icon
  }), Pt.createElement("h1", null, a("ra.page.not_found")), Pt.createElement("div", null, a("ra.message.not_found"), ".")), Pt.createElement("div", {
    className: ir.toolbar
  }, Pt.createElement(PP, {
    variant: "contained",
    startIcon: Pt.createElement(CP, null),
    onClick: EP
  }, a("ra.action.back"))));
}, "NotFound"),
    FP = n(function (s) {
  var p = s,
      e = p.staticContext,
      t = p.history,
      o = p.location,
      r = p.match,
      a = f(p, ["staticContext", "history", "location", "match"]);
  return a;
}, "sanitizeRestProps");
zi.propTypes = {
  className: Hi.string,
  title: Hi.string,
  location: Hi.object
};
var xa = "RaNotFound",
    ir = {
  icon: "".concat(xa, "-icon"),
  message: "".concat(xa, "-message"),
  toolbar: "".concat(xa, "-toolbar")
},
    SP = TP("div", {
  name: xa,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref48) {
  var _ref49;

  var e = _ref48.theme;
  return _ref49 = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, _defineProperty(_ref49, e.breakpoints.up("md"), {
    height: "100%"
  }), _defineProperty(_ref49, e.breakpoints.down("md"), {
    height: "100vh",
    marginTop: "-3em"
  }), _defineProperty(_ref49, "& .".concat(ir.icon), {
    width: "9em",
    height: "9em"
  }), _defineProperty(_ref49, "& .".concat(ir.message), {
    textAlign: "center",
    fontFamily: "Roboto, sans-serif",
    opacity: .5,
    margin: "0 1em"
  }), _defineProperty(_ref49, "& .".concat(ir.toolbar), {
    textAlign: "center",
    marginTop: "2em"
  }), _ref49;
});

function EP() {
  window.history.go(-1);
}

n(EP, "goBack");
l();
import * as Kt from "react";
import { styled as NP } from "@mui/material/styles";
import { useState as BP, useEffect as LP, useCallback as Wi } from "react";
import qi from "prop-types";
import { Button as kP, Snackbar as wP } from "@mui/material";
import AP from "clsx";
import { useNotificationContext as $P, undoableEventEmitter as Jc, useTranslate as OP } from "ra-core";
var DP = {
  vertical: "bottom",
  horizontal: "center"
},
    ji = n(function (e) {
  var C = e,
      t = C.className,
      _C$type = C.type,
      o = _C$type === void 0 ? "info" : _C$type,
      _C$autoHideDuration = C.autoHideDuration,
      r = _C$autoHideDuration === void 0 ? 4e3 : _C$autoHideDuration,
      _C$multiLine = C.multiLine,
      a = _C$multiLine === void 0 ? !1 : _C$multiLine,
      _C$anchorOrigin = C.anchorOrigin,
      s = _C$anchorOrigin === void 0 ? DP : _C$anchorOrigin,
      p = f(C, ["className", "type", "autoHideDuration", "multiLine", "anchorOrigin"]),
      _$P = $P(),
      c = _$P.notifications,
      d = _$P.takeNotification,
      _BP = BP(!1),
      _BP2 = _slicedToArray(_BP, 2),
      m = _BP2[0],
      u = _BP2[1],
      _Kt$useState = Kt.useState(void 0),
      _Kt$useState2 = _slicedToArray(_Kt$useState, 2),
      g = _Kt$useState2[0],
      y = _Kt$useState2[1],
      b = OP();

  LP(function () {
    c.length && !g ? (y(d()), u(!0)) : c.length && g && m && u(!1);
  }, [c, g, m, d]);
  var P = Wi(function () {
    u(!1);
  }, [u]),
      T = Wi(function () {
    g && g.notificationOptions.undoable && Jc.emit("end", {
      isUndo: !1
    }), y(void 0);
  }, [g]),
      x = Wi(function () {
    Jc.emit("end", {
      isUndo: !0
    }), u(!1);
  }, []);
  return g ? Kt.createElement(MP, i({
    className: t,
    open: m,
    message: g.message && b(g.message, g.notificationOptions.messageArgs),
    autoHideDuration: g.notificationOptions.autoHideDuration || r,
    disableWindowBlurListener: g.notificationOptions.undoable,
    TransitionProps: {
      onExited: T
    },
    onClose: P,
    ContentProps: {
      className: AP(Yt[g.type || o], _defineProperty({}, Yt.multiLine, g.multiLine || a))
    },
    action: g.notificationOptions.undoable ? Kt.createElement(kP, {
      color: "primary",
      className: Yt.undo,
      size: "small",
      onClick: x
    }, Kt.createElement(Kt.Fragment, null, b("ra.action.undo"))) : null,
    anchorOrigin: s
  }, p)) : null;
}, "Notification");
ji.propTypes = {
  type: qi.string,
  autoHideDuration: qi.number,
  multiLine: qi.bool
};
var lr = "RaNotification",
    Yt = {
  success: "".concat(lr, "-success"),
  error: "".concat(lr, "-error"),
  warning: "".concat(lr, "-warning"),
  undo: "".concat(lr, "-undo"),
  multiLine: "".concat(lr, "-multiLine")
},
    MP = NP(wP, {
  name: lr,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref50) {
  var _ref51;

  var e = _ref50.theme,
      t = _ref50.type;
  return _ref51 = {}, _defineProperty(_ref51, "& .".concat(Yt.success), {
    backgroundColor: e.palette.success.main,
    color: e.palette.success.contrastText
  }), _defineProperty(_ref51, "& .".concat(Yt.error), {
    backgroundColor: e.palette.error.dark,
    color: e.palette.error.contrastText
  }), _defineProperty(_ref51, "& .".concat(Yt.warning), {
    backgroundColor: e.palette.error.light,
    color: e.palette.error.contrastText
  }), _defineProperty(_ref51, "& .".concat(Yt.undo), {
    color: t === "success" ? e.palette.success.contrastText : e.palette.primary.light
  }), _defineProperty(_ref51, "& .".concat(Yt.multiLine), {
    whiteSpace: "pre-wrap"
  }), _ref51;
});
l();
import { useStore as VP } from "ra-core";
var sa = n(function (e) {
  return VP("theme", e);
}, "useTheme");
l();
import * as Kc from "react";
import { useMemo as _P } from "react";
import { ThemeProvider as HP, createTheme as Yc } from "@mui/material/styles";
var Zc = n(function (_ref52) {
  var e = _ref52.children,
      t = _ref52.theme;

  var _sa3 = sa(t),
      _sa4 = _slicedToArray(_sa3, 1),
      o = _sa4[0],
      r = _P(function () {
    try {
      return Yc(o);
    } catch (a) {
      return console.warn("Failed to reuse custom theme from store", a), Yc();
    }
  }, [o]);

  return Kc.createElement(HP, {
    theme: r
  }, e);
}, "ThemeProvider");
l();
import * as em from "react";
import { styled as zP } from "@mui/material/styles";
import tm from "prop-types";
import WP from "@mui/material/Toolbar";
var om = n(function (e) {
  return em.createElement(jP, i({}, e));
}, "TopToolbar");
om.propTypes = {
  children: tm.node,
  className: tm.string
};
var xt = om,
    qP = "RaTopToolbar",
    jP = zP(WP, {
  name: qP,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref53) {
  var _ref54;

  var e = _ref53.theme;
  return _ref54 = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingBottom: e.spacing(1),
    gap: e.spacing(1)
  }, _defineProperty(_ref54, e.breakpoints.up("sm"), {
    minHeight: e.spacing(6)
  }), _defineProperty(_ref54, e.breakpoints.up("xs"), {
    paddingLeft: 0,
    paddingRight: 0
  }), _defineProperty(_ref54, e.breakpoints.down("md"), {
    paddingRight: e.spacing(2)
  }), _defineProperty(_ref54, e.breakpoints.down("sm"), {
    padding: e.spacing(1),
    backgroundColor: e.palette.background.paper
  }), _ref54;
});
l();
import { useContext as UP } from "react";
var dq = n(function () {
  return UP(pa);
}, "useUserMenu");
l();
import * as pr from "react";
import { isValidElement as XP } from "react";
import { useTranslate as QP, ValidationError as GP } from "ra-core";
var Z = n(function (e) {
  var t = e.helperText,
      o = e.touched,
      r = e.error,
      a = QP();
  return o && r ? pr.createElement(GP, {
    error: r
  }) : XP(t) ? t : typeof t == "string" ? pr.createElement(pr.Fragment, null, a(t, {
    _: t
  })) : t !== !1 ? pr.createElement("span", {
    dangerouslySetInnerHTML: JP
  }) : null;
}, "InputHelperText"),
    JP = {
  __html: "&#8203;"
};
l();
var ne = n(function (st) {
  var De = st,
      e = De.afterSubmit,
      t = De.allowNull,
      o = De.alwaysOn,
      r = De.beforeSubmit,
      a = De.component,
      s = De.data,
      p = De.defaultValue,
      c = De.error,
      d = De.format,
      m = De.formatOnBlur,
      u = De.formClassName,
      g = De.initialValue,
      y = De.initializeForm,
      b = De.input,
      P = De.isEqual,
      T = De.isRequired,
      x = De.label,
      C = De.limitChoicesToValue,
      v = De.locale,
      I = De.meta,
      N = De.multiple,
      F = De.name,
      S = De.options,
      L = De.optionText,
      k = De.optionValue,
      B = De.parse,
      M = De.record,
      z = De.ref,
      A = De.refetch,
      W = De.render,
      D = De.resource,
      V = De.setFilter,
      _ = De.setPagination,
      w = De.setSort,
      O = De.source,
      te = De.submitError,
      oe = De.subscription,
      ce = De.textAlign,
      re = De.translate,
      le = De.translateChoice,
      He = De.validate,
      Q = De.validateFields,
      we = De.value,
      ae = f(De, ["afterSubmit", "allowNull", "alwaysOn", "beforeSubmit", "component", "data", "defaultValue", "error", "format", "formatOnBlur", "formClassName", "initialValue", "initializeForm", "input", "isEqual", "isRequired", "label", "limitChoicesToValue", "locale", "meta", "multiple", "name", "options", "optionText", "optionValue", "parse", "record", "ref", "refetch", "render", "resource", "setFilter", "setPagination", "setSort", "source", "submitError", "subscription", "textAlign", "translate", "translateChoice", "validate", "validateFields", "value"]);
  return ae;
}, "sanitizeInputRestProps");
l();
import * as gn from "react";
import { Stack as KP, Typography as YP } from "@mui/material";
import { styled as ZP } from "@mui/material/styles";
import ex from "clsx";
import { FieldTitle as tx } from "ra-core";
var fe = n(function (u) {
  var g = u,
      e = g.children,
      _g$className = g.className,
      t = _g$className === void 0 ? "" : _g$className,
      _g$color = g.color,
      o = _g$color === void 0 ? "textSecondary" : _g$color,
      _g$component = g.component,
      r = _g$component === void 0 ? "span" : _g$component,
      a = g.fullWidth,
      s = g.isRequired,
      p = g.label,
      c = g.resource,
      d = g.source,
      m = f(g, ["children", "className", "color", "component", "fullWidth", "isRequired", "label", "resource", "source"]);
  var y, b;
  return p !== !1 && e.props.label !== !1 && typeof e.type != "string" && ((y = e.type) == null ? void 0 : y.displayName) !== "Labeled" && ((b = e.type) == null ? void 0 : b.displayName) !== "Labeled" ? gn.createElement(ox, i({
    component: r,
    className: ex(t, _defineProperty({}, Ca.fullWidth, a))
  }, m), gn.createElement(YP, {
    color: o,
    className: Ca.label
  }, gn.createElement(tx, {
    label: p || e.props.label,
    source: d || e.props.source,
    resource: c,
    isRequired: s
  })), e) : gn.createElement("div", {
    className: t
  }, e);
}, "Labeled");
fe.displayName = "Labeled";
var Ui = "RaLabeled",
    Ca = {
  label: "".concat(Ui, "-label"),
  fullWidth: "".concat(Ui, "-fullWidth")
},
    ox = ZP(KP, {
  name: Ui,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref55) {
  var _ref56;

  var e = _ref55.theme;
  return _ref56 = {
    display: "inline-flex",
    marginBottom: "0.2em"
  }, _defineProperty(_ref56, "&.".concat(Ca.fullWidth), {
    width: "100%"
  }), _defineProperty(_ref56, "& .".concat(Ca.label), {
    fontSize: "0.75em",
    marginBottom: "0.2em"
  }), _ref56;
});
l();
import { createContext as rx } from "react";
var va = rx(void 0);
var Xi = n(function (e) {
  var _ = e,
      t = _.className,
      o = _.defaultValue,
      r = _.label,
      a = _.isFetching,
      s = _.isLoading,
      p = _.children,
      c = _.helperText,
      d = _.record,
      m = _.source,
      u = _.validate,
      g = _.variant,
      y = _.disabled,
      _$margin = _.margin,
      b = _$margin === void 0 ? "dense" : _$margin,
      P = f(_, ["className", "defaultValue", "label", "isFetching", "isLoading", "children", "helperText", "record", "source", "validate", "variant", "disabled", "margin"]),
      T = Array.isArray(u) ? cx(u) : u,
      x = dx(),
      C = ux(e),
      v = fx({
    name: m
  }),
      _gx = gx(),
      I = _gx.getFieldState,
      N = _gx.clearErrors,
      F = _gx.formState,
      S = _gx.getValues,
      L = _gx.register,
      k = _gx.setError,
      B = _gx.unregister,
      M = F.isSubmitted;

  rm(function () {
    return L(m), function () {
      B(m, {
        keepValue: !0
      });
    };
  }, [L, B, m]), mx(e);

  var z = yx({
    name: m
  }),
      _I2 = I(m, F),
      A = _I2.isDirty,
      W = _I2.invalid,
      D = _I2.error,
      V = sx(null);

  return rm(function () {
    T && n( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var O;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return T(z, S(), e);

            case 2:
              O = _context3.sent;
              O && !Tx(V.current, O) && (V.current = O, k(m, {
                type: "manual",
                message: x(O)
              })), !O && D && (V.current = null, N(m));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })), "applyValidation")();
  }, [N, D, T, z, S, e, k, m, x]), s ? Vt.createElement(fe, {
    label: r,
    className: t
  }, Vt.createElement(Be, null)) : Vt.createElement(hx, i({
    fullWidth: !0,
    margin: "normal",
    className: ix("ra-input", "ra-input-".concat(m), t),
    error: (A || M) && W
  }, ne(P)), Vt.createElement(bx, {
    htmlFor: m,
    shrink: !0,
    error: (A || M) && W
  }, Vt.createElement(px, {
    label: r,
    source: m,
    resource: C,
    isRequired: lx(u)
  })), Vt.createElement(va.Provider, {
    value: v
  }, nx(ax.only(p), E(i({}, v), {
    record: d,
    resource: C,
    source: m,
    variant: g,
    margin: b,
    disabled: y
  }))), !!((A || M) && W) || c ? Vt.createElement(Rx, {
    error: (A || M) && W
  }, Vt.createElement(Z, {
    touched: A || M,
    error: D == null ? void 0 : D.message,
    helperText: c
  })) : null);
}, "ArrayInput");
Xi.defaultProps = {
  options: {},
  fullWidth: !0
};
var Wq = n(function (e) {
  if (!Array.isArray(e)) return e;
}, "getArrayInputError");
l();
import * as _t from "react";
import { cloneElement as Dx, useCallback as Ki, useMemo as Mx } from "react";
import { styled as Vx } from "@mui/material";
import _x from "clsx";
import Hx from "lodash/get";
import Re from "prop-types";
import { useRecordContext as zx } from "ra-core";
l();
import { useContext as Px, useMemo as xx } from "react";
var nm = n(function (e) {
  var t = Px(va),
      o = xx(function () {
    return {
      append: e == null ? void 0 : e.append,
      fields: e == null ? void 0 : e.fields,
      insert: e == null ? void 0 : e.insert,
      move: e == null ? void 0 : e.move,
      prepend: e == null ? void 0 : e.prepend,
      remove: e == null ? void 0 : e.remove,
      replace: e == null ? void 0 : e.replace,
      swap: e == null ? void 0 : e.swap,
      update: e == null ? void 0 : e.update
    };
  }, [e]);
  return (e == null ? void 0 : e.fields) ? o : t;
}, "useArrayInput");
l();
var Zt = "RaSimpleFormIterator",
    Ae = {
  line: "".concat(Zt, "-line"),
  index: "".concat(Zt, "-index"),
  indexContainer: "".concat(Zt, "-indexContainer"),
  form: "".concat(Zt, "-form"),
  action: "".concat(Zt, "-action"),
  leftIcon: "".concat(Zt, "-leftIcon")
};
l();
import { createContext as Cx } from "react";
var Ia = Cx(void 0);
l();
import * as Ct from "react";
import { Children as Fx, cloneElement as Qi, isValidElement as Sx, useMemo as Ex } from "react";
import { Typography as Nx } from "@mui/material";
import am from "clsx";
import { getFieldLabelTranslationArgs as Bx, useTranslate as Lx } from "ra-core";
l();
import { useContext as vx } from "react";
var Fa = n(function () {
  return vx(Ia);
}, "useSimpleFormIterator");
l();
import { createContext as Ix } from "react";
var Sa = Ix(void 0);
var sm = Ct.forwardRef(function (e, t) {
  var o = e.children,
      r = e.disabled,
      a = e.disableReordering,
      s = e.disableRemove,
      p = e.getItemLabel,
      c = e.index,
      d = e.member,
      m = e.record,
      u = e.removeButton,
      g = e.reOrderButtons,
      y = e.resource,
      b = e.source,
      P = Lx(),
      _Fa = Fa(),
      T = _Fa.total,
      x = _Fa.reOrder,
      C = _Fa.remove,
      v = _Fa.source,
      I = n(function (S) {
    return typeof s == "boolean" ? s : s && s(S);
  }, "disableRemoveField"),
      N = n(function (S, L) {
    return function (k) {
      C(L), S && S(k);
    };
  }, "handleRemoveButtonClick"),
      F = Ex(function () {
    return {
      index: c,
      total: T,
      reOrder: function reOrder(S) {
        return x(c, S);
      },
      remove: function remove() {
        return C(c);
      }
    };
  }, [c, T, x, C]);

  return Ct.createElement(Sa.Provider, {
    value: F
  }, Ct.createElement("li", {
    className: Ae.line,
    ref: t
  }, Ct.createElement("div", null, Ct.createElement("div", {
    className: Ae.indexContainer
  }, Ct.createElement(Nx, {
    variant: "body1",
    className: Ae.index
  }, p(c)), !r && !a && Qi(g, {
    index: c,
    max: T,
    reOrder: x,
    className: am("button-reorder", "button-reorder-".concat(b, "-").concat(c))
  }))), Ct.createElement("section", {
    className: Ae.form
  }, Fx.map(o, function (S, L) {
    if (!Sx(S)) return null;
    var M = S.props,
        k = M.source,
        B = f(M, ["source"]);
    return Qi(S, i({
      source: k ? "".concat(d, ".").concat(k) : d,
      index: k ? void 0 : L,
      label: S.props.label === "" || S.props.label === !1 ? S.props.label : P.apply(void 0, _toConsumableArray(Bx({
        parentSource: v,
        resource: y,
        source: k
      }))),
      disabled: r
    }, B));
  })), !r && !I(m) && Ct.createElement("span", {
    className: Ae.action
  }, Qi(u, {
    onClick: N(u.props.onClick, c),
    className: am("button-remove", "button-remove-".concat(b, "-").concat(c))
  }))));
});
l();
import * as Gi from "react";
import kx from "@mui/icons-material/AddCircleOutline";
var im = n(function (e) {
  var _Fa2 = Fa(),
      t = _Fa2.add;

  return Gi.createElement(U, i({
    label: "ra.action.add",
    onClick: function onClick() {
      return t();
    }
  }, e), Gi.createElement(kx, null));
}, "AddItemButton");
l();
import * as Ji from "react";
import Ax from "@mui/icons-material/RemoveCircleOutline";
l();
import { useContext as wx } from "react";
var Ea = n(function () {
  return wx(Sa);
}, "useSimpleFormIteratorItem");
var lm = n(function (e) {
  var _Ea = Ea(),
      t = _Ea.remove;

  return Ji.createElement(U, i({
    label: "ra.action.remove",
    onClick: function onClick() {
      return t();
    }
  }, e), Ji.createElement(Ax, null));
}, "RemoveItemButton");
l();
import * as cr from "react";
import $x from "@mui/icons-material/ArrowUpward";
import Ox from "@mui/icons-material/ArrowDownward";
var pm = n(function (_ref58) {
  var e = _ref58.className;

  var _Ea2 = Ea(),
      t = _Ea2.index,
      o = _Ea2.total,
      r = _Ea2.reOrder;

  return cr.createElement("div", {
    className: e
  }, cr.createElement(li, {
    label: "ra.action.move_up",
    size: "small",
    onClick: function onClick() {
      return r(t - 1);
    },
    disabled: t <= 0
  }, cr.createElement($x, null)), cr.createElement(li, {
    label: "ra.action.move_down",
    size: "small",
    onClick: function onClick() {
      return r(t + 1);
    },
    disabled: o == null || t >= o - 1
  }, cr.createElement(Ox, null)));
}, "ReOrderButtons");
var Na = n(function (e) {
  var _e$addButton = e.addButton,
      t = _e$addButton === void 0 ? _t.createElement(im, null) : _e$addButton,
      _e$removeButton = e.removeButton,
      o = _e$removeButton === void 0 ? _t.createElement(lm, null) : _e$removeButton,
      _e$reOrderButtons = e.reOrderButtons,
      r = _e$reOrderButtons === void 0 ? _t.createElement(pm, null) : _e$reOrderButtons,
      a = e.children,
      s = e.className,
      p = e.resource,
      c = e.source,
      d = e.disabled,
      m = e.disableAdd,
      u = e.disableRemove,
      g = e.disableReordering,
      _e$getItemLabel = e.getItemLabel,
      y = _e$getItemLabel === void 0 ? qx : _e$getItemLabel,
      _nm = nm(e),
      b = _nm.append,
      P = _nm.fields,
      T = _nm.move,
      x = _nm.remove,
      C = zx(e),
      v = Ki(function (k) {
    x(k);
  }, [x]),
      I = Ki(function () {
    var k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
    b(k);
  }, [b]),
      N = n(function (k) {
    return function (B) {
      I(), k && k(B);
    };
  }, "handleAddButtonClick"),
      F = Ki(function (k, B) {
    T(k, B);
  }, [T]),
      S = Hx(C, c),
      L = Mx(function () {
    return {
      total: P.length,
      add: I,
      remove: v,
      reOrder: F,
      source: c
    };
  }, [I, P.length, F, v, c]);

  return P ? _t.createElement(Ia.Provider, {
    value: L
  }, _t.createElement(Wx, {
    className: s
  }, P.map(function (k, B) {
    return _t.createElement(sm, {
      key: k.id,
      disabled: d,
      disableRemove: u,
      disableReordering: g,
      fields: P,
      getItemLabel: y,
      index: B,
      member: "".concat(c, ".").concat(B),
      onRemoveField: v,
      onReorder: F,
      record: S && S[B] || {},
      removeButton: o,
      reOrderButtons: r,
      resource: p,
      source: c
    }, a);
  }), !d && !m && _t.createElement("li", {
    className: Ae.line
  }, _t.createElement("span", {
    className: Ae.action
  }, Dx(t, {
    onClick: N(t.props.onClick),
    className: _x("button-add", "button-add-".concat(c))
  }))))) : null;
}, "SimpleFormIterator");
Na.defaultProps = {
  disableAdd: !1,
  disableRemove: !1
};
Na.propTypes = {
  defaultValue: Re.any,
  addButton: Re.element,
  removeButton: Re.element,
  children: Re.node,
  className: Re.string,
  field: Re.object,
  fields: Re.array,
  fieldState: Re.object,
  formState: Re.object,
  record: Re.object,
  source: Re.string,
  resource: Re.string,
  translate: Re.func,
  disableAdd: Re.bool,
  disableRemove: Re.oneOfType([Re.func, Re.bool]),
  TransitionProps: Re.shape({})
};
var Wx = Vx("ul", {
  name: Zt,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref59) {
  var _$concat4, _ref60;

  var e = _ref59.theme;
  return _ref60 = {
    padding: 0,
    marginBottom: 0,
    "& > li:last-child": {
      borderBottom: "none"
    }
  }, _defineProperty(_ref60, "& .".concat(Ae.line), _defineProperty({
    display: "flex",
    listStyleType: "none",
    borderBottom: "solid 1px ".concat(e.palette.divider)
  }, e.breakpoints.down("sm"), {
    display: "block"
  })), _defineProperty(_ref60, "& .".concat(Ae.index), (_$concat4 = {}, _defineProperty(_$concat4, e.breakpoints.down("md"), {
    display: "none"
  }), _defineProperty(_$concat4, "marginRight", e.spacing(1)), _$concat4)), _defineProperty(_ref60, "& .".concat(Ae.indexContainer), {
    display: "flex",
    paddingTop: "1em",
    marginRight: e.spacing(1),
    alignItems: "center"
  }), _defineProperty(_ref60, "& .".concat(Ae.form), {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    flex: 2
  }), _defineProperty(_ref60, "& .".concat(Ae.action), {
    paddingTop: "0.5em"
  }), _defineProperty(_ref60, "& .".concat(Ae.leftIcon), {
    marginRight: e.spacing(1)
  }), _ref60;
}),
    qx = n(function (e) {
  return e + 1;
}, "DefaultLabelFn");
l();
import * as vt from "react";
import { isValidElement as Yi, useCallback as Zi, useEffect as dr, useMemo as Zx, useRef as el, useState as um } from "react";
import eC from "lodash/debounce";
import fm from "lodash/get";
import gm from "lodash/isEqual";
import tC from "clsx";
import { Autocomplete as oC, Chip as rC, TextField as nC } from "@mui/material";
import { styled as aC } from "@mui/material/styles";
import { FieldTitle as sC, useChoicesContext as iC, useInput as lC, useSuggestions as pC, useTimeout as cC, useTranslate as mC, warning as dC } from "ra-core";
l();
import * as cm from "react";
import { createContext as jx, isValidElement as mm, useContext as Ux, useEffect as Xx, useMemo as Qx, useRef as Gx, useState as Jx } from "react";
import { useTranslate as Kx } from "ra-core";
import Yx from "lodash/set";
var mr = n(function (e) {
  var t = e.create,
      _e$createLabel = e.createLabel,
      o = _e$createLabel === void 0 ? "ra.action.create" : _e$createLabel,
      _e$createItemLabel = e.createItemLabel,
      r = _e$createItemLabel === void 0 ? "ra.action.create_item" : _e$createItemLabel,
      _e$createValue = e.createValue,
      a = _e$createValue === void 0 ? "@@ra-create" : _e$createValue,
      _e$optionText = e.optionText,
      s = _e$optionText === void 0 ? "name" : _e$optionText,
      p = e.filter,
      c = e.handleChange,
      d = e.onCreate,
      m = Kx(),
      _Jx = Jx(!1),
      _Jx2 = _slicedToArray(_Jx, 2),
      u = _Jx2[0],
      g = _Jx2[1],
      y = Gx(p);

  Xx(function () {
    y.current !== p && p !== "" && (y.current = p);
  }, [p]);
  var b = Qx(function () {
    return {
      filter: y.current,
      onCancel: function onCancel() {
        return g(!1);
      },
      onCreate: function onCreate(P) {
        g(!1), c(P);
      }
    };
  }, [c]);
  return {
    getCreateItem: function getCreateItem() {
      return typeof s != "string" ? {
        id: a,
        name: p && r ? m(r, {
          item: p,
          _: r
        }) : m(o, {
          _: o
        })
      } : Yx({
        id: a
      }, s, p && r ? m(r, {
        item: p,
        _: r
      }) : m(o, {
        _: o
      }));
    },
    handleChange: function () {
      var _handleChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(P) {
        var C, T, x, v;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                T = ((C = P == null ? void 0 : P.target) == null ? void 0 : C.value) || P, x = Array.isArray(T) ? _toConsumableArray(T).pop() : T;

                if (!((x == null ? void 0 : x.id) === a || x === a)) {
                  _context4.next = 13;
                  break;
                }

                if (!mm(t)) {
                  _context4.next = 7;
                  break;
                }

                g(!0);
                return _context4.abrupt("return");

              case 7:
                _context4.next = 9;
                return d(p);

              case 9:
                v = _context4.sent;

                if (!v) {
                  _context4.next = 13;
                  break;
                }

                c(v);
                return _context4.abrupt("return");

              case 13:
                c(P);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function handleChange(_x4) {
        return _handleChange.apply(this, arguments);
      }

      return handleChange;
    }(),
    createElement: u && mm(t) ? cm.createElement(dm.Provider, {
      value: b
    }, t) : null
  };
}, "useSupportCreateSuggestion"),
    dm = jx(void 0),
    lU = n(function () {
  return Ux(dm);
}, "useCreateSuggestionContext");
var ym = n(function (e) {
  var ec = e,
      t = ec.choices,
      o = ec.className,
      _ec$clearText = ec.clearText,
      r = _ec$clearText === void 0 ? "ra.action.clear_input_value" : _ec$clearText,
      _ec$closeText = ec.closeText,
      a = _ec$closeText === void 0 ? "ra.action.close" : _ec$closeText,
      s = ec.create,
      p = ec.createLabel,
      c = ec.createItemLabel,
      d = ec.createValue,
      _ec$debounce = ec.debounce,
      m = _ec$debounce === void 0 ? 250 : _ec$debounce,
      _ec$defaultValue = ec.defaultValue,
      u = _ec$defaultValue === void 0 ? "" : _ec$defaultValue,
      g = ec.emptyText,
      _ec$emptyValue = ec.emptyValue,
      y = _ec$emptyValue === void 0 ? "" : _ec$emptyValue,
      b = ec.field,
      P = ec.format,
      T = ec.helperText,
      x = ec.id,
      C = ec.inputText,
      v = ec.isFetching,
      I = ec.isLoading,
      N = ec.isRequired,
      F = ec.label,
      S = ec.limitChoicesToValue,
      L = ec.matchSuggestion,
      k = ec.margin,
      B = ec.fieldState,
      _ec$filterToQuery = ec.filterToQuery,
      M = _ec$filterToQuery === void 0 ? gC : _ec$filterToQuery,
      z = ec.formState,
      _ec$multiple = ec.multiple,
      A = _ec$multiple === void 0 ? !1 : _ec$multiple,
      W = ec.noOptionsText,
      D = ec.onBlur,
      V = ec.onChange,
      _ = ec.onCreate,
      _ec$openText = ec.openText,
      w = _ec$openText === void 0 ? "ra.action.open" : _ec$openText,
      _ec$optionText = ec.optionText,
      O = _ec$optionText === void 0 ? "name" : _ec$optionText,
      _ec$optionValue = ec.optionValue,
      te = _ec$optionValue === void 0 ? "id" : _ec$optionValue,
      oe = ec.parse,
      ce = ec.resource,
      re = ec.shouldRenderSuggestions,
      le = ec.setFilter,
      He = ec.size,
      Q = ec.source,
      we = ec.suggestionLimit,
      ae = ec.TextFieldProps,
      st = ec.translateChoice,
      De = ec.validate,
      Zr = ec.variant,
      bo = f(ec, ["choices", "className", "clearText", "closeText", "create", "createLabel", "createItemLabel", "createValue", "debounce", "defaultValue", "emptyText", "emptyValue", "field", "format", "helperText", "id", "inputText", "isFetching", "isLoading", "isRequired", "label", "limitChoicesToValue", "matchSuggestion", "margin", "fieldState", "filterToQuery", "formState", "multiple", "noOptionsText", "onBlur", "onChange", "onCreate", "openText", "optionText", "optionValue", "parse", "resource", "shouldRenderSuggestions", "setFilter", "size", "source", "suggestionLimit", "TextFieldProps", "translateChoice", "validate", "variant"]),
      _iC = iC({
    choices: t,
    isFetching: v,
    isLoading: I,
    resource: ce,
    source: Q
  }),
      j = _iC.allChoices,
      yt = _iC.isLoading,
      bt = _iC.resource,
      en = _iC.source,
      Yo = _iC.setFilters,
      ho = mC(),
      _lC = lC(i({
    defaultValue: u,
    format: P,
    id: x,
    field: b,
    fieldState: B,
    formState: z,
    onBlur: D,
    onChange: V,
    parse: oe,
    resource: bt,
    source: en,
    validate: De
  }, bo)),
      he = _lC.id,
      it = _lC.field,
      ff = _lC.isRequired,
      _lC$fieldState = _lC.fieldState,
      $s = _lC$fieldState.error,
      gf = _lC$fieldState.invalid,
      Up = _lC$fieldState.isTouched,
      Xp = _lC.formState.isSubmitted,
      Ro = fC(it.value, {
    choices: j,
    multiple: A,
    optionValue: te
  });

  dr(function () {
    if (Yi(O) && C == null) throw new Error("\nIf you provided a React element for the optionText prop, you must also provide the inputText prop (used for the text input)");
    if (Yi(O) && L == null) throw new Error("\nIf you provided a React element for the optionText prop, you must also provide the matchSuggestion prop (used to match the user input with a choice)");
  }, [O, C, L]), dr(function () {
    dC(re != null && W == null, "When providing a shouldRenderSuggestions function, we recommend you also provide the noOptionsText prop and set it to a text explaining users why no options are displayed. It supports translation keys.");
  }, [re, W]);

  var _pC = pC({
    choices: j,
    emptyText: g,
    emptyValue: y,
    limitChoicesToValue: S,
    matchSuggestion: L,
    optionText: O,
    optionValue: te,
    selectedItem: Ro,
    suggestionLimit: we,
    translateChoice: st
  }),
      Qn = _pC.getChoiceText,
      tn = _pC.getChoiceValue,
      Qp = _pC.getSuggestions,
      _um = um(""),
      _um2 = _slicedToArray(_um, 2),
      To = _um2[0],
      Gp = _um2[1],
      yf = n(function (J) {
    var me;
    A ? Array.isArray(J) ? it.onChange(J.map(tn)) : it.onChange([].concat(_toConsumableArray((me = it.value) != null ? me : []), [tn(J)])) : it.onChange(tn(J) || "");
  }, "handleChange"),
      Jp = Zi(eC(function (J) {
    if (le) return le(J);
    t || Yo(M(J), void 0, !0);
  }, m), [m, Yo, le]),
      Kp = el(it.value);

  dr(function () {
    gm(Kp.current, it.value) || (Kp.current = it.value, Jp(""));
  }, [it.value]);

  var _mr = mr({
    create: s,
    createLabel: p,
    createItemLabel: c,
    createValue: d,
    handleChange: yf,
    filter: To,
    onCreate: _,
    optionText: O
  }),
      bf = _mr.getCreateItem,
      hf = _mr.handleChange,
      Rf = _mr.createElement,
      Po = Zi(function (J) {
    return J == null ? "" : typeof J == "string" ? J : C != null ? C(J) : Qn(J);
  }, [Qn, C]);

  dr(function () {
    if (!A) {
      var J = Po(Ro);
      if (typeof J == "string") Gp(J);else throw new Error("When optionText returns a React element, you must also provide the inputText prop");
    }
  }, [Po, A, Ro]);
  var Tf = n(function (J, me, Lt) {
    Gp(me), Jp(me);
  }, "handleInputChange"),
      Pf = Zi(function (J) {
    var me = [];
    A ? me = Ro.map(function (rn) {
      return Po(rn);
    }) : me = [Po(Ro)];
    var Lt = j ? j.some(function (rn) {
      return Po(rn) === J;
    }) : !1;
    return me.includes(J) || Lt;
  }, [j, Po, A, Ro]),
      xf = n(function (J, me) {
    var Lt = me.inputValue;
    return (_ || s) && Lt !== "" && !Pf(To) ? J.concat(bf(Lt)) : J;
  }, "filterOptions"),
      Cf = n(function (J, me, Lt) {
    hf(me != null ? me : "");
  }, "handleAutocompleteChange"),
      on = cC(1e3, To),
      Yp = el(j);
  dr(function () {
    j && (j.length > 0 || on) && (Yp.current = j);
  }, [j, on]);
  var Zp = Zx(function () {
    return Yo && (j == null ? void 0 : j.length) === 0 && !on ? Yp.current : Qp(To);
  }, [j, To, Qp, on, Yo]),
      vf = n(function (J, me) {
    return tn(J) == tn(me);
  }, "isOptionEqualToValue");
  return vt.createElement(vt.Fragment, null, vt.createElement(uC, E(i({
    blurOnSelect: !0,
    className: tC("ra-input", "ra-input-".concat(en), o),
    clearText: ho(r, {
      _: r
    }),
    closeText: ho(a, {
      _: a
    }),
    openOnFocus: !0,
    openText: ho(w, {
      _: w
    }),
    id: he,
    isOptionEqualToValue: vf,
    filterSelectedOptions: !0,
    renderInput: function renderInput(J) {
      return vt.createElement(nC, E(i(i({
        name: it.name,
        label: vt.createElement(sC, {
          label: F,
          source: en,
          resource: bt,
          isRequired: typeof N != "undefined" ? N : ff
        }),
        error: (Up || Xp) && gf,
        helperText: vt.createElement(Z, {
          touched: Up || Xp,
          error: $s == null ? void 0 : $s.message,
          helperText: T
        }),
        margin: k,
        variant: Zr,
        className: hm.textField
      }, ae), J), {
        size: He
      }));
    },
    multiple: A,
    renderTags: function renderTags(J, me) {
      return J.map(function (Lt, rn) {
        return vt.createElement(rC, i({
          label: Yi(O) ? C(Lt) : Qn(Lt),
          sx: {
            ".MuiSvgIcon-root": {
              zIndex: 100
            }
          },
          size: "small"
        }, me({
          index: rn
        })));
      });
    },
    noOptionsText: typeof W == "string" ? ho(W, {
      _: W
    }) : W,
    selectOnFocus: !0,
    clearOnBlur: !0
  }, ne(bo)), {
    freeSolo: !!s || !!_,
    handleHomeEndKeys: !!s || !!_,
    filterOptions: xf,
    options: re == null || re(To) ? Zp : [],
    getOptionLabel: Po,
    inputValue: To,
    loading: yt && Zp.length === 0 && on,
    value: Ro,
    onChange: Cf,
    onBlur: it.onBlur,
    onInputChange: Tf,
    renderOption: function renderOption(J, me) {
      return vt.createElement("li", i({}, J), Qn(me));
    }
  })), Rf);
}, "AutocompleteInput"),
    bm = "RaAutocompleteInput",
    hm = {
  textField: "".concat(bm, "-textField")
},
    uC = aC(oC, {
  name: bm,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref61) {
  var e = _ref61.theme;
  return _defineProperty({}, "& .".concat(hm.textField), {
    minWidth: e.spacing(20)
  });
}),
    fC = n(function (e, _ref63) {
  var t = _ref63.choices,
      o = _ref63.multiple,
      r = _ref63.optionValue;

  var a = el(tl(t, e, r, o)),
      _um3 = um(function () {
    return tl(t, e, r, o);
  }),
      _um4 = _slicedToArray(_um3, 2),
      s = _um4[0],
      p = _um4[1];

  return dr(function () {
    var c = tl(t, e, r, o);
    gm(a.current, c) || (a.current = c, p(c));
  }, [t, e, o, r]), s || null;
}, "useSelectedChoice"),
    tl = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = arguments.length > 1 ? arguments[1] : undefined;
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
  var r = arguments.length > 3 ? arguments[3] : undefined;
  return r ? (t || []).map(function (a) {
    return e.find(function (s) {
      return a === fm(s, o);
    });
  }).filter(function (a) {
    return !!a;
  }) : e.find(function (a) {
    return fm(a, o) === t;
  }) || "";
}, "getSelectedItems"),
    gC = n(function (e) {
  return {
    q: e
  };
}, "DefaultFilterToQuery");
l();
import * as Rm from "react";
var BU = n(function (o) {
  var r = o,
      e = r.defaultValue,
      t = f(r, ["defaultValue"]);
  return Rm.createElement(ym, E(i({}, t), {
    multiple: !0,
    defaultValue: e != null ? e : []
  }));
}, "AutocompleteArrayInput");
l();
import * as Bo from "react";
import { useCallback as yC } from "react";
import Pm from "prop-types";
import bC from "clsx";
import hC from "@mui/material/FormControlLabel";
import RC from "@mui/material/FormHelperText";
import TC from "@mui/material/FormGroup";
import xm from "@mui/material/Switch";
import { FieldTitle as PC, useInput as xC } from "ra-core";
l();
import yn from "prop-types";
var Tm = {
  label: yn.oneOfType([yn.string, yn.bool]),
  resource: yn.string,
  source: yn.string
};
var Ba = n(function (e) {
  var z = e,
      t = z.className,
      _z$row = z.row,
      o = _z$row === void 0 ? !1 : _z$row,
      _z$defaultValue = z.defaultValue,
      r = _z$defaultValue === void 0 ? !1 : _z$defaultValue,
      a = z.format,
      s = z.label,
      p = z.fullWidth,
      c = z.helperText,
      d = z.onBlur,
      m = z.onChange,
      u = z.onFocus,
      g = z.disabled,
      y = z.parse,
      b = z.resource,
      P = z.source,
      T = z.validate,
      x = z.options,
      C = z.sx,
      v = f(z, ["className", "row", "defaultValue", "format", "label", "fullWidth", "helperText", "onBlur", "onChange", "onFocus", "disabled", "parse", "resource", "source", "validate", "options", "sx"]),
      _xC = xC(i({
    defaultValue: r,
    format: a,
    parse: y,
    resource: b,
    source: P,
    onBlur: d,
    onChange: m,
    type: "checkbox",
    validate: T
  }, v)),
      I = _xC.id,
      N = _xC.field,
      F = _xC.isRequired,
      _xC$fieldState = _xC.fieldState,
      S = _xC$fieldState.error,
      L = _xC$fieldState.invalid,
      k = _xC$fieldState.isTouched,
      B = _xC.formState.isSubmitted,
      M = yC(function (A) {
    N.onChange(A), N.onBlur();
  }, [N]);

  return Bo.createElement(TC, {
    className: bC("ra-input", "ra-input-".concat(P), t),
    row: o,
    sx: C
  }, Bo.createElement(hC, {
    control: Bo.createElement(xm, E(i(i({
      id: I,
      name: N.name,
      color: "primary",
      onChange: M,
      onFocus: u,
      checked: N.value
    }, ne(v)), x), {
      disabled: g
    })),
    label: Bo.createElement(PC, {
      label: s,
      source: P,
      resource: b,
      isRequired: F
    })
  }), Bo.createElement(RC, {
    error: (k || B) && L
  }, Bo.createElement(Z, {
    touched: k || B,
    error: S == null ? void 0 : S.message,
    helperText: c
  })));
}, "BooleanInput");
Ba.propTypes = E(i({}, Tm), {
  options: Pm.shape(xm.propTypes),
  disabled: Pm.bool
});
Ba.defaultProps = {
  options: {}
};
l();
import * as It from "react";
import { styled as EC } from "@mui/material/styles";
import Fm from "clsx";
import { useCallback as NC } from "react";
import et from "prop-types";
import Sm from "lodash/get";
import BC from "@mui/material/FormLabel";
import LC from "@mui/material/FormControl";
import kC from "@mui/material/FormGroup";
import wC from "@mui/material/FormHelperText";
import { FieldTitle as AC, useInput as $C, warning as Em, useChoicesContext as OC } from "ra-core";
l();
import * as ol from "react";
import { styled as CC } from "@mui/material/styles";
import vC from "@mui/material/FormControlLabel";
import IC from "@mui/material/Checkbox";
import { useChoices as FC } from "ra-core";
var Cm = n(function (e) {
  var T = e,
      t = T.id,
      o = T.choice,
      r = T.className,
      a = T.fullWidth,
      s = T.onChange,
      p = T.optionText,
      c = T.optionValue,
      d = T.options,
      m = T.translateChoice,
      u = T.value,
      g = f(T, ["id", "choice", "className", "fullWidth", "onChange", "optionText", "optionValue", "options", "translateChoice", "value"]),
      _FC = FC({
    optionText: p,
    optionValue: c,
    translateChoice: m
  }),
      y = _FC.getChoiceText,
      b = _FC.getChoiceValue,
      P = y(o);

  return ol.createElement(SC, {
    htmlFor: "".concat(t, "_").concat(b(o)),
    key: b(o),
    onChange: s,
    className: r,
    control: ol.createElement(IC, i(i({
      id: "".concat(t, "_").concat(b(o)),
      color: "primary",
      className: Im.checkbox,
      checked: u ? u.find(function (x) {
        return x == b(o);
      }) !== void 0 : !1,
      value: String(b(o))
    }, d), g)),
    label: P
  });
}, "CheckboxGroupInputItem"),
    vm = "RaCheckboxGroupInputItem",
    Im = {
  checkbox: "".concat(vm, "-checkbox")
},
    SC = CC(vC, {
  name: vm,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(_defineProperty({}, "& .".concat(Im.checkbox), {
  height: 32
}));
var DC = n(function (e) {
  var te = e,
      t = te.choices,
      o = te.className,
      r = te.classes,
      a = te.format,
      s = te.helperText,
      p = te.label,
      c = te.isLoading,
      d = te.isFetching,
      _te$margin = te.margin,
      m = _te$margin === void 0 ? "dense" : _te$margin,
      u = te.onBlur,
      g = te.onChange,
      _te$optionText = te.optionText,
      y = _te$optionText === void 0 ? "name" : _te$optionText,
      _te$optionValue = te.optionValue,
      b = _te$optionValue === void 0 ? "id" : _te$optionValue,
      P = te.parse,
      T = te.resource,
      _te$row = te.row,
      x = _te$row === void 0 ? !0 : _te$row,
      C = te.source,
      _te$translateChoice = te.translateChoice,
      v = _te$translateChoice === void 0 ? !0 : _te$translateChoice,
      I = te.validate,
      N = f(te, ["choices", "className", "classes", "format", "helperText", "label", "isLoading", "isFetching", "margin", "onBlur", "onChange", "optionText", "optionValue", "parse", "resource", "row", "source", "translateChoice", "validate"]),
      _OC = OC({
    choices: t,
    isFetching: d,
    isLoading: c,
    resource: T,
    source: C
  }),
      F = _OC.allChoices,
      S = _OC.isLoading,
      L = _OC.resource,
      k = _OC.source;

  Em(k === void 0, "If you're not wrapping the CheckboxGroupInput inside a ReferenceArrayInput, you must provide the source prop"), Em(F === void 0, "If you're not wrapping the CheckboxGroupInput inside a ReferenceArrayInput, you must provide the choices prop");

  var _$C = $C(i({
    format: a,
    parse: P,
    resource: L,
    source: k,
    validate: I,
    onChange: g,
    onBlur: u
  }, N)),
      _$C$field = _$C.field,
      B = _$C$field.onChange,
      M = _$C$field.onBlur,
      z = _$C$field.value,
      _$C$fieldState = _$C.fieldState,
      A = _$C$fieldState.error,
      W = _$C$fieldState.invalid,
      D = _$C$fieldState.isTouched,
      V = _$C.formState.isSubmitted,
      _ = _$C.id,
      w = _$C.isRequired,
      O = NC(function (oe, ce) {
    var re;
    if (F.every(function (le) {
      return typeof Sm(le, b) == "number";
    })) try {
      re = JSON.parse(oe.target.value);
    } catch (_unused) {
      re = oe.target.value;
    } else re = oe.target.value;
    B(ce ? [].concat(_toConsumableArray(z || []), [re]) : z.filter(function (le) {
      return le != re;
    })), M();
  }, [F, B, M, b, z]);

  return S && (F == null ? void 0 : F.length) === 0 ? It.createElement(fe, i({
    id: _,
    label: p,
    source: k,
    resource: L,
    className: Fm("ra-input", "ra-input-".concat(k), o),
    isRequired: w
  }, N), It.createElement(Be, null)) : It.createElement(MC, i({
    component: "fieldset",
    margin: m,
    error: (D || V) && W,
    className: Fm("ra-input", "ra-input-".concat(k), o)
  }, Nm(N)), It.createElement(BC, {
    component: "legend",
    className: Lm.label
  }, It.createElement(AC, {
    label: p,
    source: k,
    resource: L,
    isRequired: w
  })), It.createElement(kC, {
    row: x
  }, F == null ? void 0 : F.map(function (oe) {
    return It.createElement(Cm, i({
      key: Sm(oe, b),
      choice: oe,
      id: _,
      onChange: O,
      optionText: y,
      optionValue: b,
      translateChoice: v,
      value: z
    }, Nm(N)));
  })), It.createElement(wC, null, It.createElement(Z, {
    touched: D || V,
    error: A == null ? void 0 : A.message,
    helperText: s
  })));
}, "CheckboxGroupInput"),
    Nm = n(function (c) {
  var d = c,
      e = d.refetch,
      t = d.setFilter,
      o = d.setPagination,
      r = d.setSort,
      a = d.loaded,
      s = d.touched,
      p = f(d, ["refetch", "setFilter", "setPagination", "setSort", "loaded", "touched"]);
  return ne(p);
}, "sanitizeRestProps");
DC.propTypes = {
  choices: et.arrayOf(et.any),
  className: et.string,
  source: et.string,
  optionText: et.oneOfType([et.string, et.func, et.element]),
  optionValue: et.string,
  row: et.bool,
  resource: et.string,
  translateChoice: et.bool
};
var Bm = "RaCheckboxGroupInput",
    Lm = {
  label: "".concat(Bm, "-label")
},
    MC = EC(LC, {
  name: Bm,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref64) {
  var e = _ref64.theme;
  return _defineProperty({}, "& .".concat(Lm.label), {
    transform: "translate(0, 8px) scale(0.75)",
    transformOrigin: "top ".concat(e.direction === "ltr" ? "left" : "right")
  });
});
l();
import * as Le from "react";
import { cloneElement as vd, useCallback as wl } from "react";
import US from "clsx";
import { ListContextProvider as XS, useChoicesContext as QS, useInput as GS } from "ra-core";
l();
l();
import * as ur from "react";
import { cloneElement as dv, memo as uv } from "react";
import ue from "prop-types";
import { TableBody as fv } from "@mui/material";
import Mm from "clsx";
l();
import { styled as VC } from "@mui/material";
var de = "RaDatagrid",
    $ = {
  table: "".concat(de, "-table"),
  tableWrapper: "".concat(de, "-tableWrapper"),
  thead: "".concat(de, "-thead"),
  tbody: "".concat(de, "-tbody"),
  headerRow: "".concat(de, "-headerRow"),
  headerCell: "".concat(de, "-headerCell"),
  checkbox: "".concat(de, "-checkbox"),
  row: "".concat(de, "-row"),
  clickableRow: "".concat(de, "-clickableRow"),
  rowEven: "".concat(de, "-rowEven"),
  rowOdd: "".concat(de, "-rowOdd"),
  rowCell: "".concat(de, "-rowCell"),
  selectable: "".concat(de, "-selectable"),
  expandHeader: "".concat(de, "-expandHeader"),
  expandIconCell: "".concat(de, "-expandIconCell"),
  expandIcon: "".concat(de, "-expandIcon"),
  expandable: "".concat(de, "-expandable"),
  expanded: "".concat(de, "-expanded"),
  expandedPanel: "".concat(de, "-expandedPanel")
},
    km = VC("div", {
  name: de,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref66) {
  var _ref67;

  var e = _ref66.theme;
  return _ref67 = {}, _defineProperty(_ref67, "& .".concat($.table), {
    tableLayout: "auto"
  }), _defineProperty(_ref67, "& .".concat($.tableWrapper), {}), _defineProperty(_ref67, "& .".concat($.thead), {}), _defineProperty(_ref67, "& .".concat($.tbody), {}), _defineProperty(_ref67, "& .".concat($.headerRow), {}), _defineProperty(_ref67, "& .".concat($.headerCell), {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: e.palette.background.paper,
    "&:first-of-type": {
      borderTopLeftRadius: e.shape.borderRadius
    },
    "&:last-child": {
      borderTopRightRadius: e.shape.borderRadius
    }
  }), _defineProperty(_ref67, "& .".concat($.checkbox), {}), _defineProperty(_ref67, "& .".concat($.row), {}), _defineProperty(_ref67, "& .".concat($.clickableRow), {
    cursor: "pointer"
  }), _defineProperty(_ref67, "& .".concat($.rowEven), {}), _defineProperty(_ref67, "& .".concat($.rowOdd), {}), _defineProperty(_ref67, "& .".concat($.rowCell), {}), _defineProperty(_ref67, "& .".concat($.expandHeader), {
    padding: 0,
    width: e.spacing(6)
  }), _defineProperty(_ref67, "& .".concat($.expandIconCell), {
    width: e.spacing(6)
  }), _defineProperty(_ref67, "& .".concat($.expandIcon), {
    padding: e.spacing(1),
    transform: "rotate(-90deg)",
    transition: e.transitions.create("transform", {
      duration: e.transitions.duration.shortest
    })
  }), _defineProperty(_ref67, "& .".concat($.expandIcon, ".").concat($.expanded), {
    transform: "rotate(0deg)"
  }), _defineProperty(_ref67, "& .".concat($.expandedPanel), {}), _ref67;
});
l();
import tt, { isValidElement as $m, cloneElement as KC, createElement as YC, useState as ZC, useEffect as ev, useCallback as il, memo as tv } from "react";
import ve from "prop-types";
import ll from "clsx";
import { TableCell as pl, TableRow as Om, Checkbox as ov } from "@mui/material";
import { RecordContextProvider as rv, shallowEqual as nv, useExpanded as av, useResourceContext as sv, useTranslate as iv, useCreatePath as lv, useRecordContext as pv } from "ra-core";
import { useNavigate as cv } from "react-router-dom";
l();
import * as La from "react";
import ka from "prop-types";
import _C from "@mui/material/TableCell";
import HC from "clsx";
var rl = La.forwardRef(function (p, s) {
  var c = p,
      e = c.className,
      t = c.field,
      o = c.record,
      r = c.resource,
      a = f(c, ["className", "field", "record", "resource"]);
  return La.createElement(_C, i({
    className: HC(e, t.props.cellClassName),
    align: t.props.textAlign,
    ref: s
  }, a), t);
});
rl.propTypes = {
  className: ka.string,
  field: ka.element,
  record: ka.object,
  resource: ka.string
};
rl.displayName = "DatagridCell";
var nl = rl;
l();
import * as al from "react";
import { memo as zC } from "react";
import WC from "@mui/material/IconButton";
import qC from "@mui/icons-material/ExpandMore";
import { useTranslate as jC } from "ra-core";
var UC = n(function (r) {
  var a = r,
      e = a.expanded,
      t = a.expandContentId,
      o = f(a, ["expanded", "expandContentId"]);
  var s = jC();
  return al.createElement(WC, E(i({
    "aria-label": s(e ? "ra.action.close" : "ra.action.expand"),
    "aria-expanded": e,
    "aria-controls": t,
    tabIndex: -1,
    "aria-hidden": "true",
    component: "div"
  }, o), {
    size: "small"
  }), al.createElement(qC, {
    fontSize: "inherit"
  }));
}, "ExpandRowButton"),
    sl = zC(UC);
l();
import { useContext as QC, useMemo as GC } from "react";
l();
import { createContext as XC } from "react";
var wm = XC({});
wm.displayName = "DatagridContext";
var wa = wm;
import JC from "lodash/defaults";
var Am = n(function (e) {
  var t = QC(wa);
  return GC(function () {
    return JC({}, e != null ? {
      isRowExpandable: e.isRowExpandable
    } : {}, t);
  }, [t, e]);
}, "useDatagridContext");
var Dm = n(function (e, t, o) {
  return e ? 1 + (o ? 1 : 0) + tt.Children.toArray(t).filter(function (r) {
    return !!r;
  }).length : 0;
}, "computeNbColumns"),
    Aa = tt.forwardRef(function (e, t) {
  var _ll;

  var W = e,
      o = W.children,
      r = W.className,
      a = W.expand,
      s = W.hasBulkActions,
      p = W.hover,
      c = W.id,
      d = W.onToggleItem,
      m = W.record,
      u = W.rowClick,
      g = W.selected,
      y = W.style,
      b = W.selectable,
      P = f(W, ["children", "className", "expand", "hasBulkActions", "hover", "id", "onToggleItem", "record", "rowClick", "selected", "style", "selectable"]),
      T = Am(),
      x = iv(),
      C = pv(e),
      v = (!T || !T.isRowExpandable || T.isRowExpandable(C)) && a,
      I = sv(e),
      N = lv(),
      _av = av(I, c, T && T.expandSingle),
      _av2 = _slicedToArray(_av, 2),
      F = _av2[0],
      S = _av2[1],
      _ZC = ZC(function () {
    return Dm(v, o, s);
  }),
      _ZC2 = _slicedToArray(_ZC, 2),
      L = _ZC2[0],
      k = _ZC2[1];

  ev(function () {
    var D = Dm(v, o, s);
    D !== L && k(D);
  }, [v, L, o, s]);
  var B = cv(),
      M = il(function (D) {
    S(), D.stopPropagation();
  }, [S]),
      z = il(function (D) {
    !b || (d(c, D), D.stopPropagation());
  }, [c, d, b]),
      A = il( /*#__PURE__*/function () {
    var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(D) {
      var V;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              D.persist();

              if (!(typeof u == "function")) {
                _context5.next = 7;
                break;
              }

              _context5.next = 4;
              return u(c, I, C);

            case 4:
              _context5.t0 = _context5.sent;
              _context5.next = 8;
              break;

            case 7:
              _context5.t0 = u;

            case 8:
              V = _context5.t0;

              if (V === !1 || V == null) {
                _context5.next = 20;
                break;
              }

              if (!["edit", "show"].includes(V)) {
                _context5.next = 13;
                break;
              }

              B(N({
                resource: I,
                id: c,
                type: V
              }));
              return _context5.abrupt("return");

            case 13:
              if (!(V === "expand")) {
                _context5.next = 16;
                break;
              }

              M(D);
              return _context5.abrupt("return");

            case 16:
              if (!(V === "toggleSelection")) {
                _context5.next = 19;
                break;
              }

              z(D);
              return _context5.abrupt("return");

            case 19:
              B(V);

            case 20:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref68.apply(this, arguments);
    };
  }(), [u, c, I, C, B, N, M, z]);
  return tt.createElement(rv, {
    value: C
  }, tt.createElement(Om, i({
    ref: t,
    className: ll(r, (_ll = {}, _defineProperty(_ll, $.expandable, v), _defineProperty(_ll, $.selectable, b), _defineProperty(_ll, $.clickableRow, typeof u == "function" ? !0 : u), _ll)),
    key: c,
    style: y,
    hover: p,
    onClick: A
  }, P), a && tt.createElement(pl, {
    padding: "none",
    className: $.expandIconCell
  }, v && tt.createElement(sl, {
    className: ll($.expandIcon, _defineProperty({}, $.expanded, F)),
    expanded: F,
    onClick: M,
    expandContentId: "".concat(c, "-expand")
  })), s && tt.createElement(pl, {
    padding: "checkbox"
  }, b && tt.createElement(ov, {
    "aria-label": x("ra.action.select_row", {
      _: "Select this row"
    }),
    color: "primary",
    className: "select-item ".concat($.checkbox),
    checked: g,
    onClick: z
  })), tt.Children.map(o, function (D, V) {
    return $m(D) ? tt.createElement(nl, i({
      key: "".concat(c, "-").concat(D.props.source || V),
      className: ll("column-".concat(D.props.source), $.rowCell),
      record: C
    }, {
      field: D,
      resource: I
    })) : null;
  })), v && F && tt.createElement(Om, {
    key: "".concat(c, "-expand"),
    id: "".concat(c, "-expand"),
    className: $.expandedPanel
  }, tt.createElement(pl, {
    colSpan: L
  }, $m(a) ? KC(a, {
    record: C,
    resource: I,
    id: String(c)
  }) : YC(a, {
    record: C,
    resource: I,
    id: String(c)
  }))));
});
Aa.propTypes = {
  children: ve.node,
  className: ve.string,
  expand: ve.oneOfType([ve.element, ve.elementType]),
  hasBulkActions: ve.bool.isRequired,
  hover: ve.bool,
  id: ve.any,
  onToggleItem: ve.func,
  record: ve.object,
  resource: ve.string,
  rowClick: ve.oneOfType([ve.string, ve.func]),
  selected: ve.bool,
  style: ve.object,
  selectable: ve.bool
};
Aa.defaultProps = {
  hasBulkActions: !1,
  hover: !0,
  selected: !1,
  selectable: !0
};
var mv = n(function (e, t) {
  var d = e,
      o = d.children,
      r = d.expand,
      a = f(d, ["children", "expand"]),
      m = t,
      s = m.children,
      p = m.expand,
      c = f(m, ["children", "expand"]);
  return nv(a, c);
}, "areEqual"),
    $a = tv(Aa, mv);
$a.displayName = "PureDatagridRow";
var cl = Aa;
var bn = ur.forwardRef(function (T, P) {
  var x = T,
      e = x.children,
      t = x.className,
      o = x.data,
      r = x.expand,
      a = x.hasBulkActions,
      s = x.hover,
      p = x.onToggleItem,
      c = x.resource,
      d = x.row,
      m = x.rowClick,
      u = x.rowStyle,
      g = x.selectedIds,
      y = x.isRowSelectable,
      b = f(x, ["children", "className", "data", "expand", "hasBulkActions", "hover", "onToggleItem", "resource", "row", "rowClick", "rowStyle", "selectedIds", "isRowSelectable"]);
  return ur.createElement(fv, i({
    ref: P,
    className: Mm("datagrid-body", t, $.tbody)
  }, b), o.map(function (C, v) {
    var _Mm;

    var I;
    return dv(d, {
      className: Mm($.row, (_Mm = {}, _defineProperty(_Mm, $.rowEven, v % 2 === 0), _defineProperty(_Mm, $.rowOdd, v % 2 !== 0), _Mm)),
      expand: r,
      hasBulkActions: a && !!g,
      hover: s,
      id: C.id,
      key: (I = C.id) != null ? I : "row".concat(v),
      onToggleItem: p,
      record: C,
      resource: c,
      rowClick: m,
      selectable: !y || y(C),
      selected: g == null ? void 0 : g.includes(C.id),
      style: u ? u(C, v) : null
    }, e);
  }));
});
bn.propTypes = {
  className: ue.string,
  children: ue.node,
  data: ue.arrayOf(ue.object).isRequired,
  expand: ue.oneOfType([ue.element, ue.elementType]),
  hasBulkActions: ue.bool.isRequired,
  hover: ue.bool,
  onToggleItem: ue.func,
  resource: ue.string,
  row: ue.element,
  rowClick: ue.oneOfType([ue.string, ue.func]),
  rowStyle: ue.func,
  selectedIds: ue.arrayOf(ue.any),
  styles: ue.object,
  isRowSelectable: ue.func
};
bn.defaultProps = {
  data: [],
  hasBulkActions: !1,
  row: ur.createElement(cl, null)
};
bn.muiName = "TableBody";
var hn = uv(bn);
hn.muiName = "TableBody";
hn.defaultProps = {
  row: ur.createElement($a, null)
};
var ml = bn;
l();
import * as fr from "react";
import { styled as gv } from "@mui/material/styles";
import { memo as yv } from "react";
import eo from "prop-types";
import bv from "clsx";
import { TableCell as hv, TableSortLabel as Rv, Tooltip as Tv } from "@mui/material";
import { FieldTitle as Vm, useTranslate as Pv, useResourceContext as xv } from "ra-core";

var _m = n(function (e) {
  var m = e,
      t = m.className,
      o = m.field,
      r = m.sort,
      a = m.updateSort,
      s = m.isSorting,
      p = f(m, ["className", "field", "sort", "updateSort", "isSorting"]),
      c = xv(e),
      d = Pv();
  return fr.createElement(Cv, i({
    className: bv(t, o.props.headerClassName),
    align: o.props.textAlign,
    variant: "head"
  }, p), a && o.props.sortable !== !1 && (o.props.sortBy || o.props.source) ? fr.createElement(Tv, {
    title: d("ra.action.sort"),
    placement: o.props.textAlign === "right" ? "bottom-end" : "bottom-start",
    enterDelay: 300
  }, fr.createElement(Rv, {
    active: r.field === (o.props.sortBy || o.props.source),
    direction: r.order === "ASC" ? "asc" : "desc",
    "data-field": o.props.sortBy || o.props.source,
    "data-order": o.props.sortByOrder || "ASC",
    onClick: a,
    classes: zm
  }, fr.createElement(Vm, {
    label: o.props.label,
    source: o.props.source,
    resource: c
  }))) : fr.createElement(Vm, {
    label: o.props.label,
    source: o.props.source,
    resource: c
  }));
}, "DatagridHeaderCell");

_m.propTypes = {
  className: eo.string,
  field: eo.element,
  sort: eo.shape({
    field: eo.string,
    order: eo.string
  }).isRequired,
  isSorting: eo.bool,
  resource: eo.string,
  updateSort: eo.func
};
var dl = yv(_m, function (e, t) {
  return e.updateSort === t.updateSort && e.sort.field === t.sort.field && e.sort.order === t.sort.order && e.isSorting === t.isSorting && e.resource === t.resource;
}),
    Hm = "RaDatagridHeaderCell",
    zm = {
  icon: "".concat(Hm, "-icon")
},
    Cv = gv(hv, {
  name: Hm,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref69) {
  var _ref70;

  var e = _ref69.theme;
  return _ref70 = {}, _defineProperty(_ref70, "& .MuiTableSortLabel-icon", {
    display: "none"
  }), _defineProperty(_ref70, "& .Mui-active .MuiTableSortLabel-icon", {
    display: "inline"
  }), _ref70;
});
l();
import * as Te from "react";
import { memo as Sv } from "react";
import to from "prop-types";
import { Table as Ev, TableCell as gr, TableHead as Nv, TableRow as qm, TableBody as Bv, IconButton as Lv, Checkbox as jm } from "@mui/material";
import kv from "@mui/icons-material/ExpandMore";
import wv from "clsx";
import { useTimeout as Av } from "ra-core";
l();
import * as Wm from "react";
import { styled as vv } from "@mui/material/styles";
var Lo = n(function (e) {
  return Wm.createElement(Fv, {
    className: e.className
  }, "\xA0");
}, "Placeholder"),
    Iv = "RaPlaceholder",
    Fv = vv("span", {
  name: Iv,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref71) {
  var e = _ref71.theme;
  return {
    backgroundColor: e.palette.grey[300],
    display: "flex"
  };
});
var ul = n(function (e, t) {
  return Array.from({
    length: e
  }, function (o, r) {
    return t(r);
  });
}, "times"),
    Um = n(function (_ref72) {
  var e = _ref72.className,
      t = _ref72.expand,
      o = _ref72.hasBulkActions,
      r = _ref72.nbChildren,
      _ref72$nbFakeLines = _ref72.nbFakeLines,
      a = _ref72$nbFakeLines === void 0 ? 5 : _ref72$nbFakeLines,
      s = _ref72.size;
  return Av(1e3) ? Te.createElement(Ev, {
    className: wv($.table, e),
    size: s
  }, Te.createElement(Nv, null, Te.createElement(qm, {
    className: $.row
  }, t && Te.createElement(gr, {
    padding: "none",
    className: $.expandHeader
  }), o && Te.createElement(gr, {
    padding: "checkbox",
    className: $.expandIconCell
  }, Te.createElement(jm, {
    className: "select-all",
    color: "primary",
    checked: !1
  })), ul(r, function (c) {
    return Te.createElement(gr, {
      variant: "head",
      className: $.headerCell,
      key: c
    }, Te.createElement(Lo, null));
  }))), Te.createElement(Bv, null, ul(a, function (c) {
    return Te.createElement(qm, {
      key: c,
      style: {
        opacity: 1 / (c + 1)
      }
    }, t && Te.createElement(gr, {
      padding: "none",
      className: $.expandIconCell
    }, Te.createElement(Lv, {
      className: $.expandIcon,
      component: "div",
      "aria-hidden": "true",
      size: "large"
    }, Te.createElement(kv, null))), o && Te.createElement(gr, {
      padding: "checkbox",
      className: $.expandIconCell
    }, Te.createElement(jm, {
      className: "select-all",
      color: "primary",
      checked: !1
    })), ul(r, function (d) {
      return Te.createElement(gr, {
        className: $.rowCell,
        key: d
      }, Te.createElement(Lo, null));
    }));
  }))) : null;
}, "DatagridLoading");
Um.propTypes = {
  className: to.string,
  expand: to.oneOfType([to.element, to.elementType]),
  hasBulkActions: to.bool,
  nbChildren: to.number,
  nbFakeLines: to.number,
  size: to.oneOf(["small", "medium"])
};
var fl = Sv(Um);
l();
import * as ot from "react";
import { cloneElement as sI, createElement as iI, isValidElement as Km, useCallback as lI, useRef as pI, useEffect as cI, useMemo as mI } from "react";
import G from "prop-types";
import { sanitizeListRestProps as dI, useListContext as uI } from "ra-core";
import { Table as fI } from "@mui/material";
import gI from "clsx";
import yI from "lodash/union";
import bI from "lodash/difference";
l();
import * as ko from "react";
import { Children as $v, isValidElement as Ov, useCallback as Xm } from "react";
import Ie from "prop-types";
import { useListContext as Dv, useResourceContext as Mv, useTranslate as Vv } from "ra-core";
import { Checkbox as _v, TableCell as Qm, TableHead as Hv, TableRow as zv } from "@mui/material";
import Oa from "clsx";
var Da = n(function (e) {
  var t = e.children,
      o = e.className,
      _e$hasExpand = e.hasExpand,
      r = _e$hasExpand === void 0 ? !1 : _e$hasExpand,
      _e$hasBulkActions = e.hasBulkActions,
      a = _e$hasBulkActions === void 0 ? !1 : _e$hasBulkActions,
      s = e.isRowSelectable,
      p = Mv(e),
      c = Vv(),
      _Dv = Dv(e),
      d = _Dv.sort,
      m = _Dv.data,
      u = _Dv.onSelect,
      g = _Dv.selectedIds,
      y = _Dv.setSort,
      b = Xm(function (C) {
    C.stopPropagation();
    var v = C.currentTarget.dataset.field,
        I = d.field === v ? d.order === "ASC" ? "DESC" : "ASC" : C.currentTarget.dataset.order;
    y({
      field: v,
      order: I
    });
  }, [d.field, d.order, y]),
      P = y ? b : null,
      T = Xm(function (C) {
    return u(C.target.checked ? g.concat(m.filter(function (v) {
      return !g.includes(v.id);
    }).filter(function (v) {
      return s ? s(v) : !0;
    }).map(function (v) {
      return v.id;
    })) : []);
  }, [m, u, s, g]),
      x = Array.isArray(m) ? s ? m.filter(function (C) {
    return s(C);
  }).map(function (C) {
    return C.id;
  }) : m.map(function (C) {
    return C.id;
  }) : [];

  return ko.createElement(Hv, {
    className: Oa(o, $.thead)
  }, ko.createElement(zv, {
    className: Oa($.row, $.headerRow)
  }, r && ko.createElement(Qm, {
    padding: "none",
    className: Oa($.headerCell, $.expandHeader)
  }), a && g && ko.createElement(Qm, {
    padding: "checkbox",
    className: $.headerCell
  }, ko.createElement(_v, {
    "aria-label": c("ra.action.select_all", {
      _: "Select all"
    }),
    className: "select-all",
    color: "primary",
    checked: g.length > 0 && x.length > 0 && x.every(function (C) {
      return g.includes(C);
    }),
    onChange: T
  })), $v.map(t, function (C, v) {
    return Ov(C) ? ko.createElement(dl, {
      className: Oa($.headerCell, "column-".concat(C.props.source)),
      sort: d,
      field: C,
      isSorting: d.field === (C.props.sortBy || C.props.source),
      key: C.props.source || v,
      resource: p,
      updateSort: P
    }) : null;
  })));
}, "DatagridHeader");
Da.propTypes = {
  children: Ie.node,
  className: Ie.string,
  sort: Ie.exact({
    field: Ie.string,
    order: Ie.string
  }),
  data: Ie.arrayOf(Ie.any),
  hasExpand: Ie.bool,
  hasBulkActions: Ie.bool,
  isRowSelectable: Ie.func,
  isRowExpandable: Ie.func,
  onSelect: Ie.func,
  onToggleItem: Ie.func,
  resource: Ie.string,
  selectedIds: Ie.arrayOf(Ie.any),
  setSort: Ie.func
};
Da.displayName = "DatagridHeader";
l();
import Wv from "react";
var qv = n(function (_ref73) {
  var e = _ref73.children,
      t = _ref73.value;
  return Wv.createElement(wa.Provider, {
    value: t
  }, e);
}, "DatagridContextProvider"),
    Gm = qv;
l();
import * as oo from "react";
import { Children as jv, cloneElement as Uv, isValidElement as Xv, useCallback as Qv } from "react";
import Jm from "prop-types";
import { styled as Gv } from "@mui/material/styles";
import Jv from "clsx";
import Kv from "@mui/material/Toolbar";
import Yv from "@mui/material/Typography";
import { lighten as Zv } from "@mui/material/styles";
import eI from "@mui/material/IconButton";
import tI from "@mui/icons-material/Close";
import { useTranslate as oI, sanitizeListRestProps as rI, useListContext as nI } from "ra-core";
var gl = n(function (e) {
  var g = e,
      _g$label2 = g.label,
      t = _g$label2 === void 0 ? "ra.action.bulk_actions" : _g$label2,
      o = g.children,
      r = g.className,
      a = f(g, ["label", "children", "className"]),
      _nI = nI(e),
      s = _nI.filterValues,
      p = _nI.resource,
      _nI$selectedIds = _nI.selectedIds,
      c = _nI$selectedIds === void 0 ? [] : _nI$selectedIds,
      d = _nI.onUnselectItems,
      m = oI(),
      u = Qv(function () {
    d();
  }, [d]);

  return oo.createElement(aI, {
    className: r
  }, oo.createElement(Kv, i({
    "data-test": "bulk-actions-toolbar",
    className: Jv(pt.toolbar, _defineProperty({}, pt.collapsed, c.length === 0))
  }, rI(a)), oo.createElement("div", {
    className: pt.title
  }, oo.createElement(eI, {
    className: pt.icon,
    "aria-label": m("ra.action.unselect"),
    title: m("ra.action.unselect"),
    onClick: u,
    size: "small"
  }, oo.createElement(tI, {
    fontSize: "small"
  })), oo.createElement(Yv, {
    color: "inherit",
    variant: "subtitle1"
  }, m(t, {
    _: t,
    smart_count: c.length
  }))), oo.createElement(xt, {
    className: pt.topToolbar
  }, jv.map(o, function (y) {
    return Xv(y) ? Uv(y, {
      filterValues: s,
      resource: p,
      selectedIds: c
    }) : null;
  }))));
}, "BulkActionsToolbar");
gl.propTypes = {
  children: Jm.node,
  label: Jm.string
};
var wo = "RaBulkActionsToolbar",
    pt = {
  toolbar: "".concat(wo, "-toolbar"),
  topToolbar: "".concat(wo, "-topToolbar"),
  buttons: "".concat(wo, "-buttons"),
  collapsed: "".concat(wo, "-collapsed"),
  title: "".concat(wo, "-title"),
  icon: "".concat(wo, "-icon")
},
    aI = Gv("div", {
  name: wo,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref74) {
  var _ref75;

  var e = _ref74.theme;
  return _ref75 = {
    position: "relative"
  }, _defineProperty(_ref75, "& .".concat(pt.toolbar), {
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: 3,
    color: e.palette.mode === "light" ? e.palette.primary.main : e.palette.text.primary,
    justifyContent: "space-between",
    backgroundColor: e.palette.mode === "light" ? Zv(e.palette.primary.light, .8) : e.palette.primary.dark,
    minHeight: e.spacing(6),
    height: e.spacing(6),
    transform: "translateY(-".concat(e.spacing(6), ")"),
    transition: "".concat(e.transitions.create("height"), ", ").concat(e.transitions.create("min-height"), ", ").concat(e.transitions.create("transform")),
    borderTopLeftRadius: e.shape.borderRadius,
    borderTopRightRadius: e.shape.borderRadius
  }), _defineProperty(_ref75, "& .".concat(pt.topToolbar), {
    paddingBottom: 0,
    minHeight: "auto"
  }), _defineProperty(_ref75, "& .".concat(pt.buttons), {}), _defineProperty(_ref75, "& .".concat(pt.collapsed), {
    minHeight: 0,
    height: 0,
    transform: "translateY(0)",
    overflowY: "hidden"
  }), _defineProperty(_ref75, "& .".concat(pt.title), {
    display: "flex",
    flex: "0 0 auto"
  }), _defineProperty(_ref75, "& .".concat(pt.icon), {
    marginLeft: "-0.5em",
    marginRight: "0.5em"
  }), _ref75;
});
var Ym = ot.createElement(Xs, null),
    ro = ot.forwardRef(function (e, t) {
  var _ = e,
      _$optimized = _.optimized,
      o = _$optimized === void 0 ? !1 : _$optimized,
      _$body = _.body,
      r = _$body === void 0 ? o ? hn : ml : _$body,
      _$header = _.header,
      a = _$header === void 0 ? Da : _$header,
      s = _.children,
      p = _.className,
      c = _.empty,
      d = _.expand,
      _$bulkActionButtons = _.bulkActionButtons,
      m = _$bulkActionButtons === void 0 ? Ym : _$bulkActionButtons,
      u = _.hover,
      g = _.isRowSelectable,
      y = _.isRowExpandable,
      b = _.resource,
      P = _.rowClick,
      T = _.rowStyle,
      _$size = _.size,
      x = _$size === void 0 ? "small" : _$size,
      C = _.sx,
      _$expandSingle = _.expandSingle,
      v = _$expandSingle === void 0 ? !1 : _$expandSingle,
      I = f(_, ["optimized", "body", "header", "children", "className", "empty", "expand", "bulkActionButtons", "hover", "isRowSelectable", "isRowExpandable", "resource", "rowClick", "rowStyle", "size", "sx", "expandSingle"]),
      _uI = uI(e),
      N = _uI.sort,
      F = _uI.data,
      S = _uI.isLoading,
      L = _uI.onSelect,
      k = _uI.onToggleItem,
      B = _uI.selectedIds,
      M = _uI.setSort,
      z = _uI.total,
      A = !!m,
      W = mI(function () {
    return {
      isRowExpandable: y,
      expandSingle: v
    };
  }, [y, v]),
      D = pI(null);

  cI(function () {
    (!B || B.length === 0) && (D.current = null);
  }, [JSON.stringify(B)]);
  var V = lI(function (w, O) {
    var te = F.map(function (ce) {
      return ce.id;
    }),
        oe = te.indexOf(D.current);

    if (D.current = O.target.checked ? w : null, O.shiftKey && oe !== -1) {
      var ce = te.indexOf(w),
          re = te.slice(Math.min(oe, ce), Math.max(oe, ce) + 1),
          le = O.target.checked ? yI(B, re) : bI(B, re);
      L(g ? le.filter(function (He) {
        return g(F.find(function (Q) {
          return Q.id === He;
        }));
      }) : le);
    } else k(w);
  }, [F, g, L, k, B]);
  return S === !0 ? ot.createElement(fl, {
    className: p,
    expand: d,
    hasBulkActions: A,
    nbChildren: ot.Children.count(s),
    size: x
  }) : F.length === 0 || z === 0 ? c || null : ot.createElement(Gm, {
    value: W
  }, ot.createElement(km, {
    sx: C
  }, m !== !1 ? ot.createElement(gl, {
    selectedIds: B
  }, Km(m) ? m : Ym) : null, ot.createElement("div", {
    className: $.tableWrapper
  }, ot.createElement(fI, i({
    ref: t,
    className: gI($.table, p),
    size: x
  }, RI(I)), Zm(a, {
    children: s,
    sort: N,
    data: F,
    hasExpand: !!d,
    hasBulkActions: A,
    isRowSelectable: g,
    onSelect: L,
    resource: b,
    selectedIds: B,
    setSort: M
  }, s), Zm(r, {
    expand: d,
    rowClick: P,
    data: F,
    hasBulkActions: A,
    hover: u,
    onToggleItem: V,
    resource: b,
    rowStyle: T,
    selectedIds: B,
    isRowSelectable: g
  }, s)))));
}),
    Zm = n(function (e, t, o) {
  return Km(e) ? sI(e, t, o) : iI(e, t, o);
}, "createOrCloneElement");
ro.propTypes = {
  body: G.oneOfType([G.element, G.elementType]),
  bulkActionButtons: G.oneOfType([G.bool, G.element]),
  children: G.node.isRequired,
  className: G.string,
  sort: G.exact({
    field: G.string,
    order: G.string
  }),
  data: G.arrayOf(G.any),
  empty: G.element,
  expand: G.oneOfType([G.element, G.elementType]),
  header: G.oneOfType([G.element, G.elementType]),
  hover: G.bool,
  isLoading: G.bool,
  onSelect: G.func,
  onToggleItem: G.func,
  resource: G.string,
  rowClick: G.oneOfType([G.string, G.func]),
  rowStyle: G.func,
  selectedIds: G.arrayOf(G.any),
  setSort: G.func,
  total: G.number,
  isRowSelectable: G.func,
  isRowExpandable: G.func,
  expandSingle: G.bool
};
var hI = ["isRequired", "setFilter", "setPagination", "limitChoicesToValue", "translateChoice", "field", "fieldState", "formState"],
    RI = n(function (e) {
  return Object.keys(dI(e)).filter(function (t) {
    return !hI.includes(t);
  }).reduce(function (t, o) {
    return E(i({}, t), _defineProperty({}, o, e[o]));
  }, {});
}, "sanitizeRestProps");
ro.displayName = "Datagrid";
l();
import * as za from "react";
import { Children as vF } from "react";
import Fl from "prop-types";
l();
import * as yr from "react";
import { useEffect as Rl, useCallback as SI, useContext as EI } from "react";
import $o from "prop-types";
import { styled as NI } from "@mui/material/styles";
import { useListContext as od, useResourceContext as BI } from "ra-core";
import { FormProvider as LI, useForm as kI, useFormContext as wI } from "react-hook-form";
import AI from "lodash/set";
import $I from "lodash/unset";
import Rn from "lodash/get";
import rd from "lodash/cloneDeep";
l();
import * as Ao from "react";
import { styled as TI } from "@mui/material/styles";
import yl from "prop-types";
import PI from "@mui/material/IconButton";
import xI from "@mui/icons-material/HighlightOff";
import ed from "clsx";
import { useResourceContext as CI, useTranslate as vI } from "ra-core";
var bl = n(function (e) {
  var t = e.filterElement,
      o = e.handleHide,
      r = e.className,
      a = CI(e),
      s = vI();
  return Ao.createElement(II, {
    "data-source": t.props.source,
    className: ed("filter-field", r)
  }, !t.props.alwaysOn && Ao.createElement(PI, {
    className: ed("hide-filter", Ma.hideButton),
    onClick: o,
    "data-key": t.props.source,
    title: s("ra.action.remove_filter"),
    size: "small"
  }, Ao.createElement(xI, null)), Ao.cloneElement(t, {
    resource: a,
    record: FI,
    size: "small",
    helperText: !1,
    defaultValue: void 0
  }), Ao.createElement("div", {
    className: Ma.spacer
  }, "\xA0"));
}, "FilterFormInput");
bl.propTypes = {
  filterElement: yl.node,
  handleHide: yl.func,
  resource: yl.string
};
var hl = "RaFilterFormInput",
    Ma = {
  spacer: "".concat(hl, "-spacer"),
  hideButton: "".concat(hl, "-hideButton")
},
    II = TI("div", {
  name: hl,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref76) {
  var _ref77;

  var e = _ref76.theme;
  return _ref77 = {
    display: "flex",
    alignItems: "flex-end",
    pointerEvents: "auto"
  }, _defineProperty(_ref77, "& .".concat(Ma.spacer), {
    width: e.spacing(2)
  }), _defineProperty(_ref77, "& .".concat(Ma.hideButton), {
    marginBottom: e.spacing(1)
  }), _ref77;
}),
    FI = {};
l();
import * as td from "react";
var rt = td.createContext(void 0);
var br = n(function (e) {
  var u = e,
      t = u.defaultValues,
      o = u.filters,
      r = f(u, ["defaultValues", "filters"]),
      _od = od(e),
      a = _od.setFilters,
      s = _od.displayedFilters,
      p = _od.filterValues,
      c = EI(rt) || o,
      d = MI(t || p, c),
      m = kI({
    defaultValues: d
  });

  return Rl(function () {
    var g = HI(m.getValues(), p);
    m.reset(g);
  }, [p, m]), Rl(function () {
    var g = m.watch( /*#__PURE__*/function () {
      var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(y, _ref78) {
        var b, P, x;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                b = _ref78.name, P = _ref78.type;
                _context6.next = 3;
                return m.trigger();

              case 3:
                if (!_context6.sent) {
                  _context6.next = 5;
                  break;
                }

                if (Rn(y, b) === "") {
                  x = rd(y);
                  $I(x, b), a(x, s);
                } else a(y, s);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6, _x7) {
        return _ref79.apply(this, arguments);
      };
    }());
    return function () {
      return g.unsubscribe();
    };
  }, [s, m, a]), yr.createElement(LI, i({}, m), yr.createElement(nd, i({
    onSubmit: VI,
    filters: c
  }, r)));
}, "FilterForm"),
    nd = n(function (e) {
  var u = e,
      t = u.className,
      o = u.filters,
      r = f(u, ["className", "filters"]),
      a = BI(e),
      s = wI(),
      _od2 = od(e),
      _od2$displayedFilters = _od2.displayedFilters,
      p = _od2$displayedFilters === void 0 ? {} : _od2$displayedFilters,
      c = _od2.hideFilter;

  Rl(function () {
    o.forEach(function (g) {
      if (g.props.alwaysOn && g.props.defaultValue) throw new Error("Cannot use alwaysOn and defaultValue on a filter input. Please set the filterDefaultValues props on the <List> element instead.");
    });
  }, [o]);
  var d = n(function () {
    var g = s.getValues();
    return o.filter(function (y) {
      var b = Rn(g, y.props.source);
      return y.props.alwaysOn || p[y.props.source] || b !== "" && typeof b != "undefined";
    });
  }, "getShownFilters"),
      m = SI(function (g) {
    return c(g.currentTarget.dataset.key);
  }, [c]);
  return yr.createElement(_I, E(i({
    className: t
  }, DI(r)), {
    onSubmit: OI
  }), d().map(function (g) {
    return yr.createElement(bl, {
      key: g.props.source,
      filterElement: g,
      handleHide: m,
      resource: a
    });
  }), yr.createElement("div", {
    className: sd.clearFix
  }));
}, "FilterFormBase"),
    OI = n(function (e) {
  return e.preventDefault(), !1;
}, "handleSubmit");
nd.propTypes = {
  resource: $o.string,
  filters: $o.arrayOf($o.node).isRequired,
  displayedFilters: $o.object,
  hideFilter: $o.func,
  initialValues: $o.object,
  className: $o.string
};

var DI = n(function (c) {
  var d = c,
      e = d.displayedFilters,
      t = d.filterValues,
      o = d.hasCreate,
      r = d.hideFilter,
      a = d.setFilters,
      s = d.resource,
      p = f(d, ["displayedFilters", "filterValues", "hasCreate", "hideFilter", "setFilters", "resource"]);
  return p;
}, "sanitizeRestProps"),
    MI = n(function (e, t) {
  return i(i({}, t.filter(function (o) {
    return o.props.alwaysOn && o.props.defaultValue;
  }).reduce(function (o, r) {
    return AI(i({}, o), r.props.source, r.props.defaultValue);
  }, {})), e);
}, "mergeInitialValuesWithDefaultValues"),
    VI = n(function () {}, "handleFormSubmit"),
    ad = "RaFilterForm",
    sd = {
  clearFix: "".concat(ad, "-clearFix")
},
    _I = NI("form", {
  name: ad,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref80) {
  var _ref81;

  var e = _ref80.theme;
  return _ref81 = {
    marginTop: e.spacing(-.5),
    marginBottom: e.spacing(.5),
    minHeight: e.spacing(8),
    display: "flex",
    alignItems: "flex-end",
    flexWrap: "wrap",
    pointerEvents: "none"
  }, _defineProperty(_ref81, "& .".concat(sd.clearFix), {
    clear: "right"
  }), _defineProperty(_ref81, "& .MuiFormHelperText-root", {
    display: "none"
  }), _ref81;
}),
    HI = n(function (e, t) {
  var o;
  return Object.keys(e).reduce(function (r, a) {
    return r[a] = id(e, a, t), r;
  }, (o = rd(t)) != null ? o : {});
}, "getFilterFormValues"),
    id = n(function (e, t, o) {
  return e[t] === void 0 || e[t] === null ? "" : Array.isArray(e[t]) ? Rn(o, t, "") : e[t] instanceof Date ? Rn(o, t, "") : typeof e[t] == "object" ? Object.keys(e[t]).reduce(function (r, a) {
    var s;
    return r[a] = id(e[t], a, (s = (o || {})[t]) != null ? s : {}), r;
  }, {}) : Rn(o, t, "");
}, "getInputValue");

l();
import * as ct from "react";
import { useState as xl, useCallback as Cl, useRef as cF, useContext as mF } from "react";
import Oo from "prop-types";
import { Menu as dF, MenuItem as vl, styled as uF } from "@mui/material";
import fF from "@mui/icons-material/FilterList";
import gF from "lodash/get";
import Il from "lodash/isEqual";
import { useListContext as yF, useResourceContext as bF, useTranslate as hF } from "ra-core";
import { stringify as RF } from "query-string";
import { useNavigate as TF } from "react-router";
l();
import * as Tl from "react";
import { forwardRef as zI, useCallback as WI } from "react";
import Va from "prop-types";
import qI from "@mui/material/MenuItem";
import { FieldTitle as jI, useResourceContext as UI } from "ra-core";
var Pl = zI(function (e, t) {
  var o = e.filter,
      r = e.onShow,
      a = e.autoFocus,
      s = UI(e),
      p = WI(function () {
    r({
      source: o.props.source,
      defaultValue: o.props.defaultValue
    });
  }, [o.props.defaultValue, o.props.source, r]);
  return Tl.createElement(qI, {
    className: "new-filter-item",
    "data-key": o.props.source,
    "data-default-value": o.props.defaultValue,
    key: o.props.source,
    onClick: p,
    autoFocus: a,
    ref: t,
    disabled: o.props.disabled
  }, Tl.createElement(jI, {
    label: o.props.label,
    source: o.props.source,
    resource: s
  }));
});
Pl.propTypes = {
  filter: Va.element.isRequired,
  onShow: Va.func.isRequired,
  resource: Va.string,
  autoFocus: Va.bool
};
l();
import { useStore as XI } from "ra-core";
var no = n(function (e) {
  return XI("".concat(e, ".savedQueries"), []);
}, "useSavedQueries"),
    ao = n(function (e) {
  return Array.isArray(e) ? e.filter(function (t) {
    return ld(t);
  }) : [];
}, "extractValidSavedQueries"),
    EG = n(function (e) {
  if (Array.isArray(e) && e.every(function (t) {
    return ld(t);
  })) return !0;
}, "areValidSavedQueries"),
    ld = n(function (e) {
  var t, o;
  return !!(e.label && typeof e.label == "string" && e.value && typeof Array.isArray(e.value.displayedFilters) && typeof e.value.perPage == "number" && typeof ((t = e.value.sort) == null ? void 0 : t.field) == "string" && typeof ((o = e.value.sort) == null ? void 0 : o.order) == "string" && typeof e.value.filter == "object");
}, "isValidSavedQuery");
l();
import * as Ht from "react";
import { useState as QI } from "react";
import { useListContext as GI, useTranslate as JI } from "ra-core";
import { Button as pd, Dialog as KI, DialogActions as YI, DialogContent as ZI, DialogTitle as eF, TextField as tF } from "@mui/material";

var _a = n(function (_ref82) {
  var e = _ref82.open,
      t = _ref82.onClose;

  var o = JI(),
      _GI = GI(),
      r = _GI.resource,
      a = _GI.filterValues,
      s = _GI.displayedFilters,
      p = _GI.sort,
      c = _GI.perPage,
      _no = no(r),
      _no2 = _slicedToArray(_no, 2),
      d = _no2[0],
      m = _no2[1],
      _QI = QI(""),
      _QI2 = _slicedToArray(_QI, 2),
      u = _QI2[0],
      g = _QI2[1],
      y = n(function (T) {
    g(T.target.value);
  }, "handleQueryNameChange"),
      b = n(function (T) {
    T.preventDefault(), P();
  }, "handleFormSubmit"),
      P = n(function () {
    var T = {
      label: u,
      value: {
        filter: a,
        sort: p,
        perPage: c,
        displayedFilters: s
      }
    },
        x = ao(d);
    m(x.concat(T)), g(""), t();
  }, "addQuery");

  return Ht.createElement(KI, {
    open: e,
    onClose: t,
    "aria-labelledby": "form-dialog-title"
  }, Ht.createElement(eF, {
    id: "form-dialog-title"
  }, o("ra.saved_queries.new_dialog_title", {
    _: "Save current query as"
  })), Ht.createElement(ZI, null, Ht.createElement("form", {
    onSubmit: b
  }, Ht.createElement(tF, {
    autoFocus: !0,
    margin: "dense",
    id: "name",
    label: o("ra.saved_queries.query_name", {
      _: "Query name"
    }),
    fullWidth: !0,
    value: u,
    onChange: y
  }))), Ht.createElement(YI, null, Ht.createElement(pd, {
    onClick: t
  }, o("ra.action.cancel")), Ht.createElement(pd, {
    onClick: P,
    color: "primary"
  }, o("ra.action.save"))));
}, "AddSavedQueryDialog");

l();
import * as so from "react";
import oF from "lodash/isEqual";
import { useListContext as rF, useTranslate as nF } from "ra-core";
import { Button as cd, Dialog as aF, DialogActions as sF, DialogContent as iF, DialogContentText as lF, DialogTitle as pF } from "@mui/material";
var Ha = n(function (_ref83) {
  var e = _ref83.open,
      t = _ref83.onClose;

  var o = nF(),
      _rF = rF(),
      r = _rF.resource,
      a = _rF.filterValues,
      s = _rF.sort,
      p = _rF.perPage,
      c = _rF.displayedFilters,
      _no3 = no(r),
      _no4 = _slicedToArray(_no3, 2),
      d = _no4[0],
      m = _no4[1],
      u = n(function () {
    var g = {
      filter: a,
      sort: s,
      perPage: p,
      displayedFilters: c
    },
        y = ao(d),
        b = y.findIndex(function (P) {
      return oF(P.value, g);
    });
    m([].concat(_toConsumableArray(y.slice(0, b)), _toConsumableArray(y.slice(b + 1)))), t();
  }, "removeQuery");

  return so.createElement(aF, {
    open: e,
    onClose: t,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, so.createElement(pF, {
    id: "alert-dialog-title"
  }, o("ra.saved_queries.remove_dialog_title", {
    _: "Remove saved query?"
  })), so.createElement(iF, null, so.createElement(lF, null, o("ra.saved_queries.remove_message", {
    _: "Are you sure you want to remove that item from your list of saved queries?"
  }))), so.createElement(sF, null, so.createElement(cd, {
    onClick: t
  }, o("ra.action.cancel")), so.createElement(cd, {
    onClick: u,
    color: "primary",
    autoFocus: !0
  }, o("ra.action.confirm"))));
}, "RemoveSavedQueryDialog");
var Do = n(function (e) {
  var _ = e,
      t = _.filters,
      o = _.className,
      r = f(_, ["filters", "className"]),
      a = mF(rt) || t,
      s = bF(e),
      p = hF(),
      _no5 = no(s),
      _no6 = _slicedToArray(_no5, 1),
      c = _no6[0],
      d = TF(),
      _yF = yF(e),
      _yF$displayedFilters = _yF.displayedFilters,
      m = _yF$displayedFilters === void 0 ? {} : _yF$displayedFilters,
      u = _yF.filterValues,
      g = _yF.perPage,
      y = _yF.showFilter,
      b = _yF.sort,
      P = !Il(u, {}),
      T = ao(c),
      x = T.some(function (w) {
    return Il(w.value, {
      filter: u,
      sort: b,
      perPage: g,
      displayedFilters: m
    });
  }),
      _xl = xl(!1),
      _xl2 = _slicedToArray(_xl, 2),
      C = _xl2[0],
      v = _xl2[1],
      I = cF();

  if (a === void 0) throw new Error("FilterButton requires filters prop to be set");

  var N = a.filter(function (w) {
    return !w.props.alwaysOn && !m[w.props.source] && typeof gF(u, w.props.source) == "undefined";
  }),
      F = Cl(function (w) {
    w.preventDefault(), v(!0), I.current = w.currentTarget;
  }, [I, v]),
      S = Cl(function () {
    v(!1);
  }, [v]),
      L = Cl(function (_ref84) {
    var w = _ref84.source,
        O = _ref84.defaultValue;
    y(w, O === "" ? void 0 : O), v(!1);
  }, [y, v]),
      _xl3 = xl(!1),
      _xl4 = _slicedToArray(_xl3, 2),
      k = _xl4[0],
      B = _xl4[1],
      M = n(function () {
    B(!1);
  }, "hideAddSavedQueryDialog"),
      z = n(function () {
    v(!1), B(!0);
  }, "showAddSavedQueryDialog"),
      _xl5 = xl(!1),
      _xl6 = _slicedToArray(_xl5, 2),
      A = _xl6[0],
      W = _xl6[1],
      D = n(function () {
    W(!1);
  }, "hideRemoveSavedQueryDialog"),
      V = n(function () {
    v(!1), W(!0);
  }, "showRemoveSavedQueryDialog");

  return ct.createElement(CF, i({
    className: o
  }, PF(r)), ct.createElement(U, {
    className: "add-filter",
    label: "ra.action.add_filter",
    "aria-haspopup": "true",
    onClick: F
  }, ct.createElement(fF, null)), ct.createElement(dF, {
    open: C,
    anchorEl: I.current,
    onClose: S
  }, N.map(function (w, O) {
    return ct.createElement(Pl, {
      key: w.props.source,
      filter: w,
      resource: s,
      onShow: L,
      autoFocus: O === 0
    });
  }), T.map(function (w, O) {
    return Il(w.value, {
      filter: u,
      sort: b,
      perPage: g,
      displayedFilters: m
    }) ? ct.createElement(vl, {
      onClick: V,
      key: O
    }, p("ra.saved_queries.remove_label_with_name", {
      _: 'Remove query "%{name}"',
      name: w.label
    })) : ct.createElement(vl, {
      onClick: function onClick() {
        d({
          search: RF({
            filter: JSON.stringify(w.value.filter),
            sort: w.value.sort.field,
            order: w.value.sort.order,
            page: 1,
            perPage: w.value.perPage,
            displayedFilters: JSON.stringify(w.value.displayedFilters)
          })
        }), v(!1);
      },
      key: O
    }, w.label);
  }), P && !x ? ct.createElement(vl, {
    onClick: z
  }, p("ra.saved_queries.new_label", {
    _: "Save current query..."
  })) : null), ct.createElement(_a, {
    open: k,
    onClose: M
  }), ct.createElement(Ha, {
    open: A,
    onClose: D
  }));
}, "FilterButton"),
    PF = n(function (a) {
  var s = a,
      _s$displayedFilters = s.displayedFilters,
      e = _s$displayedFilters === void 0 ? null : _s$displayedFilters,
      _s$filterValues = s.filterValues,
      t = _s$filterValues === void 0 ? null : _s$filterValues,
      _s$showFilter = s.showFilter,
      o = _s$showFilter === void 0 ? null : _s$showFilter,
      r = f(s, ["displayedFilters", "filterValues", "showFilter"]);
  return r;
}, "sanitizeRestProps");
Do.propTypes = {
  resource: Oo.string,
  filters: Oo.arrayOf(Oo.node),
  displayedFilters: Oo.object,
  filterValues: Oo.object,
  showFilter: Oo.func,
  className: Oo.string
};
var xF = "RaFilterButton",
    CF = uF("div", {
  name: xF,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref85) {
  var e = _ref85.theme;
  return {
    display: "inline-block"
  };
});
var IF = n(function (e) {
  var t = e.children,
      o = n(function () {
    return za.createElement(Do, {
      className: dd.button
    });
  }, "renderButton"),
      r = n(function () {
    return za.createElement(br, {
      className: dd.form
    });
  }, "renderForm");
  return za.createElement(rt.Provider, {
    value: vF.toArray(t)
  }, e.context === "button" ? o() : r());
}, "Filter");
IF.propTypes = {
  children: Fl.node,
  classes: Fl.object,
  context: Fl.oneOf(["form", "button"])
};
var md = "RaFilter",
    dd = {
  button: "".concat(md, "-button"),
  form: "".concat(md, "-form")
};
l();
import * as hr from "react";
import { Box as Sl, List as FF, Typography as SF } from "@mui/material";
import { useTranslate as EF } from "ra-core";
var ud = n(function (e) {
  var p = e,
      t = p.label,
      o = p.icon,
      r = p.children,
      a = f(p, ["label", "icon", "children"]),
      s = EF();
  return hr.createElement(Sl, i({}, a), hr.createElement(Sl, {
    mt: 2,
    display: "flex",
    alignItems: "center"
  }, hr.createElement(Sl, {
    mr: 1
  }, o), hr.createElement(SF, {
    variant: "overline"
  }, s(t))), hr.createElement(FF, {
    dense: !0,
    disablePadding: !0
  }, r));
}, "FilterList");
l();
import * as Mo from "react";
import { styled as NF } from "@mui/material/styles";
import { memo as BF, isValidElement as LF } from "react";
import { IconButton as kF, ListItem as wF, ListItemButton as AF, ListItemText as $F, ListItemSecondaryAction as OF } from "@mui/material";
import DF from "@mui/icons-material/CancelOutlined";
import { useTranslate as MF, useListFilterContext as VF, shallowEqual as _F } from "ra-core";
import HF from "lodash/matches";
import zF from "lodash/pickBy";
var WF = n(function (e, t) {
  return e.label === t.label && _F(e.value, t.value);
}, "arePropsEqual"),
    S5 = BF(function (e) {
  var g = e,
      t = g.label,
      o = g.value,
      r = f(g, ["label", "value"]),
      _VF = VF(),
      a = _VF.filterValues,
      s = _VF.setFilters,
      p = MF(),
      c = HF(zF(o, function (y) {
    return typeof y != "undefined";
  }))(a),
      d = n(function () {
    s(i(i({}, a), o), null, !1);
  }, "addFilter"),
      m = n(function () {
    var y = Object.keys(o),
        b = Object.keys(a).reduce(function (P, T) {
      return y.includes(T) ? P : E(i({}, P), _defineProperty({}, T, a[T]));
    }, {});
    s(b, null, !1);
  }, "removeFilter"),
      u = n(function () {
    return c ? m() : d();
  }, "toggleFilter");

  return Mo.createElement(qF, i({
    onClick: u,
    selected: c,
    disablePadding: !0
  }, r), Mo.createElement(AF, {
    disableGutters: !0,
    className: Wa.listItemButton
  }, Mo.createElement($F, {
    primary: LF(t) ? t : p(t, {
      _: t
    }),
    className: Wa.listItemText,
    "data-selected": c ? "true" : "false"
  }), c && Mo.createElement(OF, null, Mo.createElement(kF, {
    size: "small",
    onClick: function onClick(y) {
      y.stopPropagation(), u();
    }
  }, Mo.createElement(DF, null)))));
}, WF),
    El = "RaFilterListItem",
    Wa = {
  listItemButton: "".concat(El, "-listItemButton"),
  listItemText: "".concat(El, "-listItemText")
},
    qF = NF(wF, {
  name: El,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref86) {
  var _ref87;

  var e = _ref86.theme;
  return _ref87 = {}, _defineProperty(_ref87, "& .".concat(Wa.listItemButton), {
    paddingRight: "2em",
    paddingLeft: "2em"
  }), _defineProperty(_ref87, "& .".concat(Wa.listItemText), {
    margin: 0
  }), _ref87;
});
l();
import * as Tn from "react";
import { memo as jF, useMemo as UF } from "react";
import { InputAdornment as XF } from "@mui/material";
import QF from "@mui/icons-material/Search";
import { Form as GF, useTranslate as JF, useListFilterContext as KF } from "ra-core";
var $5 = jF(function (e) {
  var g = e,
      _g$source = g.source,
      t = _g$source === void 0 ? "q" : _g$source,
      o = g.variant,
      r = f(g, ["source", "variant"]),
      _KF = KF(),
      a = _KF.filterValues,
      s = _KF.setFilters,
      p = JF(),
      c = n(function (y) {
    if (y.target) s(E(i({}, a), _defineProperty({}, t, y.target.value)), null);else {
      var b = a,
          P = b[t],
          T = f(b, [rc(t)]);
      s(T, null);
    }
  }, "handleChange"),
      d = UF(function () {
    return _defineProperty({}, t, a[t]);
  }, [a, t]),
      m = n(function () {}, "onSubmit"),
      u = p("ra.action.search");

  return Tn.createElement(GF, {
    defaultValues: d,
    onSubmit: m
  }, Tn.createElement(Fe, i(i({
    resettable: !0,
    helperText: !1,
    source: t,
    InputProps: {
      endAdornment: Tn.createElement(XF, {
        position: "end"
      }, Tn.createElement(QF, {
        color: "disabled"
      }))
    },
    onChange: c,
    size: "small"
  }, o === "outlined" ? {
    variant: "outlined",
    label: u
  } : {
    placeholder: u,
    label: !1,
    hiddenLabel: !0
  }), r)));
});
l();
import * as Vo from "react";
import { useState as YF } from "react";
import { IconButton as ZF } from "@mui/material";
import eS from "@mui/icons-material/AddCircleOutline";
import { useTranslate as tS } from "ra-core";
var fd = n(function (e) {
  var _YF = YF(!1),
      _YF2 = _slicedToArray(_YF, 2),
      t = _YF2[0],
      o = _YF2[1],
      r = n(function () {
    o(!0);
  }, "handleOpen"),
      a = n(function () {
    o(!1);
  }, "handleClose"),
      s = tS();

  return Vo.createElement(Vo.Fragment, null, Vo.createElement(ZF, i({
    "aria-label": s("ra.saved_queries.new_label", {
      _: "Save current query..."
    }),
    size: "small",
    onClick: r
  }, e), Vo.createElement(eS, null)), Vo.createElement(_a, {
    open: t,
    onClose: a
  }));
}, "AddSavedQueryIconButton");
l();
import * as _o from "react";
import { useState as oS } from "react";
import { IconButton as rS } from "@mui/material";
import nS from "@mui/icons-material/RemoveCircleOutline";
import { useTranslate as aS } from "ra-core";
var gd = n(function (e) {
  var _oS = oS(!1),
      _oS2 = _slicedToArray(_oS, 2),
      t = _oS2[0],
      o = _oS2[1],
      r = n(function () {
    o(!1);
  }, "handleConfirmationClose"),
      a = n(function () {
    o(!0);
  }, "handleRemoveQueryClick"),
      s = aS();

  return _o.createElement(_o.Fragment, null, _o.createElement(rS, i({
    "aria-label": s("ra.saved_queries.remove_label", {
      _: "Remove saved query"
    }),
    size: "small",
    onClick: a
  }, e), _o.createElement(nS, null)), _o.createElement(Ha, {
    open: t,
    onClose: r
  }));
}, "RemoveSavedQueryIconButton");
l();
import * as io from "react";
import { styled as hS, Tooltip as RS } from "@mui/material";
import TS from "@mui/icons-material/BookmarkBorder";
import PS from "@mui/icons-material/HelpOutline";
import { useListContext as xS, useTranslate as CS } from "ra-core";
import Rd from "lodash/isEqual";
l();
import * as Ho from "react";
import { memo as sS } from "react";
import { IconButton as iS, ListItem as lS, ListItemButton as pS, ListItemText as cS, ListItemSecondaryAction as mS, styled as dS } from "@mui/material";
import uS from "@mui/icons-material/CancelOutlined";
import yd from "lodash/isEqual";
import { useNavigate as fS } from "react-router-dom";
import { stringify as bd } from "query-string";
import { useListContext as gS } from "ra-core";
var yS = n(function (e, t) {
  return e.label === t.label && yd(e.value, t.value);
}, "arePropsEqual"),
    hd = sS(function (e) {
  var t = e.className,
      o = e.label,
      r = e.sx,
      a = e.value,
      _gS = gS(),
      s = _gS.filterValues,
      p = _gS.sort,
      c = _gS.perPage,
      d = _gS.displayedFilters,
      m = fS(),
      u = yd(a, {
    filter: s,
    sort: p,
    perPage: c,
    displayedFilters: d
  }),
      g = n(function () {
    m({
      search: bd({
        filter: JSON.stringify(a.filter),
        sort: a.sort.field,
        order: a.sort.order,
        page: 1,
        perPage: a.perPage,
        displayedFilters: a.displayedFilters
      })
    });
  }, "addFilter"),
      y = n(function () {
    m({
      search: bd({
        filter: JSON.stringify({})
      })
    });
  }, "removeFilter"),
      b = n(function () {
    return u ? y() : g();
  }, "toggleFilter");

  return Ho.createElement(bS, {
    onClick: b,
    selected: u,
    className: t,
    sx: r,
    disablePadding: !0
  }, Ho.createElement(pS, {
    disableGutters: !0,
    className: qa.listItemButton
  }, Ho.createElement(cS, {
    primary: o,
    className: qa.listItemText
  }), u && Ho.createElement(mS, null, Ho.createElement(iS, {
    size: "small",
    onClick: b
  }, Ho.createElement(uS, null)))));
}, yS),
    Nl = "RaSavedQueryFilterListItem",
    qa = {
  listItemButton: "".concat(Nl, "-listItemButton"),
  listItemText: "".concat(Nl, "-listItemText")
},
    bS = dS(lS, {
  name: Nl,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function () {
  var _ref89;

  return _ref89 = {}, _defineProperty(_ref89, "& .".concat(qa.listItemButton), {
    paddingRight: "2em",
    paddingLeft: "2em"
  }), _defineProperty(_ref89, "& .".concat(qa.listItemText), {
    margin: 0
  }), _ref89;
});
var R6 = n(function (_ref90) {
  var _ref90$icon = _ref90.icon,
      e = _ref90$icon === void 0 ? IS : _ref90$icon;

  var t = CS(),
      _xS = xS(),
      o = _xS.resource,
      r = _xS.filterValues,
      a = _xS.displayedFilters,
      s = _xS.sort,
      p = _xS.perPage,
      _no7 = no(o),
      _no8 = _slicedToArray(_no7, 1),
      c = _no8[0],
      d = ao(c),
      m = d.some(function (g) {
    return Rd(g.value, {
      filter: r,
      sort: s,
      perPage: p,
      displayedFilters: a
    });
  }),
      u = !Rd(r, {});

  return io.createElement(vS, {
    label: "ra.saved_queries.label",
    icon: e
  }, m ? io.createElement(gd, {
    className: xn.floatingIcon
  }) : u ? io.createElement(fd, {
    className: xn.floatingIcon
  }) : io.createElement(RS, {
    title: t("ra.saved_queries.help"),
    className: xn.floatingTooltip
  }, io.createElement(PS, null)), d.map(function (g, y) {
    return io.createElement(hd, {
      label: g.label,
      value: g.value,
      key: y
    });
  }));
}, "SavedQueriesList"),
    Pn = "RaSavedQueriesList",
    xn = {
  floatingIcon: "".concat(Pn, "-floatingIcon"),
  floatingTooltip: "".concat(Pn, "-floatingTooltip"),
  titleContainer: "".concat(Pn, "-titleContainer"),
  titleIcon: "".concat(Pn, "-titleIcon")
},
    vS = hS(ud, {
  name: Pn,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref91) {
  var _ref92;

  var e = _ref91.theme;
  return _ref92 = {}, _defineProperty(_ref92, "& .".concat(xn.floatingIcon), {
    position: "absolute",
    top: "-1.8em",
    right: 0
  }), _defineProperty(_ref92, "& .".concat(xn.floatingTooltip), {
    position: "absolute",
    top: "-1.2em",
    right: 3,
    color: e.palette.action.disabled
  }), _ref92;
}),
    IS = io.createElement(TS, null);
l();
import * as Cn from "react";
import { useCallback as Ua, useMemo as OS, memo as DS } from "react";
import kl from "prop-types";
import { TablePagination as xd, Toolbar as MS, useMediaQuery as VS } from "@mui/material";
import { useTranslate as _S, useListPaginationContext as HS, sanitizeListRestProps as Cd, ComponentPropType as zS } from "ra-core";
l();
import * as ja from "react";
import { memo as FS } from "react";
import { styled as SS } from "@mui/material/styles";
import { Pagination as ES } from "@mui/material";
import Rr from "prop-types";
import { useTranslate as NS } from "ra-core";
var Bl = FS(function (e) {
  var g = e,
      t = g.page,
      o = g.rowsPerPage,
      r = g.count,
      a = g.onPageChange,
      _g$size = g.size,
      s = _g$size === void 0 ? "small" : _g$size,
      p = g.className,
      c = f(g, ["page", "rowsPerPage", "count", "onPageChange", "size", "className"]),
      d = NS(),
      m = Math.ceil(r / o) || 1;
  if (m === 1) return ja.createElement(Td, {
    className: p
  });
  var u = n(function (y, b, P) {
    return y === "page" ? P ? d("ra.navigation.current_page", {
      page: b,
      _: "page ".concat(b)
    }) : d("ra.navigation.page", {
      page: b,
      _: "Go to page ".concat(b)
    }) : d("ra.navigation.".concat(y), {
      _: "Go to ".concat(y, " page")
    });
  }, "getItemAriaLabel");
  return ja.createElement(Td, {
    className: p
  }, ja.createElement(ES, E(i({
    size: s,
    count: m,
    page: t + 1,
    onChange: function onChange(y, b) {
      return a(y, b - 1);
    }
  }, LS(c)), {
    getItemAriaLabel: u
  })));
});
Bl.propTypes = {
  count: Rr.number.isRequired,
  onPageChange: Rr.func.isRequired,
  page: Rr.number.isRequired,
  rowsPerPage: Rr.number.isRequired,
  color: Rr.oneOf(["primary", "secondary", "standard"]),
  size: Rr.oneOf(["small", "medium", "large"])
};
var BS = "RaPaginationActions",
    Td = SS("div", {
  name: BS,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref93) {
  var e = _ref93.theme;
  return {
    flexShrink: 0,
    ml: 4
  };
}),
    LS = n(function (r) {
  var a = r,
      e = a.nextIconButtonProps,
      t = a.backIconButtonProps,
      o = f(a, ["nextIconButtonProps", "backIconButtonProps"]);
  return o;
}, "sanitizeRestProps");
l();
import * as Ll from "react";
import { memo as kS } from "react";
import wS from "@mui/material/CardContent";
import AS from "@mui/material/Typography";
import { useTranslate as $S } from "ra-core";
var Pd = kS(function () {
  var e = $S();
  return Ll.createElement(wS, null, Ll.createElement(AS, {
    variant: "body2"
  }, e("ra.navigation.no_results")));
});
var vn = DS(function (e) {
  var N = e,
      _N$rowsPerPageOptions = N.rowsPerPageOptions,
      t = _N$rowsPerPageOptions === void 0 ? qS : _N$rowsPerPageOptions,
      o = N.actions,
      _N$limit = N.limit,
      r = _N$limit === void 0 ? WS : _N$limit,
      a = f(N, ["rowsPerPageOptions", "actions", "limit"]),
      _HS = HS(e),
      s = _HS.isLoading,
      p = _HS.hasNextPage,
      c = _HS.page,
      d = _HS.perPage,
      m = _HS.total,
      u = _HS.setPage,
      g = _HS.setPerPage,
      y = _S(),
      b = VS(function (F) {
    return F.breakpoints.down("md");
  }),
      P = OS(function () {
    return m != null ? Math.ceil(m / d) : void 0;
  }, [d, m]),
      T = Ua(function (F, S) {
    if (F && F.stopPropagation(), S < 0 || S > P - 1) throw new Error(y("ra.navigation.page_out_of_boundaries", {
      page: S + 1
    }));
    u(S + 1);
  }, [P, u, y]),
      x = Ua(function (F) {
    g(F.target.value);
  }, [g]),
      C = Ua(function (_ref94) {
    var F = _ref94.from,
        S = _ref94.to,
        L = _ref94.count;
    return L === -1 && p ? y("ra.navigation.partial_page_range_info", {
      offsetBegin: F,
      offsetEnd: S,
      _: "%{from}-%{to} of more than %{to}"
    }) : y("ra.navigation.page_range_info", {
      offsetBegin: F,
      offsetEnd: S,
      total: L === -1 ? S : L,
      _: "%{from}-%{to} of %{count === -1 ? to : count}"
    });
  }, [y, p]),
      v = Ua(function (F) {
    return y("ra.navigation.".concat(F), {
      _: "Go to ".concat(F, " page")
    });
  }, [y]);

  if (s) return Cn.createElement(MS, {
    variant: "dense"
  });
  if (m === 0 || c < 1 || m != null && c > P) return r;
  if (b) return Cn.createElement(xd, i({
    count: m == null ? -1 : m,
    rowsPerPage: d,
    page: c - 1,
    onPageChange: T,
    rowsPerPageOptions: jS,
    component: "span",
    labelDisplayedRows: C
  }, Cd(a)));
  var I = o || (!s && m != null ? Bl : void 0);
  return Cn.createElement(xd, i({
    count: m == null ? -1 : m,
    rowsPerPage: d,
    page: c - 1,
    onPageChange: T,
    onRowsPerPageChange: x,
    ActionsComponent: I,
    nextIconButtonProps: {
      disabled: !p
    },
    component: "span",
    labelRowsPerPage: y("ra.navigation.page_rows_per_page"),
    labelDisplayedRows: C,
    getItemAriaLabel: v,
    rowsPerPageOptions: t
  }, Cd(a)));
});
vn.propTypes = {
  actions: zS,
  limit: kl.element,
  rowsPerPageOptions: kl.arrayOf(kl.number)
};
var WS = Cn.createElement(Pd, null),
    qS = [5, 10, 25],
    jS = [];
var JS = Le.createElement(vn, null),
    s4 = n(function (e) {
  var S;

  var N = e,
      t = N.choices,
      o = N.className,
      _N$pagination = N.pagination,
      r = _N$pagination === void 0 ? JS : _N$pagination,
      a = N.filters,
      s = N.source,
      p = N.resource,
      c = f(N, ["choices", "className", "pagination", "filters", "source", "resource"]),
      F = QS({
    choices: t,
    resource: p,
    source: s
  }),
      d = F.allChoices,
      m = F.availableChoices,
      u = F.selectedChoices,
      g = F.source,
      y = f(F, ["allChoices", "availableChoices", "selectedChoices", "source"]),
      _GS = GS(E(i(i({}, e), y), {
    source: g
  })),
      b = _GS.field,
      P = _GS.fieldState,
      T = _GS.formState,
      x = wl(function (L) {
    b.onChange(L);
  }, [b]),
      C = wl(function (L) {
    b.value.includes(L) ? b.onChange(b.value.filter(function (k) {
      return k !== L;
    })) : b.onChange([].concat(_toConsumableArray(b.value), [L]));
  }, [b]),
      v = wl(function () {
    b.onChange([]);
  }, [b]),
      I = Le.useMemo(function () {
    return E(i({}, y), {
      data: m,
      onSelect: x,
      onToggleItem: C,
      onUnselectItems: v,
      selectedIds: b.value
    });
  }, [m, y, b, x, C, v]);

  return Le.createElement("div", {
    className: US("ra-input", "ra-input-".concat(g), o)
  }, Le.createElement(XS, {
    value: I
  }, a ? Array.isArray(a) ? Le.createElement(rt.Provider, {
    value: a
  }, Le.createElement(Le.Fragment, null, Le.createElement(br, null), Le.createElement(Do, null))) : Le.createElement(Le.Fragment, null, vd(a, {
    context: "form"
  }), vd(a, {
    context: "button"
  })) : null, Le.createElement(ro, i({}, c)), r !== !1 && r, Le.createElement(Z, {
    touched: P.isTouched || T.isSubmitted,
    error: (S = P.error) == null ? void 0 : S.message
  })));
}, "DatagridInput");
l();
import * as Xa from "react";
import In from "prop-types";
import KS from "clsx";
import YS from "@mui/material/TextField";
import { useInput as ZS, FieldTitle as eE } from "ra-core";
var Al = n(function (T) {
  var x = T,
      e = x.className,
      t = x.defaultValue,
      _x$format = x.format,
      o = _x$format === void 0 ? rE : _x$format,
      r = x.label,
      a = x.name,
      s = x.source,
      p = x.resource,
      c = x.helperText,
      d = x.margin,
      m = x.onBlur,
      u = x.onChange,
      g = x.parse,
      y = x.validate,
      b = x.variant,
      P = f(x, ["className", "defaultValue", "format", "label", "name", "source", "resource", "helperText", "margin", "onBlur", "onChange", "parse", "validate", "variant"]);

  var _ZS = ZS(i({
    defaultValue: t,
    name: a,
    format: o,
    parse: g,
    onBlur: m,
    onChange: u,
    resource: p,
    source: s,
    validate: y
  }, P)),
      C = _ZS.field,
      v = _ZS.fieldState,
      I = _ZS.formState,
      N = _ZS.id,
      F = _ZS.isRequired,
      S = v.error,
      L = v.invalid,
      k = v.isTouched,
      B = I.isSubmitted;

  return Xa.createElement(YS, i(E(i({
    id: N
  }, C), {
    className: KS("ra-input", "ra-input-".concat(s), e),
    type: "date",
    size: "small",
    variant: b,
    margin: d,
    error: (k || B) && L,
    helperText: Xa.createElement(Z, {
      touched: k || B,
      error: S == null ? void 0 : S.message,
      helperText: c
    }),
    label: Xa.createElement(eE, {
      label: r,
      source: s,
      resource: p,
      isRequired: F
    }),
    InputLabelProps: oE
  }), ne(P)));
}, "DateInput");
Al.propTypes = {
  label: In.oneOfType([In.string, In.bool]),
  resource: In.string,
  source: In.string
};
var Id = n(function (e) {
  if (!(e instanceof Date) || isNaN(e.getDate())) return "";
  var t = "00",
      o = e.getFullYear().toString(),
      r = (e.getMonth() + 1).toString(),
      a = e.getDate().toString();
  return "".concat(o, "-").concat((t + r).slice(-2), "-").concat((t + a).slice(-2));
}, "convertDateToString"),
    tE = /^\d{4}-\d{2}-\d{2}$/,
    oE = {
  shrink: !0
},
    rE = n(function (e) {
  return e == null || e === "" ? "" : e instanceof Date ? Id(e) : tE.test(e) ? e : Id(new Date(e));
}, "getStringFromDate");
l();
import * as Qa from "react";
import Fn from "prop-types";
import nE from "clsx";
import aE from "@mui/material/TextField";
import { useInput as sE, FieldTitle as iE } from "ra-core";
var lE = n(function (e) {
  return new Date(e);
}, "parseDateTime"),
    pE = n(function (P) {
  var T = P,
      e = T.className,
      t = T.defaultValue,
      _T$format = T.format,
      o = _T$format === void 0 ? uE : _T$format,
      r = T.label,
      a = T.helperText,
      s = T.margin,
      p = T.onBlur,
      c = T.onChange,
      d = T.source,
      m = T.resource,
      _T$parse = T.parse,
      u = _T$parse === void 0 ? lE : _T$parse,
      g = T.validate,
      y = T.variant,
      b = f(T, ["className", "defaultValue", "format", "label", "helperText", "margin", "onBlur", "onChange", "source", "resource", "parse", "validate", "variant"]);

  var _sE = sE(i({
    defaultValue: t,
    format: o,
    parse: u,
    onBlur: p,
    onChange: c,
    resource: m,
    source: d,
    validate: g
  }, b)),
      x = _sE.field,
      C = _sE.fieldState,
      v = _sE.formState,
      I = _sE.id,
      N = _sE.isRequired,
      F = C.error,
      S = C.invalid,
      L = C.isTouched,
      k = v.isSubmitted;

  return Qa.createElement(aE, i(E(i({
    id: I
  }, x), {
    className: nE("ra-input", "ra-input-".concat(d), e),
    type: "datetime-local",
    size: "small",
    variant: y,
    margin: s,
    error: (L || k) && S,
    helperText: Qa.createElement(Z, {
      touched: L || k,
      error: F == null ? void 0 : F.message,
      helperText: a
    }),
    label: Qa.createElement(iE, {
      label: r,
      source: d,
      resource: m,
      isRequired: N
    }),
    InputLabelProps: dE
  }), ne(b)));
}, "DateTimeInput");
pE.propTypes = {
  label: Fn.oneOfType([Fn.string, Fn.bool]),
  resource: Fn.string,
  source: Fn.string
};
var Fd = n(function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  return function (t) {
    return ("0".repeat(e) + t).slice(-e);
  };
}, "leftPad"),
    cE = Fd(4),
    Ga = Fd(2),
    Sd = n(function (e) {
  if (!(e instanceof Date) || isNaN(e.getDate())) return "";
  var t = cE(e.getFullYear()),
      o = Ga(e.getMonth() + 1),
      r = Ga(e.getDate()),
      a = Ga(e.getHours()),
      s = Ga(e.getMinutes());
  return "".concat(t, "-").concat(o, "-").concat(r, "T").concat(a, ":").concat(s);
}, "convertDateToString"),
    mE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/,
    dE = {
  shrink: !0
},
    uE = n(function (e) {
  return e == null || e === "" ? "" : e instanceof Date ? Sd(e) : mE.test(e) ? e : Sd(new Date(e));
}, "formatDateTime");
l();
import mt, { Children as Ol, cloneElement as TE, isValidElement as PE } from "react";
import { styled as xE } from "@mui/material/styles";
import ke from "prop-types";
import CE from "clsx";
import { useDropzone as vE } from "react-dropzone";
import IE from "@mui/material/FormHelperText";
import { useInput as FE, useTranslate as SE, shallowEqual as EE } from "ra-core";
l();
import * as Ja from "react";
import { styled as fE } from "@mui/material/styles";
import { useEffect as gE } from "react";
import Ka from "prop-types";
import yE from "@mui/icons-material/RemoveCircle";
import bE from "@mui/material/IconButton";
import { useTranslate as hE } from "ra-core";
var Ya = n(function (e) {
  var c = e,
      t = c.children,
      o = c.className,
      r = c.onRemove,
      a = c.file,
      s = f(c, ["children", "className", "onRemove", "file"]),
      p = hE();
  return gE(function () {
    return function () {
      var d = a.rawFile ? a.rawFile.preview : a.preview;
      d && window.URL.revokeObjectURL(d);
    };
  }, [a]), Ja.createElement(RE, i({
    className: o
  }, s), Ja.createElement(bE, {
    className: Za.removeButton,
    onClick: r,
    "aria-label": p("ra.action.delete"),
    title: p("ra.action.delete"),
    size: "large"
  }, Ja.createElement(yE, {
    className: Za.removeIcon
  })), t);
}, "FileInputPreview");
Ya.propTypes = {
  children: Ka.element.isRequired,
  className: Ka.string,
  file: Ka.object,
  onRemove: Ka.func.isRequired
};
Ya.defaultProps = {
  file: void 0
};
var $l = "RaFileInputPreview",
    Za = {
  removeButton: "".concat($l, "-removeButton"),
  removeIcon: "".concat($l, "-removeIcon")
},
    RE = fE("div", {
  name: $l,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref95) {
  var _ref96;

  var e = _ref95.theme;
  return _ref96 = {}, _defineProperty(_ref96, "& .".concat(Za.removeButton), {}), _defineProperty(_ref96, "& .".concat(Za.removeIcon), {
    color: e.palette.error.main
  }), _ref96;
});
var Dl = n(function (e) {
  var He = e,
      t = He.accept,
      o = He.children,
      r = He.className,
      a = He.format,
      s = He.helperText,
      p = He.inputProps,
      c = He.maxSize,
      d = He.minSize,
      _He$multiple = He.multiple,
      m = _He$multiple === void 0 ? !1 : _He$multiple,
      u = He.label,
      _He$labelMultiple = He.labelMultiple,
      g = _He$labelMultiple === void 0 ? "ra.input.file.upload_several" : _He$labelMultiple,
      _He$labelSingle = He.labelSingle,
      y = _He$labelSingle === void 0 ? "ra.input.file.upload_single" : _He$labelSingle,
      _He$options = He.options,
      b = _He$options === void 0 ? {} : _He$options,
      P = He.onRemove,
      T = He.parse,
      x = He.placeholder,
      C = He.resource,
      v = He.source,
      I = He.validate,
      N = He.validateFileRemoval,
      F = f(He, ["accept", "children", "className", "format", "helperText", "inputProps", "maxSize", "minSize", "multiple", "label", "labelMultiple", "labelSingle", "options", "onRemove", "parse", "placeholder", "resource", "source", "validate", "validateFileRemoval"]),
      S = b.onDrop,
      L = SE(),
      k = n(function (Q) {
    if (!(Q instanceof File)) return Q;

    var _Ol$only$props = Ol.only(o).props,
        we = _Ol$only$props.source,
        ae = _Ol$only$props.title,
        st = URL.createObjectURL(Q),
        De = _defineProperty({
      rawFile: Q
    }, we, st);

    return ae && (De[ae] = Q.name), De;
  }, "transformFile"),
      B = n(function (Q) {
    return Q ? Array.isArray(Q) ? Q.map(k) : k(Q) : m ? [] : null;
  }, "transformFiles"),
      _FE = FE(i({
    format: a || B,
    parse: T || B,
    source: v,
    validate: I
  }, F)),
      M = _FE.id,
      _FE$field = _FE.field,
      z = _FE$field.onChange,
      A = _FE$field.value,
      W = _FE.fieldState,
      D = _FE.formState.isSubmitted,
      V = _FE.isRequired,
      _ = W.isTouched,
      w = W.error,
      O = A ? Array.isArray(A) ? A : [A] : [],
      te = n(function (Q, we, ae) {
    var st = m ? [].concat(_toConsumableArray(O), _toConsumableArray(Q)) : _toConsumableArray(Q);
    z(m ? st : st[0]), S && S(Q, we, ae);
  }, "onDrop"),
      oe = n(function (Q) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var we;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!N) {
                _context7.next = 9;
                break;
              }

              _context7.prev = 1;
              _context7.next = 4;
              return N(Q);

            case 4:
              _context7.next = 9;
              break;

            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](1);
              return _context7.abrupt("return");

            case 9:
              if (m) {
                we = O.filter(function (ae) {
                  return !EE(ae, Q);
                });
                z(we);
              } else z(null);

              P && P(Q);

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 6]]);
    }));
  }, "onRemove"),
      ce = o && PE(Ol.only(o)) ? Ol.only(o) : void 0,
      _vE = vE(E(i({
    accept: t,
    maxSize: c,
    minSize: d,
    multiple: m
  }, b), {
    onDrop: te
  })),
      re = _vE.getRootProps,
      le = _vE.getInputProps;

  return mt.createElement(NE, i({
    htmlFor: M,
    label: u,
    className: CE("ra-input", "ra-input-".concat(v), r),
    source: v,
    resource: C,
    isRequired: V
  }, ne(F)), mt.createElement(mt.Fragment, null, mt.createElement("div", i({}, re({
    className: Ft.dropZone,
    "data-testid": "dropzone"
  })), mt.createElement("input", i({
    id: M,
    name: M
  }, le(i({}, p)))), x || (m ? mt.createElement("p", null, L(g)) : mt.createElement("p", null, L(y)))), mt.createElement(IE, null, mt.createElement(Z, {
    touched: _ || D,
    error: w == null ? void 0 : w.message,
    helperText: s
  })), o && mt.createElement("div", {
    className: "previews"
  }, O.map(function (Q, we) {
    return mt.createElement(Ya, {
      key: we,
      file: Q,
      onRemove: oe(Q),
      className: Ft.removeButton
    }, TE(ce, {
      record: Q,
      className: Ft.preview
    }));
  }))));
}, "FileInput");
Dl.propTypes = {
  accept: ke.string,
  children: ke.element,
  className: ke.string,
  id: ke.string,
  isRequired: ke.bool,
  label: ke.string,
  labelMultiple: ke.string,
  labelSingle: ke.string,
  maxSize: ke.number,
  minSize: ke.number,
  multiple: ke.bool,
  validateFileRemoval: ke.func,
  options: ke.object,
  resource: ke.string,
  source: ke.string,
  placeholder: ke.node
};
var es = "RaFileInput",
    Ft = {
  dropZone: "".concat(es, "-dropZone"),
  preview: "".concat(es, "-preview"),
  removeButton: "".concat(es, "-removeButton")
},
    NE = xE(fe, {
  name: es,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref98) {
  var _ref99;

  var e = _ref98.theme;
  return _ref99 = {
    width: "100%"
  }, _defineProperty(_ref99, "& .".concat(Ft.dropZone), {
    background: e.palette.background.default,
    cursor: "pointer",
    padding: e.spacing(1),
    textAlign: "center",
    color: e.palette.getContrastText(e.palette.background.default)
  }), _defineProperty(_ref99, "& .".concat(Ft.preview), {}), _defineProperty(_ref99, "& .".concat(Ft.removeButton), {}), _ref99;
});
l();
import * as Ed from "react";
import { styled as BE } from "@mui/material/styles";
var J4 = n(function (e) {
  return Ed.createElement(kE, i({
    labelMultiple: "ra.input.image.upload_several",
    labelSingle: "ra.input.image.upload_single"
  }, e));
}, "ImageInput"),
    LE = "RaImageInput",
    kE = BE(Dl, {
  name: LE,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref100) {
  var _ref101;

  var e = _ref100.theme;
  return _ref101 = {
    width: "100%"
  }, _defineProperty(_ref101, "& .".concat(Ft.dropZone), {
    background: e.palette.background.default,
    cursor: "pointer",
    padding: e.spacing(1),
    textAlign: "center",
    color: e.palette.getContrastText(e.palette.background.default)
  }), _defineProperty(_ref101, "& .".concat(Ft.preview), {
    display: "inline-block"
  }), _defineProperty(_ref101, "& .".concat(Ft.removeButton), {
    display: "inline-block",
    position: "relative",
    float: "left",
    "& button": {
      position: "absolute",
      top: e.spacing(1),
      right: e.spacing(1),
      minWidth: e.spacing(2),
      opacity: 0
    },
    "&:hover button": {
      opacity: 1
    }
  }), _ref101;
});
l();
import * as zo from "react";
import { styled as wE } from "@mui/material/styles";
import zt from "prop-types";
import AE from "@mui/material/TextField";
import Ml from "@mui/material/MenuItem";
import $E from "clsx";
import { useInput as OE, useTranslate as DE, FieldTitle as ME } from "ra-core";
var VE = n(function (e) {
  var B = e,
      t = B.className,
      _B$format = B.format,
      o = _B$format === void 0 ? zE : _B$format,
      r = B.helperText,
      a = B.label,
      s = B.margin,
      p = B.onBlur,
      c = B.onChange,
      _B$parse = B.parse,
      d = _B$parse === void 0 ? HE : _B$parse,
      m = B.resource,
      u = B.source,
      g = B.validate,
      y = B.variant,
      _B$nullLabel = B.nullLabel,
      b = _B$nullLabel === void 0 ? "ra.boolean.null" : _B$nullLabel,
      _B$falseLabel = B.falseLabel,
      P = _B$falseLabel === void 0 ? "ra.boolean.false" : _B$falseLabel,
      _B$trueLabel = B.trueLabel,
      T = _B$trueLabel === void 0 ? "ra.boolean.true" : _B$trueLabel,
      x = f(B, ["className", "format", "helperText", "label", "margin", "onBlur", "onChange", "parse", "resource", "source", "validate", "variant", "nullLabel", "falseLabel", "trueLabel"]),
      C = DE(),
      _OE = OE(i({
    format: o,
    parse: d,
    onBlur: p,
    onChange: c,
    resource: m,
    source: u,
    validate: g
  }, x)),
      v = _OE.field,
      _OE$fieldState = _OE.fieldState,
      I = _OE$fieldState.error,
      N = _OE$fieldState.invalid,
      F = _OE$fieldState.isTouched,
      S = _OE.formState.isSubmitted,
      L = _OE.id,
      k = _OE.isRequired;

  return zo.createElement(_E, i(E(i({
    id: L,
    size: "small"
  }, v), {
    className: $E("ra-input", "ra-input-".concat(u), Bd.input, t),
    select: !0,
    margin: s,
    label: zo.createElement(ME, {
      label: a,
      source: u,
      resource: m,
      isRequired: k
    }),
    error: (F || S) && N,
    helperText: zo.createElement(Z, {
      touched: F || S,
      error: I == null ? void 0 : I.message,
      helperText: r
    }),
    variant: y
  }), ne(x)), zo.createElement(Ml, {
    value: ""
  }, C(b)), zo.createElement(Ml, {
    value: "false"
  }, C(P)), zo.createElement(Ml, {
    value: "true"
  }, C(T)));
}, "NullableBooleanInput");
VE.propTypes = {
  label: zt.oneOfType([zt.string, zt.bool]),
  options: zt.object,
  resource: zt.string,
  source: zt.string,
  nullLabel: zt.string,
  falseLabel: zt.string,
  trueLabel: zt.string
};

var Nd = "RaNullableBooleanInput",
    Bd = {
  input: "".concat(Nd, "-input")
},
    _E = wE(AE, {
  name: Nd,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref102) {
  var e = _ref102.theme,
      t = _ref102.fullWidth;
  return _defineProperty({}, "&.".concat(Bd.input), {
    width: t ? "100%" : e.spacing(16)
  });
}),
    HE = n(function (e) {
  return e === "true" ? !0 : e === "false" ? !1 : null;
}, "getBooleanFromString"),
    zE = n(function (e) {
  return e === !0 ? "true" : e === !1 ? "false" : "";
}, "getStringFromBoolean");

l();
import * as lo from "react";
import Wt from "prop-types";
import WE from "clsx";
import qE from "@mui/material/TextField";
import { useInput as jE, FieldTitle as UE } from "ra-core";
var ts = n(function (v) {
  var I = v,
      e = I.className,
      _I$defaultValue = I.defaultValue,
      t = _I$defaultValue === void 0 ? null : _I$defaultValue,
      _I$format = I.format,
      o = _I$format === void 0 ? QE : _I$format,
      r = I.helperText,
      a = I.label,
      s = I.margin,
      p = I.onBlur,
      c = I.onChange,
      d = I.parse,
      m = I.resource,
      u = I.source,
      g = I.step,
      y = I.min,
      b = I.max,
      P = I.validate,
      T = I.variant,
      x = I.inputProps,
      C = f(I, ["className", "defaultValue", "format", "helperText", "label", "margin", "onBlur", "onChange", "parse", "resource", "source", "step", "min", "max", "validate", "variant", "inputProps"]);

  var _jE = jE(i({
    defaultValue: t,
    resource: m,
    source: u,
    validate: P
  }, C)),
      N = _jE.field,
      _jE$fieldState = _jE.fieldState,
      F = _jE$fieldState.error,
      S = _jE$fieldState.invalid,
      L = _jE$fieldState.isTouched,
      k = _jE.formState.isSubmitted,
      B = _jE.id,
      M = _jE.isRequired,
      z = E(i({}, x), {
    step: g,
    min: y,
    max: b
  }),
      _lo$useState = lo.useState(o(N.value)),
      _lo$useState2 = _slicedToArray(_lo$useState, 2),
      A = _lo$useState2[0],
      W = _lo$useState2[1];

  lo.useEffect(function () {
    var _ = o(N.value);

    W(function (w) {
      return w !== _ ? _ : w;
    });
  }, [N.value]);
  var D = n(function (_) {
    c && c(_), !(typeof _.target == "undefined" || typeof _.target.value == "undefined") && W(_.target.value);
  }, "handleChange"),
      V = n(function () {
    p && p.apply(void 0, arguments);
    var w = arguments.length <= 0 ? undefined : arguments[0];
    if (typeof w.target == "undefined" || typeof w.target.value == "undefined") return;
    var O = w.target,
        te = O.valueAsNumber ? d ? d(O.valueAsNumber) : O.valueAsNumber : d ? d(O.value) : XE(O.value);
    N.onChange(te);
  }, "handleBlur");
  return lo.createElement(qE, i(E(i({
    id: B
  }, N), {
    value: A,
    onChange: D,
    onBlur: V,
    className: WE("ra-input", "ra-input-".concat(u), e),
    type: "number",
    size: "small",
    variant: T,
    error: (L || k) && S,
    helperText: lo.createElement(Z, {
      touched: L || k,
      error: F == null ? void 0 : F.message,
      helperText: r
    }),
    label: lo.createElement(UE, {
      label: a,
      source: u,
      resource: m,
      isRequired: M
    }),
    margin: s,
    inputProps: z
  }), ne(C)));
}, "NumberInput");
ts.propTypes = {
  label: Wt.oneOfType([Wt.string, Wt.bool]),
  options: Wt.object,
  resource: Wt.string,
  source: Wt.string,
  step: Wt.oneOfType([Wt.string, Wt.number])
};
ts.defaultProps = {
  options: {},
  step: "any",
  textAlign: "right"
};
var XE = n(function (e) {
  if (e == null || e === "") return null;
  var t = parseFloat(e);
  return isNaN(t) ? 0 : t;
}, "convertStringToNumber"),
    QE = n(function (e) {
  return e == null || isNaN(e) ? "" : e.toString();
}, "convertNumberToString");
l();
import * as Cr from "react";
import { useState as nN } from "react";
import { useTranslate as aN } from "ra-core";
import { InputAdornment as sN, IconButton as iN } from "@mui/material";
import lN from "@mui/icons-material/Visibility";
import pN from "@mui/icons-material/VisibilityOff";
l();
import * as os from "react";
import Wo from "prop-types";
import tN from "clsx";
import { useInput as oN, FieldTitle as rN } from "ra-core";
l();
import * as St from "react";
import { forwardRef as GE, useCallback as Vl } from "react";
import { styled as JE } from "@mui/material/styles";
import po from "prop-types";
import Ld from "clsx";
import { InputAdornment as _l, IconButton as kd, TextField as KE } from "@mui/material";
import wd from "@mui/icons-material/Clear";
import { useTranslate as YE } from "ra-core";
var Tr = GE(function (e, t) {
  var M = e,
      o = M.clearAlwaysVisible,
      r = M.InputProps,
      a = M.value,
      s = M.resettable,
      p = M.disabled,
      c = M.variant,
      d = M.margin,
      m = M.className,
      u = f(M, ["clearAlwaysVisible", "InputProps", "value", "resettable", "disabled", "variant", "margin", "className"]),
      g = YE(),
      y = e.onChange,
      b = e.onFocus,
      P = e.onBlur,
      T = Vl(function (A) {
    A.preventDefault(), y("");
  }, [y]),
      x = Vl(function (A) {
    b && b(A);
  }, [b]),
      C = Vl(function (A) {
    P && P(A);
  }, [P]),
      v = xr.clearButton,
      I = xr.clearIcon,
      N = xr.inputAdornedEnd,
      F = xr.selectAdornment,
      S = xr.visibleClearIcon,
      z = r || {},
      L = z.endAdornment,
      k = f(z, ["endAdornment"]);
  if (o && L) throw new Error("ResettableTextField cannot display both an endAdornment and a clear button always visible");
  var B = n(function () {
    return s ? a ? St.createElement(_l, {
      position: "end",
      classes: {
        root: e.select ? F : null
      }
    }, St.createElement(kd, {
      className: v,
      "aria-label": g("ra.action.clear_input_value"),
      title: g("ra.action.clear_input_value"),
      disableRipple: !0,
      onClick: T,
      onMouseDown: ZE,
      disabled: p,
      size: "large"
    }, St.createElement(wd, {
      className: Ld(I, _defineProperty({}, S, o || a))
    }))) : o ? St.createElement(_l, {
      position: "end",
      classes: {
        root: e.select ? F : null
      }
    }, St.createElement(kd, {
      className: v,
      "aria-label": g("ra.action.clear_input_value"),
      title: g("ra.action.clear_input_value"),
      disableRipple: !0,
      disabled: !0,
      size: "large"
    }, St.createElement(wd, {
      className: Ld(I, S)
    }))) : L || St.createElement(_l, {
      position: "end",
      classes: {
        root: e.select ? F : null
      }
    }, St.createElement("span", {
      className: v
    }, "\xA0")) : L;
  }, "getEndAdornment");
  return St.createElement(eN, E(i({
    value: a,
    InputProps: i({
      classes: e.select && c === "filled" ? {
        adornedEnd: N
      } : {},
      endAdornment: B()
    }, k),
    disabled: p,
    variant: c,
    margin: d,
    className: m,
    size: "small"
  }, u), {
    onFocus: x,
    onBlur: C,
    inputRef: t
  }));
});
Tr.displayName = "ResettableTextField";
var ZE = n(function (e) {
  e.preventDefault();
}, "handleMouseDownClearButton");
Tr.propTypes = {
  clearAlwaysVisible: po.bool,
  disabled: po.bool,
  InputProps: po.object,
  onBlur: po.func,
  onChange: po.func.isRequired,
  onFocus: po.func,
  resettable: po.bool,
  value: po.any
};
var Pr = "RaResettableTextField",
    xr = {
  clearIcon: "".concat(Pr, "-clearIcon"),
  visibleClearIcon: "".concat(Pr, "-visibleClearIcon"),
  clearButton: "".concat(Pr, "-clearButton"),
  selectAdornment: "".concat(Pr, "-selectAdornment"),
  inputAdornedEnd: "".concat(Pr, "-inputAdornedEnd")
},
    Hl = (_Hl = {}, _defineProperty(_Hl, "& .".concat(xr.clearIcon), {
  height: 16,
  width: 0
}), _defineProperty(_Hl, "& .".concat(xr.visibleClearIcon), {
  width: 16
}), _defineProperty(_Hl, "& .".concat(xr.clearButton), {
  height: 24,
  width: 24,
  padding: 0
}), _defineProperty(_Hl, "& .".concat(xr.selectAdornment), {
  position: "absolute",
  right: 24
}), _defineProperty(_Hl, "& .".concat(xr.inputAdornedEnd), {
  paddingRight: 0
}), _Hl),
    eN = JE(KE, {
  name: Pr,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(Hl);
var Fe = n(function (e) {
  var N = e,
      t = N.className,
      _N$defaultValue = N.defaultValue,
      o = _N$defaultValue === void 0 ? "" : _N$defaultValue,
      r = N.label,
      a = N.format,
      s = N.helperText,
      p = N.onBlur,
      c = N.onChange,
      d = N.parse,
      m = N.resource,
      u = N.source,
      g = N.validate,
      y = f(N, ["className", "defaultValue", "label", "format", "helperText", "onBlur", "onChange", "parse", "resource", "source", "validate"]),
      _oN = oN(i({
    defaultValue: o,
    format: a,
    parse: d,
    resource: m,
    source: u,
    type: "text",
    validate: g,
    onBlur: p,
    onChange: c
  }, y)),
      b = _oN.field,
      _oN$fieldState = _oN.fieldState,
      P = _oN$fieldState.error,
      T = _oN$fieldState.invalid,
      x = _oN$fieldState.isTouched,
      C = _oN.formState.isSubmitted,
      v = _oN.id,
      I = _oN.isRequired;

  return os.createElement(Tr, i(E(i({
    id: v
  }, b), {
    className: tN("ra-input", "ra-input-".concat(u), t),
    label: r !== "" && r !== !1 && os.createElement(rN, {
      label: r,
      source: u,
      resource: m,
      isRequired: I
    }),
    error: (x || C) && T,
    helperText: os.createElement(Z, {
      touched: x || C,
      error: P == null ? void 0 : P.message,
      helperText: s
    })
  }), ne(y)));
}, "TextInput");
Fe.propTypes = {
  className: Wo.string,
  label: Wo.oneOfType([Wo.string, Wo.bool]),
  options: Wo.object,
  resource: Wo.string,
  source: Wo.string
};
Fe.defaultProps = {
  options: {}
};

var _J = n(function (e) {
  var c = e,
      _c$initiallyVisible = c.initiallyVisible,
      t = _c$initiallyVisible === void 0 ? !1 : _c$initiallyVisible,
      o = f(c, ["initiallyVisible"]),
      _nN = nN(t),
      _nN2 = _slicedToArray(_nN, 2),
      r = _nN2[0],
      a = _nN2[1],
      s = aN(),
      p = n(function () {
    a(!r);
  }, "handleClick");

  return Cr.createElement(Fe, i({
    type: r ? "text" : "password",
    size: "small",
    InputProps: {
      endAdornment: Cr.createElement(sN, {
        position: "end"
      }, Cr.createElement(iN, {
        "aria-label": s(r ? "ra.input.password.toggle_visible" : "ra.input.password.toggle_hidden"),
        onClick: p,
        size: "large"
      }, r ? Cr.createElement(lN, null) : Cr.createElement(pN, null)))
    }
  }, o));
}, "PasswordInput");

l();
import * as Et from "react";
import { styled as uN } from "@mui/material/styles";
import Ve from "prop-types";
import $d from "clsx";
import { FormControl as fN, FormHelperText as gN, FormLabel as yN, RadioGroup as bN } from "@mui/material";
import hN from "lodash/get";
import { useInput as RN, FieldTitle as TN, warning as Od, useChoicesContext as PN } from "ra-core";
l();
import * as zl from "react";
import cN from "@mui/material/FormControlLabel";
import mN from "@mui/material/Radio";
import { useChoices as dN } from "ra-core";
var Ad = n(function (_ref104) {
  var e = _ref104.choice,
      t = _ref104.optionText,
      o = _ref104.optionValue,
      r = _ref104.source,
      a = _ref104.translateChoice;

  var _dN = dN({
    optionText: t,
    optionValue: o,
    translateChoice: a
  }),
      s = _dN.getChoiceText,
      p = _dN.getChoiceValue,
      c = s(e),
      d = p(e),
      m = "".concat(r, "_").concat(d);

  return zl.createElement(cN, {
    label: c,
    htmlFor: m,
    value: d,
    control: zl.createElement(mN, {
      id: m,
      color: "primary"
    })
  });
}, "RadioButtonGroupInputItem");
var Dd = n(function (e) {
  var w = e,
      t = w.choices,
      o = w.className,
      r = w.format,
      a = w.helperText,
      s = w.isFetching,
      p = w.isLoading,
      c = w.label,
      _w$margin = w.margin,
      d = _w$margin === void 0 ? "dense" : _w$margin,
      m = w.onBlur,
      u = w.onChange,
      g = w.optionText,
      y = w.optionValue,
      b = w.parse,
      P = w.resource,
      T = w.row,
      x = w.source,
      C = w.translateChoice,
      v = w.validate,
      I = f(w, ["choices", "className", "format", "helperText", "isFetching", "isLoading", "label", "margin", "onBlur", "onChange", "optionText", "optionValue", "parse", "resource", "row", "source", "translateChoice", "validate"]),
      _PN = PN({
    choices: t,
    isFetching: s,
    isLoading: p,
    resource: P,
    source: x
  }),
      N = _PN.allChoices,
      F = _PN.isLoading,
      S = _PN.resource,
      L = _PN.source;

  Od(L === void 0, "If you're not wrapping the RadioButtonGroupInput inside a ReferenceInput, you must provide the source prop"), Od(N === void 0, "If you're not wrapping the RadioButtonGroupInput inside a ReferenceInput, you must provide the choices prop");

  var _RN = RN(i({
    format: r,
    onBlur: m,
    onChange: u,
    parse: b,
    resource: S,
    source: L,
    validate: v
  }, I)),
      k = _RN.id,
      B = _RN.isRequired,
      M = _RN.fieldState,
      z = _RN.field,
      A = _RN.formState,
      W = M.error,
      D = M.invalid,
      V = M.isTouched,
      _ = A.isSubmitted;

  return F ? Et.createElement(fe, {
    htmlFor: k,
    label: c,
    source: L,
    resource: S,
    className: $d("ra-input", "ra-input-".concat(L), o),
    isRequired: B
  }, Et.createElement(Be, null)) : Et.createElement(xN, i({
    component: "fieldset",
    className: $d("ra-input", "ra-input-".concat(L), o),
    margin: d,
    error: (V || _) && D
  }, Md(I)), Et.createElement(yN, {
    component: "legend",
    className: _d.label
  }, Et.createElement(TN, {
    label: c,
    source: L,
    resource: S,
    isRequired: B
  })), Et.createElement(bN, i(i({
    id: k,
    row: T
  }, z), Md(I)), N.map(function (O) {
    return Et.createElement(Ad, {
      key: hN(O, y),
      choice: O,
      optionText: g,
      optionValue: y,
      source: L,
      translateChoice: C
    });
  })), Et.createElement(gN, null, Et.createElement(Z, {
    touched: V || _,
    error: W == null ? void 0 : W.message,
    helperText: a
  })));
}, "RadioButtonGroupInput");
Dd.propTypes = {
  choices: Ve.arrayOf(Ve.any),
  label: Ve.oneOfType([Ve.string, Ve.bool]),
  options: Ve.object,
  optionText: Ve.oneOfType([Ve.string, Ve.func, Ve.element]),
  optionValue: Ve.string,
  resource: Ve.string,
  source: Ve.string,
  translateChoice: Ve.bool
};
Dd.defaultProps = {
  options: {},
  optionText: "name",
  optionValue: "id",
  row: !0,
  translateChoice: !0
};
var Md = n(function (V) {
  var _ = V,
      e = _.afterSubmit,
      t = _.allowNull,
      o = _.beforeSubmit,
      r = _.choices,
      a = _.className,
      s = _.crudGetMatching,
      p = _.crudGetOne,
      c = _.data,
      d = _.filter,
      m = _.filterToQuery,
      u = _.formatOnBlur,
      g = _.isEqual,
      y = _.limitChoicesToValue,
      b = _.multiple,
      P = _.name,
      T = _.pagination,
      x = _.perPage,
      C = _.ref,
      v = _.reference,
      I = _.refetch,
      N = _.render,
      F = _.setFilter,
      S = _.setPagination,
      L = _.setSort,
      k = _.sort,
      B = _.subscription,
      M = _.type,
      z = _.validateFields,
      A = _.validation,
      W = _.value,
      D = f(_, ["afterSubmit", "allowNull", "beforeSubmit", "choices", "className", "crudGetMatching", "crudGetOne", "data", "filter", "filterToQuery", "formatOnBlur", "isEqual", "limitChoicesToValue", "multiple", "name", "pagination", "perPage", "ref", "reference", "refetch", "render", "setFilter", "setPagination", "setSort", "sort", "subscription", "type", "validateFields", "validation", "value"]);
  return ne(D);
}, "sanitizeRestProps"),
    Vd = "RaRadioButtonGroupInput",
    _d = {
  label: "".concat(Vd, "-label")
},
    xN = uN(fN, {
  name: Vd,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref105) {
  var e = _ref105.theme;
  return _defineProperty({}, "& .".concat(_d.label), {
    transform: "translate(0, 5px) scale(0.75)",
    transformOrigin: "top ".concat(e.direction === "ltr" ? "left" : "right")
  });
});
l();
import * as vr from "react";
import dt from "prop-types";
import { useReferenceArrayInputController as vN, ResourceContextProvider as IN, ChoicesContextProvider as FN } from "ra-core";
l();
import * as Hd from "react";
import Sn from "prop-types";
import CN from "@mui/material/TextField";
var En = n(function (_ref107) {
  var e = _ref107.label,
      t = _ref107.error;
  return Hd.createElement(CN, {
    error: !0,
    disabled: !0,
    label: e,
    value: t == null ? void 0 : t.message,
    margin: "normal"
  });
}, "ReferenceError");
En.propTypes = {
  error: Sn.object.isRequired,
  label: Sn.oneOfType([Sn.string, Sn.element, Sn.bool])
};
var rs = n(function (e) {
  var t = e.children,
      o = e.label,
      r = e.reference;
  if (vr.Children.count(t) !== 1) throw new Error("<ReferenceArrayInput> only accepts a single child (like <Datagrid>)");
  var a = vN(e);
  return a.error ? vr.createElement(En, {
    label: o,
    error: a.error
  }) : vr.createElement(IN, {
    value: r
  }, vr.createElement(FN, {
    value: a
  }, t));
}, "ReferenceArrayInput");
rs.propTypes = {
  children: dt.element.isRequired,
  filter: dt.object,
  label: dt.string,
  page: dt.number,
  perPage: dt.number,
  reference: dt.string.isRequired,
  resource: dt.string,
  sort: dt.shape({
    field: dt.string,
    order: dt.oneOf(["ASC", "DESC"])
  }),
  source: dt.string
};
rs.defaultProps = {
  filter: {},
  page: 1,
  perPage: 25,
  sort: {
    field: "id",
    order: "DESC"
  }
};
l();
import Wl, { Children as SN } from "react";
import nt from "prop-types";
import { ChoicesContextProvider as EN, useReferenceInputController as NN, ResourceContextProvider as BN } from "ra-core";
var ns = n(function (e) {
  var t = e.children,
      o = e.label,
      r = e.reference,
      a = NN(e);
  if (SN.count(t) !== 1) throw new Error("<ReferenceInput> only accepts a single child");
  return a.error ? Wl.createElement(En, {
    label: o,
    error: a.error
  }) : Wl.createElement(BN, {
    value: r
  }, Wl.createElement(EN, {
    value: a
  }, t));
}, "ReferenceInput");
ns.propTypes = {
  children: nt.element.isRequired,
  filter: nt.object,
  label: nt.string,
  page: nt.number,
  perPage: nt.number,
  record: nt.object,
  reference: nt.string.isRequired,
  resource: nt.string,
  sort: nt.shape({
    field: nt.string,
    order: nt.oneOf(["ASC", "DESC"])
  }),
  source: nt.string
};
ns.defaultProps = {
  filter: {},
  page: 1,
  perPage: 25,
  sort: {
    field: "id",
    order: "DESC"
  }
};
l();
import * as as from "react";
import { styled as LN } from "@mui/material/styles";
import kN from "@mui/icons-material/Search";
import { InputAdornment as wN } from "@mui/material";
import { useTranslate as AN } from "ra-core";
var F3 = n(function (e) {
  var t = AN();
  if (e.label) throw new Error("<SearchInput> isn't designed to be used with a label prop. Use <TextInput> if you need a label.");
  return as.createElement(ON, i({
    hiddenLabel: !0,
    label: "",
    resettable: !0,
    placeholder: t("ra.action.search"),
    InputProps: {
      endAdornment: as.createElement(wN, {
        position: "end"
      }, as.createElement(kN, {
        color: "disabled"
      }))
    },
    size: "small"
  }, e));
}, "SearchInput"),
    $N = "RaSearchInput",
    ON = LN(Fe, {
  name: $N,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  marginTop: 0
});
l();
import * as $e from "react";
import { styled as DN } from "@mui/material/styles";
import { useCallback as ql, useRef as MN } from "react";
import Se from "prop-types";
import zd from "clsx";
import { Select as VN, MenuItem as _N, InputLabel as HN, FormHelperText as zN, FormControl as WN, Chip as qN } from "@mui/material";
import { FieldTitle as jN, useInput as UN, useChoicesContext as XN, useChoices as QN } from "ra-core";
var Wd = n(function (e) {
  var bo = e,
      t = bo.choices,
      o = bo.className,
      r = bo.create,
      a = bo.createLabel,
      s = bo.createValue,
      p = bo.disableValue,
      c = bo.format,
      d = bo.helperText,
      m = bo.label,
      u = bo.isFetching,
      g = bo.isLoading,
      y = bo.margin,
      b = bo.onBlur,
      P = bo.onChange,
      T = bo.onCreate,
      x = bo.optionText,
      C = bo.optionValue,
      v = bo.parse,
      I = bo.resource,
      N = bo.source,
      F = bo.translateChoice,
      S = bo.validate,
      L = bo.variant,
      k = f(bo, ["choices", "className", "create", "createLabel", "createValue", "disableValue", "format", "helperText", "label", "isFetching", "isLoading", "margin", "onBlur", "onChange", "onCreate", "optionText", "optionValue", "parse", "resource", "source", "translateChoice", "validate", "variant"]),
      B = MN(null),
      _XN = XN({
    choices: t,
    isLoading: g,
    isFetching: u,
    resource: I,
    source: N
  }),
      M = _XN.allChoices,
      z = _XN.isLoading,
      A = _XN.source,
      W = _XN.resource,
      _QN = QN({
    optionText: x,
    optionValue: C,
    disableValue: p,
    translateChoice: F
  }),
      D = _QN.getChoiceText,
      V = _QN.getChoiceValue,
      _ = _QN.getDisableValue,
      _UN = UN(i({
    format: c,
    onBlur: b,
    onChange: P,
    parse: v,
    resource: W,
    source: A,
    validate: S
  }, k)),
      w = _UN.field,
      O = _UN.isRequired,
      _UN$fieldState = _UN.fieldState,
      te = _UN$fieldState.error,
      oe = _UN$fieldState.invalid,
      ce = _UN$fieldState.isTouched,
      re = _UN.formState.isSubmitted,
      le = ql(function (j) {
    (j == null ? void 0 : j.target) ? w.onChange(j) : w.onChange([].concat(_toConsumableArray(w.value || []), [V(j)]));
  }, [w, V]),
      _mr2 = mr({
    create: r,
    createLabel: a,
    createValue: s,
    handleChange: le,
    onCreate: T,
    optionText: x
  }),
      He = _mr2.getCreateItem,
      Q = _mr2.handleChange,
      we = _mr2.createElement,
      ae = r || T ? He() : null,
      st = r || T ? [].concat(_toConsumableArray(M || []), [ae]) : M || [],
      De = ql(function (j) {
    return !!ae && (j == null ? void 0 : j.id) === ae.id && typeof x == "function" ? ae.name : D(j);
  }, [ae, D, x]),
      Zr = ql(function (j) {
    return j ? $e.createElement(_N, {
      key: V(j),
      value: V(j),
      disabled: _(j)
    }, De(!!ae && (j == null ? void 0 : j.id) === ae.id ? ae : j)) : null;
  }, [V, _, De, ae]);

  return z ? $e.createElement(fe, {
    label: m,
    source: A,
    resource: W,
    className: zd("ra-input", "ra-input-".concat(A), o),
    isRequired: O
  }, $e.createElement(Be, null)) : $e.createElement($e.Fragment, null, $e.createElement(JN, i({
    margin: y,
    className: zd("ra-input", "ra-input-".concat(A), o),
    error: (ce || re) && oe,
    variant: L
  }, GN(k)), $e.createElement(HN, {
    ref: B,
    id: "".concat(m, "-outlined-label"),
    error: (ce || re) && oe
  }, $e.createElement(jN, {
    label: m,
    source: A,
    resource: W,
    isRequired: O
  })), $e.createElement(VN, E(i({
    autoWidth: !0,
    labelId: "".concat(m, "-outlined-label"),
    multiple: !0,
    error: (ce || re) && oe,
    renderValue: function renderValue(j) {
      return $e.createElement("div", {
        className: ss.chips
      }, j.map(function (yt) {
        return (M || []).find(function (bt) {
          return V(bt) === yt;
        });
      }).filter(function (yt) {
        return !!yt;
      }).map(function (yt) {
        return $e.createElement(qN, {
          key: V(yt),
          label: De(yt),
          className: ss.chip,
          size: "small"
        });
      }));
    },
    "data-testid": "selectArray",
    size: "small"
  }, w), {
    onChange: Q,
    value: w.value || []
  }), st.map(Zr)), $e.createElement(zN, {
    error: ce && !!te
  }, $e.createElement(Z, {
    touched: ce || re,
    error: te == null ? void 0 : te.message,
    helperText: d
  }))), we);
}, "SelectArrayInput");
Wd.propTypes = {
  choices: Se.arrayOf(Se.object),
  className: Se.string,
  children: Se.node,
  label: Se.oneOfType([Se.string, Se.bool]),
  options: Se.object,
  optionText: Se.oneOfType([Se.string, Se.func, Se.element]).isRequired,
  optionValue: Se.string.isRequired,
  disableValue: Se.string,
  resource: Se.string,
  source: Se.string,
  translateChoice: Se.bool
};
Wd.defaultProps = {
  options: {},
  optionText: "name",
  optionValue: "id",
  disableValue: "disabled",
  translateChoice: !0
};
var GN = n(function (He) {
  var Q = He,
      e = Q.alwaysOn,
      t = Q.choices,
      o = Q.classNamInputWithOptionsPropse,
      r = Q.componenInputWithOptionsPropst,
      a = Q.crudGetMInputWithOptionsPropsatching,
      s = Q.crudGetOInputWithOptionsPropsne,
      p = Q.defaultValue,
      c = Q.disableValue,
      d = Q.emptyText,
      m = Q.enableGetChoices,
      u = Q.filter,
      g = Q.filterToQuery,
      y = Q.formClassName,
      b = Q.initializeForm,
      P = Q.initialValue,
      T = Q.input,
      x = Q.isRequired,
      C = Q.label,
      v = Q.limitChoicesToValue,
      I = Q.loaded,
      N = Q.locale,
      F = Q.meta,
      S = Q.onChange,
      L = Q.options,
      k = Q.optionValue,
      B = Q.optionText,
      M = Q.perPage,
      z = Q.record,
      A = Q.reference,
      W = Q.resource,
      D = Q.setFilter,
      V = Q.setPagination,
      _ = Q.setSort,
      w = Q.sort,
      O = Q.source,
      te = Q.textAlign,
      oe = Q.translate,
      ce = Q.translateChoice,
      re = Q.validation,
      le = f(Q, ["alwaysOn", "choices", "classNamInputWithOptionsPropse", "componenInputWithOptionsPropst", "crudGetMInputWithOptionsPropsatching", "crudGetOInputWithOptionsPropsne", "defaultValue", "disableValue", "emptyText", "enableGetChoices", "filter", "filterToQuery", "formClassName", "initializeForm", "initialValue", "input", "isRequired", "label", "limitChoicesToValue", "loaded", "locale", "meta", "onChange", "options", "optionValue", "optionText", "perPage", "record", "reference", "resource", "setFilter", "setPagination", "setSort", "sort", "source", "textAlign", "translate", "translateChoice", "validation"]);
  return le;
}, "sanitizeRestProps"),
    jl = "RaSelectArrayInput",
    ss = {
  chips: "".concat(jl, "-chips"),
  chip: "".concat(jl, "-chip")
},
    JN = DN(WN, {
  name: jl,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref108) {
  var _ref109;

  var e = _ref108.theme;
  return _ref109 = {
    minWidth: e.spacing(20)
  }, _defineProperty(_ref109, "& .".concat(ss.chips), {
    display: "flex",
    flexWrap: "wrap"
  }), _defineProperty(_ref109, "& .".concat(ss.chip), {
    marginTop: e.spacing(.5),
    marginRight: e.spacing(.5)
  }), _ref109;
});
l();
import * as Xe from "react";
import { useCallback as is } from "react";
import pe from "prop-types";
import qd from "clsx";
import jd from "@mui/material/MenuItem";
import { styled as KN } from "@mui/material/styles";
import { useChoicesContext as YN, useInput as ZN, FieldTitle as eB, useTranslate as tB, useChoices as oB } from "ra-core";
var Nn = n(function (e) {
  var ho = e,
      t = ho.choices,
      o = ho.className,
      r = ho.create,
      a = ho.createLabel,
      s = ho.createValue,
      _ho$defaultValue = ho.defaultValue,
      p = _ho$defaultValue === void 0 ? "" : _ho$defaultValue,
      c = ho.disableValue,
      d = ho.emptyText,
      m = ho.emptyValue,
      u = ho.format,
      g = ho.filter,
      y = ho.helperText,
      b = ho.isFetching,
      P = ho.isLoading,
      T = ho.label,
      _ho$margin = ho.margin,
      x = _ho$margin === void 0 ? "dense" : _ho$margin,
      C = ho.onBlur,
      v = ho.onChange,
      I = ho.onCreate,
      N = ho.optionText,
      F = ho.optionValue,
      S = ho.parse,
      L = ho.resource,
      k = ho.source,
      B = ho.translateChoice,
      M = ho.validate,
      z = f(ho, ["choices", "className", "create", "createLabel", "createValue", "defaultValue", "disableValue", "emptyText", "emptyValue", "format", "filter", "helperText", "isFetching", "isLoading", "label", "margin", "onBlur", "onChange", "onCreate", "optionText", "optionValue", "parse", "resource", "source", "translateChoice", "validate"]),
      A = tB(),
      _YN = YN({
    choices: t,
    isLoading: P,
    isFetching: b,
    resource: L,
    source: k
  }),
      W = _YN.allChoices,
      D = _YN.isLoading,
      V = _YN.source,
      _ = _YN.resource,
      _oB = oB({
    optionText: N,
    optionValue: F,
    disableValue: c,
    translateChoice: B
  }),
      w = _oB.getChoiceText,
      O = _oB.getChoiceValue,
      te = _oB.getDisableValue,
      _ZN = ZN(i({
    defaultValue: p,
    format: u,
    parse: S,
    onBlur: C,
    onChange: v,
    resource: _,
    source: V,
    validate: M
  }, z)),
      oe = _ZN.field,
      ce = _ZN.fieldState,
      re = _ZN.id,
      le = _ZN.isRequired,
      He = _ZN.formState.isSubmitted,
      Q = ce.error,
      we = ce.invalid,
      ae = ce.isTouched,
      st = is(function () {
    return Xe.isValidElement(d) ? d : d === "" ? "\u2003" : A(d, {
      _: d
    });
  }, [d, A]),
      De = is(function (he) {
    return w(he);
  }, [w]),
      Zr = is( /*#__PURE__*/function () {
    var _ref110 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(he) {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              (he == null ? void 0 : he.target) ? oe.onChange(he) : oe.onChange(O(he));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref110.apply(this, arguments);
    };
  }(), [oe, O]),
      _mr3 = mr({
    create: r,
    createLabel: a,
    createValue: s,
    handleChange: Zr,
    onCreate: I,
    optionText: N
  }),
      bo = _mr3.getCreateItem,
      j = _mr3.handleChange,
      yt = _mr3.createElement,
      bt = r || I ? bo() : null,
      en = r || I ? [].concat(_toConsumableArray(W), [bt]) : W,
      Yo = is(function (he) {
    return he ? Xe.createElement(jd, {
      key: O(he),
      value: O(he),
      disabled: te(he)
    }, De(!!bt && (he == null ? void 0 : he.id) === bt.id ? bt : he)) : null;
  }, [O, te, De, bt]);

  return D ? Xe.createElement(fe, {
    label: T,
    source: V,
    resource: _,
    className: qd("ra-input", "ra-input-".concat(V), o),
    isRequired: le
  }, Xe.createElement(Be, null)) : Xe.createElement(Xe.Fragment, null, Xe.createElement(aB, i(E(i({
    id: re
  }, oe), {
    className: qd("ra-input", "ra-input-".concat(V), o),
    onChange: j,
    select: !0,
    label: T !== "" && T !== !1 && Xe.createElement(eB, {
      label: T,
      source: V,
      resource: _,
      isRequired: le
    }),
    clearAlwaysVisible: !0,
    error: (ae || He) && we,
    helperText: Xe.createElement(Z, {
      touched: ae || He,
      error: Q == null ? void 0 : Q.message,
      helperText: y
    }),
    margin: x
  }), rB(z)), Xe.createElement(jd, {
    value: m,
    key: "null",
    "aria-label": A("ra.action.clear_input_value"),
    title: A("ra.action.clear_input_value")
  }, st()), en.map(Yo)), yt);
}, "SelectInput");
Nn.propTypes = {
  emptyText: pe.oneOfType([pe.string, pe.element]),
  emptyValue: pe.any,
  choices: pe.arrayOf(pe.object),
  className: pe.string,
  label: pe.oneOfType([pe.string, pe.bool]),
  options: pe.object,
  optionText: pe.oneOfType([pe.string, pe.func, pe.element]).isRequired,
  optionValue: pe.string.isRequired,
  disableValue: pe.string,
  resettable: pe.bool,
  resource: pe.string,
  source: pe.string,
  translateChoice: pe.bool
};
Nn.defaultProps = {
  emptyText: "",
  emptyValue: "",
  options: {},
  optionText: "name",
  optionValue: "id",
  translateChoice: !0,
  disableValue: "disabled"
};
var rB = n(function (O) {
  var te = O,
      e = te.afterSubmit,
      t = te.allowNull,
      o = te.beforeSubmit,
      r = te.choices,
      a = te.className,
      s = te.crudGetMatching,
      p = te.crudGetOne,
      c = te.data,
      d = te.field,
      m = te.fieldState,
      u = te.formState,
      g = te.filter,
      y = te.filterToQuery,
      b = te.formatOnBlur,
      P = te.isEqual,
      T = te.limitChoicesToValue,
      x = te.multiple,
      C = te.name,
      v = te.pagination,
      I = te.perPage,
      N = te.ref,
      F = te.reference,
      S = te.refetch,
      L = te.render,
      k = te.setFilter,
      B = te.setPagination,
      M = te.setSort,
      z = te.sort,
      A = te.subscription,
      W = te.type,
      D = te.validateFields,
      V = te.validation,
      _ = te.value,
      w = f(te, ["afterSubmit", "allowNull", "beforeSubmit", "choices", "className", "crudGetMatching", "crudGetOne", "data", "field", "fieldState", "formState", "filter", "filterToQuery", "formatOnBlur", "isEqual", "limitChoicesToValue", "multiple", "name", "pagination", "perPage", "ref", "reference", "refetch", "render", "setFilter", "setPagination", "setSort", "sort", "subscription", "type", "validateFields", "validation", "value"]);
  return ne(w);
}, "sanitizeRestProps"),
    nB = "RaSelectInput",
    aB = KN(Tr, {
  name: nB,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref111) {
  var e = _ref111.theme;
  return E(i({}, Hl), {
    minWidth: e.spacing(20)
  });
});
l();
import * as Bn from "react";
import { styled as FB } from "@mui/material/styles";
import { TranslatableContextProvider as SB, useTranslatable as EB } from "ra-core";
l();
import * as ps from "react";
import { styled as fB } from "@mui/material/styles";
import { AppBar as gB, Tabs as yB } from "@mui/material";
import { useTranslatableContext as bB } from "ra-core";
l();
import sB from "react";
import { styled as iB } from "@mui/material/styles";
import lB from "@mui/material/Tab";
import { useFormGroup as pB, useTranslate as cB } from "ra-core";
import { capitalize as mB } from "inflection";
import dB from "clsx";
var Ud = n(function (e) {
  var c = e,
      _c$groupKey = c.groupKey,
      t = _c$groupKey === void 0 ? "" : _c$groupKey,
      o = c.locale,
      r = f(c, ["groupKey", "locale"]),
      _pB = pB("".concat(t).concat(o)),
      a = _pB.isValid,
      s = _pB.isTouched,
      p = cB();

  return sB.createElement(uB, i({
    id: "translatable-header-".concat(t).concat(o),
    label: p("ra.locales.".concat(o), {
      _: mB(o)
    }),
    className: dB(ls.root, _defineProperty({}, ls.error, !a && s))
  }, r));
}, "TranslatableInputsTab"),
    Ul = "RaTranslatableInputsTab",
    ls = {
  root: "".concat(Ul, "-root"),
  error: "".concat(Ul, "-error")
},
    uB = iB(lB, {
  name: Ul
})(function (_ref112) {
  var _ref113;

  var e = _ref112.theme;
  return _ref113 = {}, _defineProperty(_ref113, "&.".concat(ls.root), {
    fontSize: "0.8em",
    minHeight: e.spacing(3),
    minWidth: e.spacing(6)
  }), _defineProperty(_ref113, "&.".concat(ls.error), {
    color: e.palette.error.main
  }), _ref113;
});
var Xd = n(function (e) {
  var t = e.groupKey,
      o = e.TabsProps,
      _bB = bB(),
      r = _bB.locales,
      a = _bB.selectLocale,
      s = _bB.selectedLocale,
      p = n(function (c, d) {
    a(d);
  }, "handleChange");

  return ps.createElement(hB, {
    color: "default",
    position: "static",
    className: cs.root
  }, ps.createElement(yB, i({
    value: s,
    onChange: p,
    indicatorColor: "primary",
    textColor: "primary",
    className: cs.tabs
  }, o), r.map(function (c) {
    return ps.createElement(Ud, {
      key: c,
      value: c,
      locale: c,
      groupKey: t
    });
  })));
}, "TranslatableInputsTabs"),
    Xl = "RaTranslatableInputsTabs",
    cs = {
  root: "".concat(Xl, "-root"),
  tabs: "".concat(Xl, "-tabs")
},
    hB = fB(gB, {
  name: Xl
})(function (_ref114) {
  var _ref115;

  var e = _ref114.theme;
  return _ref115 = {}, _defineProperty(_ref115, "&.".concat(cs.root), {
    boxShadow: "none",
    borderRadius: 0,
    borderTopLeftRadius: e.shape.borderRadius,
    borderTopRightRadius: e.shape.borderRadius,
    border: "1px solid ".concat(e.palette.divider)
  }), _defineProperty(_ref115, "& .".concat(cs.tabs), {
    minHeight: e.spacing(3)
  }), _ref115;
});
l();
import * as Ql from "react";
import { styled as RB } from "@mui/material/styles";
import { Children as TB, cloneElement as PB, isValidElement as xB } from "react";
import { FormGroupContextProvider as CB, useTranslatableContext as vB } from "ra-core";
var Qd = n(function (e) {
  var u = e,
      t = u.children,
      _u$groupKey = u.groupKey,
      o = _u$groupKey === void 0 ? "" : _u$groupKey,
      r = u.locale,
      a = u.margin,
      s = u.variant,
      p = f(u, ["children", "groupKey", "locale", "margin", "variant"]),
      _vB = vB(),
      c = _vB.selectedLocale,
      d = _vB.getLabel,
      m = _vB.getSource;

  return Ql.createElement(CB, {
    name: "".concat(o).concat(r)
  }, Ql.createElement(IB, i({
    role: "tabpanel",
    hidden: c !== r,
    id: "translatable-content-".concat(o).concat(r),
    "aria-labelledby": "translatable-header-".concat(o).concat(r),
    className: Jd.root
  }, p), TB.map(t, function (g) {
    return xB(g) ? PB(g, E(i({}, g.props), {
      label: d(g.props.source, g.props.label),
      source: m(g.props.source, r)
    })) : null;
  })));
}, "TranslatableInputsTabContent"),
    Gd = "RaTranslatableInputsTabContent",
    Jd = {
  root: "".concat(Gd, "-root")
},
    IB = RB("div", {
  name: Gd
})(function (_ref116) {
  var e = _ref116.theme;
  return _defineProperty({}, "&.".concat(Jd.root), {
    flexGrow: 1,
    paddingLeft: e.spacing(2),
    paddingRight: e.spacing(2),
    paddingTop: e.spacing(1),
    paddingBottom: e.spacing(1),
    borderRadius: 0,
    borderBottomLeftRadius: e.shape.borderRadius,
    borderBottomRightRadius: e.shape.borderRadius,
    border: "1px solid ".concat(e.palette.divider),
    borderTop: 0
  });
});
var wK = n(function (e) {
  var t = e.className,
      o = e.defaultLocale,
      r = e.locales,
      _e$groupKey = e.groupKey,
      a = _e$groupKey === void 0 ? "" : _e$groupKey,
      _e$selector = e.selector,
      s = _e$selector === void 0 ? Bn.createElement(Xd, {
    groupKey: a
  }) : _e$selector,
      p = e.children,
      c = e.variant,
      d = e.margin,
      m = EB({
    defaultLocale: o,
    locales: r
  });
  return Bn.createElement(BB, {
    className: t
  }, Bn.createElement(SB, {
    value: m
  }, s, r.map(function (u) {
    return Bn.createElement(Qd, {
      key: u,
      locale: u,
      groupKey: a,
      variant: c,
      margin: d
    }, p);
  })));
}, "TranslatableInputs"),
    NB = "RaTranslatableInputs",
    BB = FB("div", {
  name: NB,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref118) {
  var e = _ref118.theme;
  return {
    flexGrow: 1,
    marginTop: e.spacing(1),
    marginBottom: e.spacing(.5)
  };
});
var Gl = n(function (e) {
  var t = e.redirectTo,
      o = e.className,
      _B2 = _B(!1),
      _B3 = _slicedToArray(_B2, 2),
      r = _B3[0],
      a = _B3[1],
      s = MB(),
      p = DB(),
      c = VB();

  return qo.createElement(HB, {
    onSubmit: n(function (m) {
      a(!0), s(m, t).then(function () {
        a(!1);
      }).catch(function (u) {
        a(!1), c(typeof u == "string" ? u : typeof u == "undefined" || !u.message ? "ra.auth.sign_in_error" : u.message, {
          type: "warning",
          messageArgs: {
            _: typeof u == "string" ? u : u && u.message ? u.message : void 0
          }
        });
      });
    }, "submit"),
    mode: "onChange",
    noValidate: !0,
    className: o
  }, qo.createElement(AB, {
    className: Ir.content
  }, qo.createElement(Fe, {
    autoFocus: !0,
    source: "username",
    label: p("ra.auth.username"),
    validate: Kd(),
    fullWidth: !0
  }), qo.createElement(Fe, {
    source: "password",
    label: p("ra.auth.password"),
    type: "password",
    autoComplete: "current-password",
    validate: Kd(),
    fullWidth: !0
  }), qo.createElement(wB, {
    variant: "contained",
    type: "submit",
    color: "primary",
    disabled: r,
    fullWidth: !0,
    className: Ir.button
  }, r ? qo.createElement($B, {
    className: Ir.icon,
    size: 19,
    thickness: 3
  }) : p("ra.auth.sign_in"))));
}, "LoginForm"),
    ms = "RaLoginForm",
    Ir = {
  content: "".concat(ms, "-content"),
  button: "".concat(ms, "-button"),
  icon: "".concat(ms, "-icon")
},
    HB = LB(OB, {
  name: ms,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref119) {
  var _ref120;

  var e = _ref119.theme;
  return _ref120 = {}, _defineProperty(_ref120, "& .".concat(Ir.content), {
    width: 300
  }), _defineProperty(_ref120, "& .".concat(Ir.button), {
    marginTop: e.spacing(2)
  }), _defineProperty(_ref120, "& .".concat(Ir.icon), {
    margin: e.spacing(.3)
  }), _ref120;
});
Gl.propTypes = {
  redirectTo: kB.string
};
var ds = n(function (e) {
  var u = e,
      t = u.children,
      o = u.backgroundImage,
      r = f(u, ["children", "backgroundImage"]),
      a = zB(),
      s = !1,
      p = QB(),
      c = XB();
  Yd(function () {
    p({}, !1).then(function () {
      c("/");
    }).catch(function () {});
  }, [p, c]);
  var d = n(function () {
    !s && a.current && (a.current.style.backgroundImage = "url(".concat(o, ")"), s = !0);
  }, "updateBackgroundImage"),
      m = n(function () {
    if (o) {
      var g = new Image();
      g.onload = d, g.src = o;
    }
  }, "lazyLoadBackgroundImage");
  return Yd(function () {
    s || m();
  }), jo.createElement(GB, E(i({}, r), {
    ref: a
  }), jo.createElement(WB, {
    className: Fr.card
  }, jo.createElement("div", {
    className: Fr.avatar
  }, jo.createElement(qB, {
    className: Fr.icon
  }, jo.createElement(UB, null))), t));
}, "Login"),
    us = "RaLogin",
    Fr = {
  card: "".concat(us, "-card"),
  avatar: "".concat(us, "-avatar"),
  icon: "".concat(us, "-icon")
},
    GB = jB("div", {
  name: us,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref121) {
  var _ref122;

  var e = _ref121.theme;
  return _ref122 = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    height: "1px",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: "radial-gradient(circle at 50% 14em, #313264 0%, #00023b 60%, #00023b 100%)"
  }, _defineProperty(_ref122, "& .".concat(Fr.card), {
    minWidth: 300,
    marginTop: "6em"
  }), _defineProperty(_ref122, "& .".concat(Fr.avatar), {
    margin: "1em",
    display: "flex",
    justifyContent: "center"
  }), _defineProperty(_ref122, "& .".concat(Fr.icon), {
    backgroundColor: e.palette.secondary[500]
  }), _ref122;
});
ds.propTypes = {
  backgroundImage: Jl.string,
  children: Jl.node,
  className: Jl.string
};
ds.defaultProps = {
  children: jo.createElement(Gl, null)
};
l();
var Zd = {
  palette: {
    background: {
      default: "#fafafb"
    },
    secondary: {
      light: "#6ec6ff",
      main: "#2196f3",
      dark: "#0069c0",
      contrastText: "#fff"
    }
  },
  typography: {
    h6: {
      fontWeight: 400
    }
  },
  sidebar: {
    width: 240,
    closedWidth: 50
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      },
      styleOverrides: {
        root: {
          "&:hover:active::after": {
            content: '""',
            display: "block",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: "currentColor",
            opacity: .3,
            borderRadius: "inherit"
          },
          "&:focus::after": {
            content: '""',
            display: "block",
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: "currentColor",
            opacity: .3,
            borderRadius: "inherit"
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          "&$disabled": {
            backgroundColor: "rgba(0, 0, 0, 0.04)"
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "filled",
        margin: "dense",
        size: "small"
      }
    },
    MuiFormControl: {
      defaultProps: {
        variant: "filled",
        margin: "dense",
        size: "small"
      }
    }
  }
};
l();
import * as Yl from "react";
import ge from "prop-types";
import { useCheckMinimumRequiredProps as tL } from "ra-core";
l();
import * as Ln from "react";
import Pe from "prop-types";
import { Card as JB } from "@mui/material";
import { styled as KB } from "@mui/material/styles";
import { useCreateContext as YB } from "ra-core";
import eu from "clsx";
var Kl = n(function (e) {
  var m = e,
      t = m.actions,
      o = m.aside,
      r = m.children,
      a = m.className,
      _m$component = m.component,
      s = _m$component === void 0 ? JB : _m$component,
      p = m.title,
      c = f(m, ["actions", "aside", "children", "className", "component", "title"]),
      _YB = YB(e),
      d = _YB.defaultTitle;

  return Ln.createElement(eL, i({
    className: eu("create-page", a)
  }, ZB(c)), Ln.createElement(je, {
    title: p,
    defaultTitle: d
  }), t, Ln.createElement("div", {
    className: eu(Sr.main, _defineProperty({}, Sr.noActions, !t))
  }, Ln.createElement(s, {
    className: Sr.card
  }, r), o));
}, "CreateView");
Kl.propTypes = {
  actions: Pe.oneOfType([Pe.element, Pe.bool]),
  aside: Pe.element,
  children: Pe.element,
  className: Pe.string,
  defaultTitle: Pe.any,
  hasList: Pe.bool,
  hasShow: Pe.bool,
  mutationOptions: Pe.object,
  record: Pe.object,
  redirect: Pe.oneOfType([Pe.string, Pe.bool, Pe.func]),
  resource: Pe.string,
  save: Pe.func,
  title: Pe.node
};
var ZB = n(function (C) {
  var v = C,
      _v$defaultTitle = v.defaultTitle,
      e = _v$defaultTitle === void 0 ? null : _v$defaultTitle,
      _v$hasCreate = v.hasCreate,
      t = _v$hasCreate === void 0 ? null : _v$hasCreate,
      _v$hasEdit = v.hasEdit,
      o = _v$hasEdit === void 0 ? null : _v$hasEdit,
      _v$hasList = v.hasList,
      r = _v$hasList === void 0 ? null : _v$hasList,
      _v$hasShow = v.hasShow,
      a = _v$hasShow === void 0 ? null : _v$hasShow,
      _v$history = v.history,
      s = _v$history === void 0 ? null : _v$history,
      _v$isFetching = v.isFetching,
      p = _v$isFetching === void 0 ? null : _v$isFetching,
      _v$isLoading = v.isLoading,
      c = _v$isLoading === void 0 ? null : _v$isLoading,
      _v$location = v.location,
      d = _v$location === void 0 ? null : _v$location,
      _v$match = v.match,
      m = _v$match === void 0 ? null : _v$match,
      _v$mutationOptions = v.mutationOptions,
      u = _v$mutationOptions === void 0 ? null : _v$mutationOptions,
      _v$options = v.options,
      g = _v$options === void 0 ? null : _v$options,
      _v$permissions = v.permissions,
      y = _v$permissions === void 0 ? null : _v$permissions,
      _v$save = v.save,
      b = _v$save === void 0 ? null : _v$save,
      _v$saving = v.saving,
      P = _v$saving === void 0 ? null : _v$saving,
      _v$transform = v.transform,
      T = _v$transform === void 0 ? null : _v$transform,
      x = f(v, ["defaultTitle", "hasCreate", "hasEdit", "hasList", "hasShow", "history", "isFetching", "isLoading", "location", "match", "mutationOptions", "options", "permissions", "save", "saving", "transform"]);
  return x;
}, "sanitizeRestProps"),
    fs = "RaCreate",
    Sr = {
  main: "".concat(fs, "-main"),
  noActions: "".concat(fs, "-noActions"),
  card: "".concat(fs, "-card")
},
    eL = KB("div", {
  name: fs,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref123) {
  var _ref124;

  var e = _ref123.theme;
  return _ref124 = {}, _defineProperty(_ref124, "& .".concat(Sr.main), {
    display: "flex"
  }), _defineProperty(_ref124, "& .".concat(Sr.noActions), _defineProperty({}, e.breakpoints.up("sm"), {
    marginTop: "1em"
  })), _defineProperty(_ref124, "& .".concat(Sr.card), {
    flex: "1 1 auto"
  }), _ref124;
});
import { CreateBase as oL } from "ra-core";
var rL = n(function (e) {
  tL("Create", ["children"], e);
  var u = e,
      t = u.resource,
      o = u.record,
      r = u.redirect,
      a = u.transform,
      s = u.mutationOptions,
      p = u.disableAuthentication,
      c = u.hasEdit,
      d = u.hasShow,
      m = f(u, ["resource", "record", "redirect", "transform", "mutationOptions", "disableAuthentication", "hasEdit", "hasShow"]);
  return Yl.createElement(oL, {
    resource: t,
    record: o,
    redirect: r,
    transform: a,
    mutationOptions: s,
    disableAuthentication: p,
    hasEdit: c,
    hasShow: d
  }, Yl.createElement(Kl, i({}, m)));
}, "Create");
rL.propTypes = {
  actions: ge.oneOfType([ge.element, ge.bool]),
  aside: ge.element,
  children: ge.element,
  className: ge.string,
  disableAuthentication: ge.bool,
  hasEdit: ge.bool,
  hasShow: ge.bool,
  redirect: ge.oneOfType([ge.string, ge.bool, ge.func]),
  resource: ge.string,
  title: ge.node,
  record: ge.object,
  mutationOptions: ge.object,
  transform: ge.func,
  sx: ge.any
};
l();
import * as Zl from "react";
import Er from "prop-types";
import { useResourceDefinition as nL } from "ra-core";
var aL = n(function (o) {
  var r = o,
      e = r.className,
      t = f(r, ["className"]);

  var _nL = nL(t),
      a = _nL.hasList;

  return Zl.createElement(xt, i({
    className: e
  }, sL(t)), a && Zl.createElement(ci, null));
}, "CreateActions"),
    sL = n(function (a) {
  var s = a,
      _s$className = s.className,
      e = _s$className === void 0 ? null : _s$className,
      _s$hasList = s.hasList,
      t = _s$hasList === void 0 ? null : _s$hasList,
      _s$resource = s.resource,
      o = _s$resource === void 0 ? null : _s$resource,
      r = f(s, ["className", "hasList", "resource"]);
  return r;
}, "sanitizeRestProps");
aL.propTypes = {
  className: Er.string,
  hasCreate: Er.bool,
  hasEdit: Er.bool,
  hasShow: Er.bool,
  hasList: Er.bool,
  resource: Er.string
};
l();
import * as op from "react";
import se from "prop-types";
import { useCheckMinimumRequiredProps as hL } from "ra-core";
l();
import * as Xo from "react";
import { styled as cL } from "@mui/material/styles";
import ye from "prop-types";
import { Card as mL, CardContent as dL } from "@mui/material";
import tu from "clsx";
import { ComponentPropType as uL, useEditContext as fL, useResourceDefinition as gL } from "ra-core";
l();
import * as ep from "react";
import Uo from "prop-types";
import { useEditContext as iL, useResourceDefinition as lL } from "ra-core";
var tp = n(function (o) {
  var r = o,
      e = r.className,
      t = f(r, ["className"]);

  var _iL = iL(t),
      a = _iL.record,
      _lL = lL(t),
      s = _lL.hasShow;

  return ep.createElement(xt, i({
    className: e
  }, pL(t)), s && ep.createElement(zs, {
    record: a
  }));
}, "EditActions"),
    pL = n(function (s) {
  var p = s,
      _p$hasCreate = p.hasCreate,
      e = _p$hasCreate === void 0 ? null : _p$hasCreate,
      _p$hasEdit = p.hasEdit,
      t = _p$hasEdit === void 0 ? null : _p$hasEdit,
      _p$hasShow = p.hasShow,
      o = _p$hasShow === void 0 ? null : _p$hasShow,
      _p$hasList = p.hasList,
      r = _p$hasList === void 0 ? null : _p$hasList,
      a = f(p, ["hasCreate", "hasEdit", "hasShow", "hasList"]);
  return a;
}, "sanitizeRestProps");
tp.propTypes = {
  className: Uo.string,
  data: Uo.object,
  hasCreate: Uo.bool,
  hasEdit: Uo.bool,
  hasShow: Uo.bool,
  hasList: Uo.bool,
  resource: Uo.string
};
var Nr = n(function (e) {
  var b = e,
      t = b.actions,
      o = b.aside,
      r = b.children,
      a = b.className,
      _b$component = b.component,
      s = _b$component === void 0 ? mL : _b$component,
      p = b.title,
      c = b.mutationMode,
      d = f(b, ["actions", "aside", "children", "className", "component", "title", "mutationMode"]),
      _gL = gL(),
      m = _gL.hasShow,
      _fL = fL(e),
      u = _fL.defaultTitle,
      g = _fL.record,
      y = typeof t == "undefined" && m ? Xo.createElement(tp, null) : t;

  return r ? Xo.createElement(bL, i({
    className: tu("edit-page", a)
  }, yL(d)), Xo.createElement(je, {
    title: p,
    defaultTitle: u
  }), y, Xo.createElement("div", {
    className: tu(Br.main, _defineProperty({}, Br.noActions, !y))
  }, Xo.createElement(s, {
    className: Br.card
  }, g ? r : Xo.createElement(dL, null, "\xA0")), o)) : null;
}, "EditView");
Nr.propTypes = {
  actions: ye.oneOfType([ye.element, ye.bool]),
  aside: ye.element,
  children: ye.element,
  className: ye.string,
  component: uL,
  defaultTitle: ye.any,
  hasList: ye.bool,
  hasShow: ye.bool,
  mutationMode: ye.oneOf(["pessimistic", "optimistic", "undoable"]),
  mutationOptions: ye.object,
  record: ye.object,
  redirect: ye.oneOfType([ye.string, ye.bool, ye.func]),
  resource: ye.string,
  save: ye.func,
  title: ye.node
};
var yL = n(function (F) {
  var S = F,
      _S$defaultTitle = S.defaultTitle,
      e = _S$defaultTitle === void 0 ? null : _S$defaultTitle,
      _S$hasCreate = S.hasCreate,
      t = _S$hasCreate === void 0 ? null : _S$hasCreate,
      _S$hasEdit = S.hasEdit,
      o = _S$hasEdit === void 0 ? null : _S$hasEdit,
      _S$hasList = S.hasList,
      r = _S$hasList === void 0 ? null : _S$hasList,
      _S$hasShow = S.hasShow,
      a = _S$hasShow === void 0 ? null : _S$hasShow,
      _S$history = S.history,
      s = _S$history === void 0 ? null : _S$history,
      _S$id = S.id,
      p = _S$id === void 0 ? null : _S$id,
      _S$isFetching = S.isFetching,
      c = _S$isFetching === void 0 ? null : _S$isFetching,
      _S$isLoading = S.isLoading,
      d = _S$isLoading === void 0 ? null : _S$isLoading,
      _S$location = S.location,
      m = _S$location === void 0 ? null : _S$location,
      _S$match = S.match,
      u = _S$match === void 0 ? null : _S$match,
      _S$options = S.options,
      g = _S$options === void 0 ? null : _S$options,
      _S$queryOptions = S.queryOptions,
      y = _S$queryOptions === void 0 ? null : _S$queryOptions,
      _S$mutationOptions = S.mutationOptions,
      b = _S$mutationOptions === void 0 ? null : _S$mutationOptions,
      _S$permissions = S.permissions,
      P = _S$permissions === void 0 ? null : _S$permissions,
      _S$refetch = S.refetch,
      T = _S$refetch === void 0 ? null : _S$refetch,
      _S$resource = S.resource,
      x = _S$resource === void 0 ? null : _S$resource,
      _S$save = S.save,
      C = _S$save === void 0 ? null : _S$save,
      _S$saving = S.saving,
      v = _S$saving === void 0 ? null : _S$saving,
      _S$transform = S.transform,
      I = _S$transform === void 0 ? null : _S$transform,
      N = f(S, ["defaultTitle", "hasCreate", "hasEdit", "hasList", "hasShow", "history", "id", "isFetching", "isLoading", "location", "match", "options", "queryOptions", "mutationOptions", "permissions", "refetch", "resource", "save", "saving", "transform"]);
  return N;
}, "sanitizeRestProps"),
    gs = "RaEdit",
    Br = {
  main: "".concat(gs, "-main"),
  noActions: "".concat(gs, "-noActions"),
  card: "".concat(gs, "-card")
},
    bL = cL("div", {
  name: gs,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})((_cL = {}, _defineProperty(_cL, "& .".concat(Br.main), {
  display: "flex",
  alignItems: "flex-start"
}), _defineProperty(_cL, "& .".concat(Br.noActions), {
  marginTop: "1em"
}), _defineProperty(_cL, "& .".concat(Br.card), {
  flex: "1 1 auto"
}), _cL));
import { EditBase as RL } from "ra-core";
var TL = n(function (e) {
  hL("Edit", ["children"], e);
  var u = e,
      t = u.resource,
      o = u.id,
      r = u.mutationMode,
      a = u.mutationOptions,
      s = u.queryOptions,
      p = u.redirect,
      c = u.transform,
      d = u.disableAuthentication,
      m = f(u, ["resource", "id", "mutationMode", "mutationOptions", "queryOptions", "redirect", "transform", "disableAuthentication"]);
  return op.createElement(RL, {
    resource: t,
    id: o,
    mutationMode: r,
    mutationOptions: a,
    queryOptions: s,
    redirect: p,
    transform: c,
    disableAuthentication: d
  }, op.createElement(Nr, i({}, m)));
}, "Edit");
TL.propTypes = {
  actions: se.oneOfType([se.element, se.bool]),
  aside: se.element,
  children: se.node,
  className: se.string,
  disableAuthentication: se.bool,
  hasCreate: se.bool,
  hasEdit: se.bool,
  hasShow: se.bool,
  hasList: se.bool,
  id: se.any,
  mutationMode: se.oneOf(["pessimistic", "optimistic", "undoable"]),
  mutationOptions: se.object,
  queryOptions: se.object,
  redirect: se.oneOfType([se.string, se.bool, se.func]),
  resource: se.string,
  title: se.node,
  transform: se.func,
  sx: se.any
};
l();
import * as An from "react";
l();
import * as ip from "react";
import { Children as su, isValidElement as iu } from "react";
import Qe from "prop-types";
import { Form as KL } from "ra-core";
import YL from "lodash/get";
l();
import * as ut from "react";
import { Children as kL, cloneElement as wL, isValidElement as AL, useState as $L } from "react";
import qt from "prop-types";
import OL from "clsx";
import { Routes as DL, Route as ML, matchPath as VL, useResolvedPath as _L, useLocation as HL } from "react-router-dom";
import { CardContent as zL, Divider as WL } from "@mui/material";
import { styled as qL } from "@mui/material/styles";
import { useResourceContext as jL } from "ra-core";
l();
import * as kn from "react";
import { styled as PL } from "@mui/material/styles";
import { Children as xL } from "react";
import ys from "prop-types";
import { Toolbar as CL, useMediaQuery as vL } from "@mui/material";
import IL from "clsx";
var wn = n(function (e) {
  var _IL;

  var p = e,
      t = p.children,
      o = p.className,
      r = p.resource,
      a = f(p, ["children", "className", "resource"]),
      s = vL(function (c) {
    return c.breakpoints.down("sm");
  });
  return kn.createElement(FL, i({
    className: IL((_IL = {}, _defineProperty(_IL, Lr.mobileToolbar, s), _defineProperty(_IL, Lr.desktopToolbar, !s), _IL), o),
    role: "toolbar"
  }, a), xL.count(t) === 0 ? kn.createElement("div", {
    className: Lr.defaultToolbar
  }, kn.createElement(gi, null), kn.createElement(ri, {
    resource: r
  })) : t);
}, "Toolbar");
wn.propTypes = {
  children: ys.node,
  className: ys.string,
  record: ys.any,
  resource: ys.string
};
var bs = "RaToolbar",
    Lr = {
  desktopToolbar: "".concat(bs, "-desktopToolbar"),
  mobileToolbar: "".concat(bs, "-mobileToolbar"),
  defaultToolbar: "".concat(bs, "-defaultToolbar")
},
    FL = PL(CL, {
  name: bs,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref125) {
  var _ref126;

  var e = _ref125.theme;
  return _ref126 = {
    backgroundColor: e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[900]
  }, _defineProperty(_ref126, "&.".concat(Lr.desktopToolbar), {}), _defineProperty(_ref126, "&.".concat(Lr.mobileToolbar), {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "16px",
    width: "100%",
    boxSizing: "border-box",
    flexShrink: 0,
    zIndex: 2
  }), _defineProperty(_ref126, "& .".concat(Lr.defaultToolbar), {
    flex: 1,
    display: "flex",
    justifyContent: "space-between"
  }), _ref126;
});
l();
import * as ou from "react";
import { Children as SL, cloneElement as EL, isValidElement as NL } from "react";
import hs from "prop-types";
import BL from "@mui/material/Tabs";
import { useParams as LL } from "react-router-dom";
var rp = n(function (e) {
  var d = e,
      t = d.children,
      o = d.url,
      r = d.syncWithLocation,
      a = d.value,
      s = f(d, ["children", "url", "syncWithLocation", "value"]),
      c = LL()["*"];
  return ou.createElement(BL, i({
    value: r ? c : a,
    indicatorColor: "primary"
  }, s), SL.map(t, function (m, u) {
    if (!NL(m)) return null;
    var g = np(m, u);
    return EL(m, {
      intent: "header",
      value: r ? g : u,
      syncWithLocation: r
    });
  }));
}, "TabbedFormTabs");
rp.propTypes = {
  children: hs.node,
  url: hs.string,
  tabsWithErrors: hs.arrayOf(hs.string)
};
var np = n(function (e, t) {
  return e.props.path != null ? e.props.path : t > 0 ? t.toString() : "";
}, "getTabbedFormTabFullPath");
var ap = n(function (e) {
  var t = e.children,
      o = e.className,
      _e$component = e.component,
      r = _e$component === void 0 ? XL : _e$component,
      a = e.formRootPathname,
      _e$syncWithLocation = e.syncWithLocation,
      s = _e$syncWithLocation === void 0 ? !0 : _e$syncWithLocation,
      _e$tabs = e.tabs,
      p = _e$tabs === void 0 ? UL : _e$tabs,
      _e$toolbar = e.toolbar,
      c = _e$toolbar === void 0 ? QL : _e$toolbar,
      d = HL(),
      m = _L(""),
      u = jL(e),
      _$L = $L(0),
      _$L2 = _slicedToArray(_$L, 2),
      g = _$L2[0],
      y = _$L2[1],
      b = n(function (T, x) {
    s || y(x);
  }, "handleTabChange"),
      P = n(function () {
    return wL(p, {
      onChange: b,
      syncWithLocation: s,
      url: a,
      value: g
    }, t);
  }, "renderTabHeaders");

  return ut.createElement(GL, {
    className: OL("tabbed-form", o)
  }, s ? ut.createElement(DL, null, ut.createElement(ML, {
    path: "/*",
    element: P()
  })) : P(), ut.createElement(WL, null), ut.createElement(r, null, kL.map(t, function (T, x) {
    if (!T) return null;
    var C = np(T, x),
        v = s ? !VL("".concat(m.pathname, "/").concat(C), d.pathname) : g !== x;
    return AL(T) ? ut.cloneElement(T, {
      intent: "content",
      resource: u,
      hidden: v,
      value: s ? C : x
    }) : null;
  })), c);
}, "TabbedFormView");
ap.propTypes = {
  children: qt.node,
  className: qt.string,
  location: qt.object,
  match: qt.object,
  resource: qt.string,
  tabs: qt.element,
  toolbar: qt.element,
  validate: qt.func,
  value: qt.number
};
var UL = ut.createElement(rp, null),
    XL = n(function (_ref127) {
  var e = _ref127.children;
  return ut.createElement(zL, null, e);
}, "DefaultComponent"),
    QL = ut.createElement(wn, null),
    ru = "RaTabbedForm",
    sp = {
  errorTabButton: "".concat(ru, "-errorTabButton")
},
    GL = qL("div", {
  name: ru,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref128) {
  var e = _ref128.theme;
  return _defineProperty({}, "& .MuiTab-root.".concat(sp.errorTabButton), {
    color: e.palette.error.main
  });
});
l();
import { matchPath as nu, useLocation as JL } from "react-router-dom";
var au = n(function () {
  var e = JL(),
      t = nu(":resource/create/*", e.pathname),
      o = nu(":resource/:id/*", e.pathname);
  return t ? t.pathnameBase : o ? o.pathnameBase : "";
}, "useFormRootPath");
var ZL = n(function (e) {
  var t = au();
  return ip.createElement(KL, i({
    formRootPathname: t
  }, e), ip.createElement(ap, i({
    formRootPathname: t
  }, e)));
}, "TabbedForm");
ZL.propTypes = {
  children: Qe.node,
  defaultValues: Qe.oneOfType([Qe.object, Qe.func]),
  formRootPathname: Qe.string,
  mutationMode: Qe.oneOf(["pessimistic", "optimistic", "undoable"]),
  record: Qe.object,
  redirect: Qe.oneOfType([Qe.string, Qe.bool, Qe.func]),
  saving: Qe.bool,
  validate: Qe.func
};
var A7 = n(function (e, t) {
  return console.warn("Deprecated. FormTab now wrap their content inside a FormGroupContextProvider. If you implemented custom forms with tabs, please use the FormGroupContextProvider. See https://marmelab.com/react-admin/EditTutorial.html#grouping-inputs"), su.toArray(e).reduce(function (o, r) {
    return iu(r) && su.toArray(r.props.children).some(function (s) {
      return iu(s) && YL(t, s.props.source);
    }) ? [].concat(_toConsumableArray(o), [r.props.label]) : o;
  }, []);
}, "findTabsWithErrors");
l();
import * as Rs from "react";
import _e from "prop-types";
import { FormGroupContextProvider as lk } from "ra-core";
import { Stack as pk } from "@mui/material";
l();
import * as lu from "react";
import { isValidElement as ek } from "react";
import Ee from "prop-types";
import { Link as tk, useLocation as ok } from "react-router-dom";
import { Tab as rk } from "@mui/material";
import nk from "clsx";
import { useTranslate as ak, useFormGroup as sk } from "ra-core";
import { useFormState as ik } from "react-hook-form";
var lp = n(function (c) {
  var _nk;

  var d = c,
      e = d.label,
      t = d.value,
      o = d.icon,
      r = d.className,
      a = d.onChange,
      s = d.syncWithLocation,
      p = f(d, ["label", "value", "icon", "className", "onChange", "syncWithLocation"]);

  var m = ak(),
      u = ok(),
      _ik = ik(),
      g = _ik.isSubmitted,
      y = sk(t.toString()),
      b = {
    component: tk,
    to: E(i({}, u), {
      pathname: t
    })
  };

  return lu.createElement(rk, i(E(i({
    label: ek(e) ? e : m(e, {
      _: e
    }),
    value: t,
    icon: o,
    className: nk("form-tab", r, (_nk = {}, _defineProperty(_nk, sp.errorTabButton, !y.isValid && (y.isTouched || g)), _defineProperty(_nk, "error", !y.isValid && (y.isTouched || g)), _nk))
  }, s ? b : {}), {
    id: "tabheader-".concat(t),
    "aria-controls": "tabpanel-".concat(t),
    onChange: a
  }), p));
}, "FormTabHeader");
lp.propTypes = {
  className: Ee.string,
  contentClassName: Ee.string,
  children: Ee.node,
  intent: Ee.oneOf(["header", "content"]),
  hidden: Ee.bool,
  icon: Ee.element,
  label: Ee.oneOfType([Ee.string, Ee.element]).isRequired,
  margin: Ee.oneOf(["none", "dense", "normal"]),
  path: Ee.string,
  record: Ee.object,
  resource: Ee.string,
  value: Ee.oneOfType([Ee.string, Ee.number]),
  variant: Ee.oneOf(["standard", "outlined", "filled"])
};
var pu = n(function (e) {
  var x = e,
      t = x.className,
      o = x.contentClassName,
      r = x.children,
      a = x.hidden,
      s = x.icon,
      p = x.intent,
      c = x.label,
      d = x.onChange,
      m = x.path,
      u = x.resource,
      g = x.syncWithLocation,
      y = x.value,
      b = f(x, ["className", "contentClassName", "children", "hidden", "icon", "intent", "label", "onChange", "path", "resource", "syncWithLocation", "value"]);
  return p === "header" ? n(function () {
    return Rs.createElement(lp, {
      label: c,
      value: y,
      icon: s,
      className: t,
      syncWithLocation: g,
      onChange: d
    });
  }, "renderHeader")() : n(function () {
    return Rs.createElement(lk, {
      name: y.toString()
    }, Rs.createElement(pk, i({
      alignItems: "flex-start",
      style: a ? ck : null,
      className: o,
      id: "tabpanel-".concat(y),
      "aria-labelledby": "tabheader-".concat(y),
      "aria-hidden": a || void 0
    }, b), r));
  }, "renderContent")();
}, "FormTab");
pu.propTypes = {
  className: _e.string,
  contentClassName: _e.string,
  children: _e.node,
  intent: _e.oneOf(["header", "content"]),
  hidden: _e.bool,
  icon: _e.element,
  label: _e.oneOfType([_e.string, _e.element]).isRequired,
  path: _e.string,
  resource: _e.string,
  value: _e.oneOfType([_e.string, _e.number])
};
pu.displayName = "FormTab";
var ck = {
  display: "none"
};
l();
import * as kr from "react";
import Ge from "prop-types";
import { Form as mk } from "ra-core";
import { Stack as dk, CardContent as uk } from "@mui/material";
var pp = n(function (e) {
  var c = e,
      t = c.children,
      o = c.className,
      _c$component = c.component,
      r = _c$component === void 0 ? fk : _c$component,
      a = c.sx,
      _c$toolbar = c.toolbar,
      s = _c$toolbar === void 0 ? gk : _c$toolbar,
      p = f(c, ["children", "className", "component", "sx", "toolbar"]);
  return kr.createElement(mk, i({}, p), kr.createElement(r, {
    className: o,
    sx: a
  }, kr.createElement(dk, i({
    alignItems: "flex-start"
  }, yk(e)), t)), s);
}, "SimpleForm");
pp.propTypes = {
  children: Ge.node,
  defaultValues: Ge.oneOfType([Ge.object, Ge.func]),
  record: Ge.object,
  redirect: Ge.oneOfType([Ge.string, Ge.bool, Ge.func]),
  toolbar: Ge.oneOfType([Ge.element, Ge.oneOf([!1])]),
  validate: Ge.func
};
var fk = n(function (_ref130) {
  var e = _ref130.children,
      t = _ref130.sx,
      o = _ref130.className;
  return kr.createElement(uk, {
    sx: t,
    className: o
  }, e);
}, "DefaultComponent"),
    gk = kr.createElement(wn, null),
    yk = n(function (P) {
  var T = P,
      e = T.children,
      t = T.className,
      o = T.component,
      r = T.defaultValues,
      a = T.onSubmit,
      s = T.record,
      p = T.resource,
      c = T.reValidateMode,
      d = T.sx,
      m = T.toolbar,
      u = T.validate,
      g = T.resolver,
      y = T.warnWhenUnsavedChanges,
      b = f(T, ["children", "className", "component", "defaultValues", "onSubmit", "record", "resource", "reValidateMode", "sx", "toolbar", "validate", "resolver", "warnWhenUnsavedChanges"]);
  return b;
}, "sanitizeRestProps");
var cp = {
  form: {
    component: pp,
    representation: function representation(e, t) {
      return "        <SimpleForm>\n".concat(t.map(function (o) {
        return "            ".concat(o.getRepresentation());
      }).join("\n"), "\n        </SimpleForm>");
    }
  },
  array: {
    component: function component(o) {
      var r = o,
          e = r.children,
          t = f(r, ["children"]);
      return An.createElement(Xi, i({}, t), An.createElement(Na, null, e));
    },
    representation: function representation(e, t) {
      return "<ArrayInput source=\"".concat(e.source, "\"><SimpleFormIterator>").concat(t.map(function (o) {
        return o.getRepresentation();
      }).join("\n"), "</SimpleFormIterator></ArrayInput>");
    }
  },
  boolean: {
    component: Ba,
    representation: function representation(e) {
      return "<BooleanInput source=\"".concat(e.source, "\" />");
    }
  },
  date: {
    component: Al,
    representation: function representation(e) {
      return "<DateInput source=\"".concat(e.source, "\" />");
    }
  },
  email: {
    component: Fe,
    representation: function representation(e) {
      return "<TextInput source=\"".concat(e.source, "\" />");
    }
  },
  id: {
    component: Fe,
    representation: function representation(e) {
      return "<TextInput source=\"".concat(e.source, "\" />");
    }
  },
  number: {
    component: ts,
    representation: function representation(e) {
      return "<NumberInput source=\"".concat(e.source, "\" />");
    }
  },
  reference: {
    component: ns,
    representation: function representation(e, t) {
      return "<ReferenceInput source=\"".concat(e.source, "\" reference=\"").concat(e.reference, "\">").concat(t.getRepresentation(), "</ReferenceInput>");
    }
  },
  referenceChild: {
    component: function component(e) {
      return An.createElement(Nn, i({
        optionText: "id"
      }, e));
    },
    representation: function representation() {
      return '<SelectInput optionText="id" />';
    }
  },
  referenceArray: {
    component: rs,
    representation: function representation(e) {
      return "<ReferenceArrayInput source=\"".concat(e.source, "\" reference=\"").concat(e.reference, "\"><TextInput source=\"id\" /></ReferenceArrayInput>");
    }
  },
  referenceArrayChild: {
    component: function component(e) {
      return An.createElement(Nn, i({
        optionText: "id"
      }, e));
    },
    representation: function representation() {
      return '<SelectInput optionText="id" />';
    }
  },
  richText: {
    component: Fe,
    representation: function representation(e) {
      return "<TextInput source=\"".concat(e.source, "\" />");
    }
  },
  string: {
    component: Fe,
    representation: function representation(e) {
      return "<TextInput source=\"".concat(e.source, "\" />");
    }
  },
  url: {
    component: Fe,
    representation: function representation(e) {
      return "<TextInput source=\"".concat(e.source, "\" />");
    }
  }
};
l();
import * as Ts from "react";
import { useEffect as bk, useState as hk } from "react";
import cu from "inflection";
import { useEditController as Rk, EditContextProvider as Tk, InferredElement as Pk, useResourceContext as xk, useEditContext as Ck, getElementsFromRecords as vk } from "ra-core";
var mu = n(function (e) {
  var t = xk(e),
      _Ck = Ck(),
      o = _Ck.record,
      _hk = hk(null),
      _hk2 = _slicedToArray(_hk, 2),
      r = _hk2[0],
      a = _hk2[1];

  return bk(function () {
    if (o && !r) {
      var s = vk([o], cp),
          p = new Pk(cp.form, null, s);
      process.env.NODE_ENV !== "production" && console.log("Guessed Edit:\n\nexport const ".concat(cu.capitalize(cu.singularize(t)), "Edit = () => (\n    <Edit>\n").concat(p.getRepresentation(), "\n    </Edit>\n);")), a(p.getElement());
    }
  }, [o, r, t]), Ts.createElement(Nr, i({}, e), r);
}, "EditViewGuesser");
mu.propTypes = Nr.propTypes;
var y8 = n(function (e) {
  var t = Rk(e);
  return Ts.createElement(Tk, {
    value: t
  }, Ts.createElement(mu, i({}, e)));
}, "EditGuesser");
l();
import * as up from "react";
import ft from "prop-types";
import { ShowBase as Ak } from "ra-core";
l();
import * as wr from "react";
import Qo from "prop-types";
import { Card as Sk } from "@mui/material";
import { styled as Ek } from "@mui/material/styles";
import uu from "clsx";
import { useShowContext as Nk, useResourceDefinition as Bk } from "ra-core";
l();
import * as mp from "react";
import du from "prop-types";
import { useResourceDefinition as Ik, useRecordContext as Fk } from "ra-core";
var dp = n(function (e) {
  var t = Fk(e),
      _Ik = Ik(),
      o = _Ik.hasEdit;

  return o ? mp.createElement(xt, {
    className: e.className
  }, mp.createElement(ai, {
    record: t
  })) : null;
}, "ShowActions");
dp.propTypes = {
  className: du.string,
  record: du.any
};
var Lk = wr.createElement(dp, null),
    Ar = n(function (e) {
  var b = e,
      t = b.actions,
      o = b.aside,
      r = b.children,
      a = b.className,
      _b$component2 = b.component,
      s = _b$component2 === void 0 ? Sk : _b$component2,
      _b$emptyWhileLoading = b.emptyWhileLoading,
      p = _b$emptyWhileLoading === void 0 ? !1 : _b$emptyWhileLoading,
      c = b.title,
      d = f(b, ["actions", "aside", "children", "className", "component", "emptyWhileLoading", "title"]),
      _Nk = Nk(e),
      m = _Nk.defaultTitle,
      u = _Nk.record,
      _Bk = Bk(e),
      g = _Bk.hasEdit,
      y = typeof t == "undefined" && g ? Lk : t;

  return !r || !u && p ? null : wr.createElement(wk, i({
    className: uu("show-page", a)
  }, kk(d)), wr.createElement(je, {
    title: c,
    defaultTitle: m
  }), y !== !1 && y, wr.createElement("div", {
    className: uu($r.main, _defineProperty({}, $r.noActions, !y))
  }, wr.createElement(s, {
    className: $r.card
  }, r), o));
}, "ShowView");
Ar.propTypes = {
  actions: Qo.oneOfType([Qo.element, Qo.bool]),
  children: Qo.node,
  className: Qo.string,
  emptyWhileLoading: Qo.bool,
  title: Qo.any
};
var kk = n(function (T) {
  var x = T,
      _x$defaultTitle = x.defaultTitle,
      e = _x$defaultTitle === void 0 ? null : _x$defaultTitle,
      _x$hasCreate = x.hasCreate,
      t = _x$hasCreate === void 0 ? null : _x$hasCreate,
      _x$hasEdit = x.hasEdit,
      o = _x$hasEdit === void 0 ? null : _x$hasEdit,
      _x$hasList = x.hasList,
      r = _x$hasList === void 0 ? null : _x$hasList,
      _x$hasShow = x.hasShow,
      a = _x$hasShow === void 0 ? null : _x$hasShow,
      _x$history = x.history,
      s = _x$history === void 0 ? null : _x$history,
      _x$id = x.id,
      p = _x$id === void 0 ? null : _x$id,
      _x$isLoading = x.isLoading,
      c = _x$isLoading === void 0 ? null : _x$isLoading,
      _x$isFetching = x.isFetching,
      d = _x$isFetching === void 0 ? null : _x$isFetching,
      _x$location = x.location,
      m = _x$location === void 0 ? null : _x$location,
      _x$match = x.match,
      u = _x$match === void 0 ? null : _x$match,
      _x$options = x.options,
      g = _x$options === void 0 ? null : _x$options,
      _x$refetch = x.refetch,
      y = _x$refetch === void 0 ? null : _x$refetch,
      _x$permissions = x.permissions,
      b = _x$permissions === void 0 ? null : _x$permissions,
      P = f(x, ["defaultTitle", "hasCreate", "hasEdit", "hasList", "hasShow", "history", "id", "isLoading", "isFetching", "location", "match", "options", "refetch", "permissions"]);
  return P;
}, "sanitizeRestProps"),
    Ps = "RaShow",
    $r = {
  main: "".concat(Ps, "-main"),
  noActions: "".concat(Ps, "-noActions"),
  card: "".concat(Ps, "-card")
},
    wk = Ek("div", {
  name: Ps,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref131) {
  var _ref132;

  var e = _ref131.theme;
  return _ref132 = {}, _defineProperty(_ref132, "& .".concat($r.main), {
    display: "flex"
  }), _defineProperty(_ref132, "& .".concat($r.noActions), {
    marginTop: "1em"
  }), _defineProperty(_ref132, "& .".concat($r.card), {
    flex: "1 1 auto"
  }), _ref132;
});
var $k = n(function (a) {
  var s = a,
      e = s.id,
      t = s.resource,
      o = s.queryOptions,
      r = f(s, ["id", "resource", "queryOptions"]);
  return up.createElement(Ak, {
    id: e,
    queryOptions: o,
    resource: t
  }, up.createElement(Ar, i({}, r)));
}, "Show");
$k.propTypes = {
  actions: ft.oneOfType([ft.element, ft.bool]),
  children: ft.node.isRequired,
  className: ft.string,
  disableAuthentication: ft.bool,
  emptyWhileLoading: ft.bool,
  component: ft.elementType,
  resource: ft.string,
  title: ft.node,
  sx: ft.any
};
l();
import * as Ur from "react";
l();
import * as fu from "react";
import { useEffect as Ok, useState as Dk, memo as Mk } from "react";
import Vk from "lodash/get";
import { ListContextProvider as _k, useRecordContext as Hk } from "ra-core";
l();
import Je from "prop-types";
var q = {
  sortBy: Je.string,
  sortByOrder: Je.oneOf(["ASC", "DESC"]),
  source: Je.string,
  label: Je.oneOfType([Je.string, Je.element, Je.bool]),
  sortable: Je.bool,
  className: Je.string,
  cellClassName: Je.string,
  headerClassName: Je.string,
  textAlign: Je.oneOf(["inherit", "left", "center", "right", "justify"]),
  emptyText: Je.string
};
var Or = Mk(function (e) {
  var t = e.children,
      o = e.resource,
      r = e.source,
      a = Hk(e),
      _Dk = Dk(gu),
      _Dk2 = _slicedToArray(_Dk, 2),
      s = _Dk2[0],
      p = _Dk2[1];

  return Ok(function () {
    var c = Vk(a, r) || gu;
    p(c);
  }, [a, r]), fu.createElement(_k, {
    value: {
      data: s,
      selectedIds: [],
      sort: {
        field: null,
        order: null
      },
      displayedFilters: null,
      filterValues: null,
      hasCreate: null,
      hideFilter: null,
      isFetching: !1,
      isLoading: !1,
      onSelect: null,
      onToggleItem: null,
      onUnselectItems: null,
      page: null,
      perPage: null,
      resource: o,
      setFilters: null,
      setPage: null,
      setPerPage: null,
      setSort: null,
      showFilter: null,
      total: s.length
    }
  }, t);
});
Or.propTypes = i({}, q);
Or.displayName = "ArrayField";
var gu = [];
l();
import * as Dr from "react";
import { styled as zk } from "@mui/material/styles";
import { memo as Wk } from "react";
import $n from "prop-types";
import qk from "lodash/get";
import jk from "@mui/icons-material/Done";
import Uk from "@mui/icons-material/Clear";
import { Tooltip as Xk, Typography as fp } from "@mui/material";
import { useTranslate as Qk, useRecordContext as Gk } from "ra-core";
l();
var X = n(function (N) {
  var F = N,
      e = F.cellClassName,
      t = F.className,
      o = F.emptyText,
      r = F.formClassName,
      a = F.fullWidth,
      s = F.headerClassName,
      p = F.label,
      c = F.linkType,
      d = F.link,
      m = F.locale,
      u = F.record,
      g = F.refetch,
      y = F.resource,
      b = F.sortable,
      P = F.sortBy,
      T = F.sortByOrder,
      x = F.source,
      C = F.textAlign,
      v = F.translateChoice,
      I = f(F, ["cellClassName", "className", "emptyText", "formClassName", "fullWidth", "headerClassName", "label", "linkType", "link", "locale", "record", "refetch", "resource", "sortable", "sortBy", "sortByOrder", "source", "textAlign", "translateChoice"]);
  return I;
}, "sanitizeFieldRestProps");
var Mr = Wk(function (e) {
  var T = e,
      t = T.className,
      o = T.emptyText,
      r = T.source,
      a = T.valueLabelTrue,
      s = T.valueLabelFalse,
      _T$TrueIcon = T.TrueIcon,
      p = _T$TrueIcon === void 0 ? jk : _T$TrueIcon,
      _T$FalseIcon = T.FalseIcon,
      c = _T$FalseIcon === void 0 ? Uk : _T$FalseIcon,
      _T$looseValue = T.looseValue,
      d = _T$looseValue === void 0 ? !1 : _T$looseValue,
      m = f(T, ["className", "emptyText", "source", "valueLabelTrue", "valueLabelFalse", "TrueIcon", "FalseIcon", "looseValue"]),
      u = Gk(e),
      g = Qk(),
      y = qk(u, r),
      b = y === !0 || d && y,
      P = y ? a : s;
  return P || (P = b ? "ra.boolean.true" : "ra.boolean.false"), d || y === !1 || y === !0 ? Dr.createElement(Kk, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(m)), Dr.createElement(Xk, {
    title: g(P, {
      _: P
    })
  }, b ? Dr.createElement(p, {
    "data-testid": "true",
    fontSize: "small"
  }) : Dr.createElement(c, {
    "data-testid": "false",
    fontSize: "small"
  }))) : Dr.createElement(fp, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(m)), o);
});
Mr.propTypes = E(i(i({}, fp.propTypes), q), {
  valueLabelFalse: $n.string,
  valueLabelTrue: $n.string,
  TrueIcon: $n.elementType,
  FalseIcon: $n.elementType,
  looseValue: $n.bool
});
Mr.displayName = "BooleanField";
var Jk = "RaBooleanField",
    Kk = zk(fp, {
  name: Jk,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  display: "inline-flex",
  verticalAlign: "middle",
  lineHeight: 0
});
l();
import * as gp from "react";
import { styled as Yk } from "@mui/material/styles";
import { memo as Zk } from "react";
import ew from "lodash/get";
import tw from "@mui/material/Chip";
import ow from "@mui/material/Typography";
import rw from "clsx";
import { useRecordContext as nw } from "ra-core";
var On = Zk(function (e) {
  var c = e,
      t = c.className,
      o = c.source,
      r = c.emptyText,
      a = f(c, ["className", "source", "emptyText"]),
      s = nw(e),
      p = ew(s, o);
  return p == null && r ? gp.createElement(ow, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(a)), r) : gp.createElement(aw, i({
    className: rw(bu.chip, t),
    label: p
  }, X(a)));
});
On.propTypes = i(i({}, On.propTypes), q);
On.displayName = "ChipField";
var yu = "RaChipField",
    bu = {
  chip: "".concat(yu, "-chip")
},
    aw = Yk(tw, {
  name: yu,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(_defineProperty({}, "&.".concat(bu.chip), {
  margin: 4,
  cursor: "inherit"
}));
l();
import * as yp from "react";
import { memo as sw } from "react";
import Vr from "prop-types";
import iw from "lodash/get";
import { Typography as bp } from "@mui/material";
import { useRecordContext as lw } from "ra-core";

var _r = sw(function (e) {
  var b = e,
      t = b.className,
      o = b.emptyText,
      r = b.locales,
      a = b.options,
      _b$showTime = b.showTime,
      s = _b$showTime === void 0 ? !1 : _b$showTime,
      p = b.source,
      c = f(b, ["className", "emptyText", "locales", "options", "showTime", "source"]),
      d = lw(e);
  if (!d) return null;
  var m = iw(d, p);
  if (m == null || m === "") return o ? yp.createElement(bp, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(c)), o) : null;
  var u = m instanceof Date ? m : new Date(m),
      g = a;
  typeof m == "string" && m.length <= 10 && !s && !a && (g = {
    timeZone: "UTC"
  });
  var y = s ? hu ? u.toLocaleString(r, a) : u.toLocaleString() : hu ? u.toLocaleDateString(r, g) : u.toLocaleDateString();
  return yp.createElement(bp, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(c)), y);
});

_r.propTypes = E(i(i({}, bp.propTypes), q), {
  locales: Vr.oneOfType([Vr.string, Vr.arrayOf(Vr.string)]),
  options: Vr.object,
  showTime: Vr.bool
});
_r.displayName = "DateField";

var hu = function () {
  try {
    new Date().toLocaleString("i");
  } catch (e) {
    return e instanceof RangeError;
  }

  return !1;
}();

l();
import * as hp from "react";
import { memo as pw } from "react";
import cw from "lodash/get";
import mw from "@mui/material/Typography";
import { Link as dw } from "@mui/material";
import { useRecordContext as uw } from "ra-core";
var Hr = pw(function (e) {
  var c = e,
      t = c.className,
      o = c.source,
      r = c.emptyText,
      a = f(c, ["className", "source", "emptyText"]),
      s = uw(e),
      p = cw(s, o);
  return p == null ? r ? hp.createElement(mw, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(a)), r) : null : hp.createElement(dw, i({
    className: t,
    href: "mailto:".concat(p),
    onClick: fw,
    variant: "body2"
  }, X(a)), p);
});
Hr.propTypes = q;
Hr.displayName = "EmailField";
var fw = n(function (e) {
  return e.stopPropagation();
}, "stopPropagation");
l();
import * as co from "react";
import { styled as Ru } from "@mui/material/styles";
import mo from "prop-types";
import xs from "lodash/get";
import gw from "@mui/material/Typography";
import { useRecordContext as yw } from "ra-core";
var bw = n(function (e) {
  var P = e,
      t = P.className,
      o = P.emptyText,
      r = P.source,
      a = P.title,
      s = P.src,
      p = P.target,
      c = P.download,
      d = P.ping,
      m = P.rel,
      u = f(P, ["className", "emptyText", "source", "title", "src", "target", "download", "ping", "rel"]),
      g = yw(e),
      y = xs(g, r);
  if (!y) return o ? co.createElement(gw, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(u)), o) : co.createElement(Tu, i({
    className: t
  }, X(u)));
  if (Array.isArray(y)) return co.createElement(Rw, i({
    className: t
  }, X(u)), y.map(function (T, x) {
    var C = xs(T, a) || a,
        v = xs(T, s) || a;
    return co.createElement("li", {
      key: x
    }, co.createElement("a", {
      href: v,
      title: C,
      target: p,
      download: c,
      ping: d,
      rel: m
    }, C));
  }));
  var b = xs(g, a) || a;
  return co.createElement(Tu, i({
    className: t
  }, X(u)), co.createElement("a", {
    href: y,
    title: b,
    target: p,
    download: c,
    ping: d,
    rel: m
  }, b));
}, "FileField");
bw.propTypes = E(i({}, q), {
  src: mo.string,
  title: mo.string,
  target: mo.string,
  download: mo.oneOfType([mo.bool, mo.string]),
  ping: mo.string,
  rel: mo.string
});
var hw = "RaFileField",
    Tu = Ru("div", {
  name: hw,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})({
  display: "inline-block"
}),
    Rw = Ru("ul")({
  display: "inline-block"
});
l();
import * as Pu from "react";
import { useMemo as Tw } from "react";
import { useRecordContext as Pw } from "ra-core";
import xw from "prop-types";
import xu from "@mui/material/Typography";
var Cw = n(function (e) {
  var p = e,
      t = p.className,
      _p$source = p.source,
      o = _p$source === void 0 ? "" : _p$source,
      r = p.render,
      a = f(p, ["className", "source", "render"]),
      s = Pw(e);
  return Tw(function () {
    return s ? Pu.createElement(xu, i({
      component: "span",
      variant: "body2",
      className: t
    }, X(a)), r(s, o)) : null;
  }, [t, s, o, r, a]);
}, "FunctionField");
Cw.propTypes = E(i(i({}, xu.propTypes), q), {
  render: xw.func.isRequired
});
l();
import * as uo from "react";
import { styled as vw } from "@mui/material/styles";
import { Box as Iw, Typography as Fw } from "@mui/material";
import Cu from "prop-types";
import Cs from "lodash/get";
import Sw from "clsx";
import { useRecordContext as Ew } from "ra-core";
var vu = n(function (e) {
  var u = e,
      t = u.className,
      o = u.emptyText,
      r = u.source,
      a = u.src,
      s = u.title,
      p = f(u, ["className", "emptyText", "source", "src", "title"]),
      c = Ew(e),
      d = Cs(c, r);
  if (!d) return o ? uo.createElement(Fw, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(p)), o) : uo.createElement("div", i({
    className: t
  }, X(p)));
  if (Array.isArray(d)) return uo.createElement(Nw, i({
    className: Sw(Dn.list, t)
  }, X(p)), d.map(function (g, y) {
    var b = Cs(g, s) || s,
        P = Cs(g, a) || s;
    return uo.createElement("li", {
      key: y
    }, uo.createElement("img", {
      alt: b,
      title: b,
      src: P,
      className: Dn.image
    }));
  }));
  var m = Cs(c, s) || s;
  return uo.createElement(Iw, i({
    className: t
  }, X(p)), uo.createElement("img", {
    title: m,
    alt: m,
    src: d,
    className: Dn.image
  }));
}, "ImageField");
vu.displayName = "ImageField";
vu.propTypes = E(i({}, q), {
  src: Cu.string,
  title: Cu.string
});
var Rp = "RaImageField",
    Dn = {
  list: "".concat(Rp, "-list"),
  image: "".concat(Rp, "-image")
},
    Nw = vw("ul", {
  name: Rp,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})((_vw = {}, _defineProperty(_vw, "&.".concat(Dn.list), {
  display: "flex",
  listStyleType: "none"
}), _defineProperty(_vw, "& .".concat(Dn.image), {
  margin: "0.5rem",
  maxHeight: "10rem"
}), _vw));
l();
import * as Tp from "react";
import { memo as Bw } from "react";
import Mn from "prop-types";
import Lw from "lodash/get";
import Pp from "@mui/material/Typography";
import { useRecordContext as kw } from "ra-core";
var Go = Bw(function (e) {
  var u = e,
      t = u.className,
      o = u.emptyText,
      r = u.source,
      a = u.locales,
      s = u.options,
      p = u.textAlign,
      c = f(u, ["className", "emptyText", "source", "locales", "options", "textAlign"]),
      d = kw(e);
  if (!d) return null;
  var m = Lw(d, r);
  return m == null ? o ? Tp.createElement(Pp, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(c)), o) : null : Tp.createElement(Pp, i({
    variant: "body2",
    component: "span",
    className: t
  }, X(c)), ww ? m.toLocaleString(a, s) : m);
});
Go.displayName = "NumberField";
Go.defaultProps = {
  textAlign: "right"
};
Go.propTypes = E(i(i({}, Pp.propTypes), q), {
  locales: Mn.oneOfType([Mn.string, Mn.arrayOf(Mn.string)]),
  options: Mn.object
});
var ww = !!(typeof Intl == "object" && Intl && typeof Intl.NumberFormat == "function");
l();
import * as Jo from "react";
import { memo as Aw } from "react";
import Nt from "prop-types";
import { ListContextProvider as $w, useListContext as Ow, useReferenceArrayFieldController as Dw, ResourceContextProvider as Mw, useRecordContext as Vw } from "ra-core";
import { styled as _w } from "@mui/material/styles";
var Vn = n(function (e) {
  var t = e.filter,
      _e$page = e.page,
      o = _e$page === void 0 ? 1 : _e$page,
      r = e.perPage,
      a = e.reference,
      s = e.resource,
      p = e.sort,
      c = e.source,
      d = Vw(e),
      m = Dw({
    filter: t,
    page: o,
    perPage: r,
    record: d,
    reference: a,
    resource: s,
    sort: p,
    source: c
  });
  return Jo.createElement(Mw, {
    value: a
  }, Jo.createElement($w, {
    value: m
  }, Jo.createElement(zw, i({}, e))));
}, "ReferenceArrayField");
Vn.propTypes = E(i({}, q), {
  className: Nt.string,
  children: Nt.element.isRequired,
  label: q.label,
  record: Nt.any,
  reference: Nt.string.isRequired,
  resource: Nt.string,
  sortBy: Nt.string,
  sortByOrder: q.sortByOrder,
  source: Nt.string.isRequired
});
var Iu = n(function (e) {
  var t = e.children,
      o = e.pagination,
      r = e.className,
      a = e.sx,
      _Ow = Ow(e),
      s = _Ow.isLoading,
      p = _Ow.total;

  return Jo.createElement(Hw, {
    className: r,
    sx: a
  }, s ? Jo.createElement(Be, {
    className: Su.progress
  }) : Jo.createElement("span", null, t, o && p !== void 0 ? o : null));
}, "ReferenceArrayFieldView");
Iu.propTypes = {
  className: Nt.string,
  children: Nt.element.isRequired,
  reference: Nt.string.isRequired
};

var Fu = "RaReferenceArrayField",
    Su = {
  progress: "".concat(Fu, "-progress")
},
    Hw = _w("div", {
  name: Fu,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref133) {
  var e = _ref133.theme;
  return _defineProperty({}, "& .".concat(Su.progress), {
    marginTop: e.spacing(2)
  });
}),
    zw = Aw(Iu);

l();
import * as Ke from "react";
import { styled as Jw } from "@mui/material/styles";
import { memo as Kw } from "react";
import Y from "prop-types";
import Yw from "lodash/get";
import { Typography as Zw } from "@mui/material";
import eA from "@mui/icons-material/Error";
import { useReference as tA, ResourceContextProvider as oA, RecordContextProvider as Nu, useRecordContext as rA, useCreatePath as nA } from "ra-core";
l();
import * as xp from "react";
import _n from "prop-types";
import Ww from "clsx";
import { Link as qw } from "react-router-dom";
import { styled as jw, Link as Uw } from "@mui/material";
var Hn = n(function (e) {
  var s = e,
      t = s.to,
      o = s.children,
      r = s.className,
      a = f(s, ["to", "children", "className"]);
  return xp.createElement(Gw, i({
    to: t,
    className: Ww(Eu.link, r)
  }, a), o);
}, "Link"),
    Xw = "RaLink",
    Eu = {
  link: "".concat(Xw, "-link")
},
    Qw = n(function (e) {
  return xp.createElement(Uw, i({
    component: qw
  }, e));
}, "MuiRouterLink"),
    Gw = jw(Qw)(function (_ref135) {
  var e = _ref135.theme;
  return _defineProperty({}, "&.".concat(Eu.link), {
    textDecoration: "none"
  });
});
Hn.propTypes = {
  className: _n.string,
  children: _n.node,
  to: _n.oneOfType([_n.string, _n.object])
};
var zr = n(function (e) {
  var p = e,
      t = p.source,
      o = p.emptyText,
      r = f(p, ["source", "emptyText"]),
      a = rA(e),
      s = Yw(a, t);
  return s == null ? o ? Ke.createElement(Zw, {
    component: "span",
    variant: "body2"
  }, o) : null : Ke.createElement(aA, E(i({}, r), {
    record: a,
    id: s
  }));
}, "ReferenceField");
zr.propTypes = {
  children: Y.element.isRequired,
  className: Y.string,
  cellClassName: Y.string,
  headerClassName: Y.string,
  label: q.label,
  record: Y.any,
  reference: Y.string.isRequired,
  resource: Y.string,
  sortBy: Y.string,
  sortByOrder: q.sortByOrder,
  source: Y.string.isRequired,
  translateChoice: Y.oneOfType([Y.func, Y.bool]),
  link: Y.oneOfType([Y.string, Y.bool, Y.func]).isRequired
};
zr.defaultProps = {
  link: "edit"
};
var aA = n(function (p) {
  var c = p,
      e = c.children,
      t = c.id,
      o = c.record,
      r = c.reference,
      a = c.link,
      s = f(c, ["children", "id", "record", "reference", "link"]);
  if (Ke.Children.count(e) !== 1) throw new Error("<ReferenceField> only accepts a single child");
  var d = nA(),
      m = a === !1 ? !1 : d({
    resource: r,
    id: t,
    type: typeof a == "function" ? a(o, r) : a
  });
  return Ke.createElement(oA, {
    value: r
  }, Ke.createElement(iA, E(i(i({
    reference: r
  }, s), tA({
    reference: r,
    id: t
  })), {
    resourceLinkPath: m
  }), e));
}, "NonEmptyReferenceField"),
    sA = n(function (e) {
  return e.stopPropagation();
}, "stopPropagation"),
    vs = n(function (e) {
  var t = e.children,
      o = e.className,
      r = e.error,
      a = e.isLoading,
      s = e.referenceRecord,
      p = e.resourceLinkPath,
      c = e.sx;
  return r ? Ke.createElement(eA, {
    "aria-errormessage": r.message ? r.message : r,
    role: "presentation",
    color: "error",
    fontSize: "small"
  }) : a ? Ke.createElement(Be, null) : s ? p ? Ke.createElement(lA, {
    className: o,
    sx: c
  }, Ke.createElement(Nu, {
    value: s
  }, Ke.createElement(Hn, {
    to: p,
    className: Lu.link,
    onClick: sA
  }, t))) : Ke.createElement(Nu, {
    value: s
  }, t) : null;
}, "ReferenceFieldView");
vs.propTypes = {
  children: Y.element,
  className: Y.string,
  isLoading: Y.bool,
  record: Y.any,
  reference: Y.string,
  referenceRecord: Y.any,
  resource: Y.string,
  resourceLinkPath: Y.oneOfType([Y.string, Y.oneOf([!1])]),
  source: Y.string,
  translateChoice: Y.oneOfType([Y.func, Y.bool])
};
var iA = Kw(vs),
    Bu = "RaReferenceField",
    Lu = {
  link: "".concat(Bu, "-link")
},
    lA = Jw("span", {
  name: Bu,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref137) {
  var e = _ref137.theme;
  return _defineProperty({}, "& .".concat(Lu.link), {
    "& > *": {
      color: e.palette.primary.main
    }
  });
});
l();
import Wr from "react";
import ie from "prop-types";
import { useReferenceManyFieldController as pA, ListContextProvider as cA, ResourceContextProvider as mA, useRecordContext as dA } from "ra-core";
var ku = n(function (e) {
  var t = e.children,
      o = e.filter,
      _e$page2 = e.page,
      r = _e$page2 === void 0 ? 1 : _e$page2,
      a = e.perPage,
      s = e.reference,
      p = e.resource,
      c = e.sort,
      d = e.source,
      m = e.target,
      u = dA(e);
  if (Wr.Children.count(t) !== 1) throw new Error("<ReferenceManyField> only accepts a single child (like <Datagrid>)");
  var g = pA({
    filter: o,
    page: r,
    perPage: a,
    record: u,
    reference: s,
    resource: p,
    sort: c,
    source: d,
    target: m
  });
  return Wr.createElement(mA, {
    value: s
  }, Wr.createElement(cA, {
    value: g
  }, Wr.createElement(wu, i(i({}, e), g))));
}, "ReferenceManyField");
ku.propTypes = {
  children: ie.element.isRequired,
  className: ie.string,
  filter: ie.object,
  label: q.label,
  perPage: ie.number,
  record: ie.any,
  reference: ie.string.isRequired,
  resource: ie.string,
  sortBy: ie.string,
  sortByOrder: q.sortByOrder,
  source: ie.string.isRequired,
  sort: ie.exact({
    field: ie.string,
    order: ie.string
  }),
  target: ie.string.isRequired
};
ku.defaultProps = {
  filter: {},
  perPage: 25,
  sort: {
    field: "id",
    order: "DESC"
  },
  source: "id"
};
var wu = n(function (e) {
  var t = e.children,
      o = e.pagination;
  return Wr.createElement(Wr.Fragment, null, t, o && e.total !== void 0 ? o : null);
}, "ReferenceManyFieldView");
wu.propTypes = {
  children: ie.element,
  className: ie.string,
  sort: ie.exact({
    field: ie.string,
    order: ie.string
  }),
  data: ie.any,
  isLoading: ie.bool,
  pagination: ie.element,
  reference: ie.string,
  setSort: ie.func
};
l();
import Cp from "react";
import qr from "prop-types";
import { Typography as uA } from "@mui/material";
import { useReferenceOneFieldController as fA, useRecordContext as gA, ResourceContextProvider as yA, useCreatePath as bA } from "ra-core";
var Au = n(function (e) {
  var t = e.children,
      o = e.reference,
      r = e.source,
      a = e.target,
      s = e.emptyText,
      _e$link = e.link,
      p = _e$link === void 0 ? !1 : _e$link,
      c = gA(e),
      d = bA(),
      _fA = fA({
    record: c,
    reference: o,
    source: r,
    target: a
  }),
      m = _fA.isLoading,
      u = _fA.isFetching,
      g = _fA.referenceRecord,
      y = _fA.error,
      b = _fA.refetch,
      P = p === !1 ? !1 : d({
    resource: o,
    id: g == null ? void 0 : g.id,
    type: typeof p == "function" ? p(c, o) : p
  });

  return !c || !m && g == null ? s ? Cp.createElement(uA, {
    component: "span",
    variant: "body2"
  }, s) : null : Cp.createElement(yA, {
    value: o
  }, Cp.createElement(vs, {
    isLoading: m,
    isFetching: u,
    referenceRecord: g,
    resourceLinkPath: P,
    reference: o,
    refetch: b,
    error: y
  }, t));
}, "ReferenceOneField");
Au.propTypes = {
  children: qr.element.isRequired,
  className: qr.string,
  label: q.label,
  record: qr.any,
  reference: qr.string.isRequired,
  source: qr.string.isRequired,
  target: qr.string.isRequired
};
Au.defaultProps = {
  source: "id"
};
l();
import * as vp from "react";
import { memo as hA } from "react";
import RA from "prop-types";
import TA from "lodash/get";
import $u from "@mui/material/Typography";
import { useRecordContext as PA } from "ra-core";
var Is = hA(function (e) {
  var d = e,
      t = d.className,
      o = d.emptyText,
      r = d.source,
      _d$stripTags = d.stripTags,
      a = _d$stripTags === void 0 ? !1 : _d$stripTags,
      s = f(d, ["className", "emptyText", "source", "stripTags"]),
      p = PA(e),
      c = TA(p, r);
  return vp.createElement($u, i({
    className: t,
    variant: "body2",
    component: "span"
  }, X(s)), c == null && o ? o : a ? xA(c) : vp.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: c
    }
  }));
});
Is.propTypes = E(i(i({}, $u.propTypes), q), {
  stripTags: RA.bool
});
Is.displayName = "RichTextField";
var xA = n(function (e) {
  return e ? e.replace(/<[^>]+>/gm, "") : "";
}, "removeTags");
l();
import * as Ip from "react";
import { memo as CA } from "react";
import fo from "prop-types";
import vA from "lodash/get";
import { useChoices as IA, useRecordContext as FA } from "ra-core";
import { Typography as Fp } from "@mui/material";
var Sp = CA(function (e) {
  var T = e,
      t = T.className,
      o = T.emptyText,
      r = T.source,
      a = T.choices,
      s = T.optionValue,
      p = T.optionText,
      c = T.translateChoice,
      d = f(T, ["className", "emptyText", "source", "choices", "optionValue", "optionText", "translateChoice"]),
      m = FA(e),
      u = vA(m, r),
      _IA = IA({
    optionText: p,
    optionValue: s,
    translateChoice: c
  }),
      g = _IA.getChoiceText,
      y = _IA.getChoiceValue,
      b = a.find(function (x) {
    return y(x) === u;
  });

  if (!b) return o ? Ip.createElement(Fp, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(d)), o) : null;
  var P = g(b);
  return Ip.createElement(Fp, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(d)), P);
});
Sp.defaultProps = {
  optionText: "name",
  optionValue: "id",
  translateChoice: !0
};
Sp.propTypes = E(i(i({}, Fp.propTypes), q), {
  choices: fo.arrayOf(fo.object).isRequired,
  optionText: fo.oneOfType([fo.string, fo.func, fo.element]),
  optionValue: fo.string,
  translateChoice: fo.bool
});
Sp.displayName = "SelectField";
l();
import * as Ou from "react";
import { memo as SA } from "react";
import EA from "lodash/get";
import Du from "@mui/material/Typography";
import { useRecordContext as NA } from "ra-core";
var at = SA(function (e) {
  var c = e,
      t = c.className,
      o = c.source,
      r = c.emptyText,
      a = f(c, ["className", "source", "emptyText"]),
      s = NA(e),
      p = EA(s, o);
  return Ou.createElement(Du, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(a)), p != null && typeof p != "string" ? JSON.stringify(p) : p || r);
});
at.displayName = "TextField";
at.propTypes = i(i({}, Du.propTypes), q);
l();
import * as zn from "react";
import { styled as UA } from "@mui/material/styles";
import { TranslatableContextProvider as XA, useTranslatable as QA, useRecordContext as GA } from "ra-core";
l();
import * as Fs from "react";
import { styled as AA } from "@mui/material/styles";
import $A from "@mui/material/AppBar";
import OA from "@mui/material/Tabs";
import { useTranslatableContext as DA } from "ra-core";
l();
import BA from "react";
import LA from "@mui/material/Tab";
import { useTranslate as kA } from "ra-core";
import { capitalize as wA } from "inflection";
var Mu = n(function (e) {
  var s = e,
      t = s.locale,
      _s$groupKey = s.groupKey,
      o = _s$groupKey === void 0 ? "" : _s$groupKey,
      r = f(s, ["locale", "groupKey"]),
      a = kA();
  return BA.createElement(LA, i({
    id: "translatable-header-".concat(o).concat(t),
    label: a("ra.locales.".concat(o).concat(t), {
      _: wA(t)
    })
  }, r));
}, "TranslatableFieldsTab");
var Vu = n(function (e) {
  var t = e.groupKey,
      o = e.TabsProps,
      r = e.className,
      _DA = DA(),
      a = _DA.locales,
      s = _DA.selectLocale,
      p = _DA.selectedLocale;

  return Fs.createElement(VA, {
    color: "default",
    position: "static",
    className: r
  }, Fs.createElement(OA, i({
    value: p,
    onChange: n(function (d, m) {
      s(m);
    }, "handleChange"),
    indicatorColor: "primary",
    textColor: "primary"
  }, o), a.map(function (d) {
    return Fs.createElement(Mu, {
      key: d,
      value: d,
      locale: d,
      groupKey: t
    });
  })));
}, "TranslatableFieldsTabs"),
    MA = "RaTranslatableFieldsTabs",
    VA = AA($A, {
  name: MA,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref139) {
  var e = _ref139.theme;
  return {
    boxShadow: "none",
    borderRadius: 0,
    borderTopLeftRadius: e.shape.borderRadius,
    borderTopRightRadius: e.shape.borderRadius,
    border: "1px solid ".concat(e.palette.divider)
  };
});
l();
import * as Ss from "react";
import { styled as _A } from "@mui/material/styles";
import { Children as HA, cloneElement as _u, isValidElement as zA } from "react";
import { useTranslatableContext as WA } from "ra-core";

var Hu = n(function (e) {
  var g = e,
      t = g.children,
      _g$groupKey = g.groupKey,
      o = _g$groupKey === void 0 ? "" : _g$groupKey,
      r = g.locale,
      a = g.record,
      s = g.resource,
      p = g.className,
      c = f(g, ["children", "groupKey", "locale", "record", "resource", "className"]),
      _WA = WA(),
      d = _WA.selectedLocale,
      m = _WA.getLabel,
      u = _WA.getSource;

  return Ss.createElement(jA, i({
    role: "tabpanel",
    hidden: d !== r,
    id: "translatable-content-".concat(o).concat(r),
    "aria-labelledby": "translatable-header-".concat(o).concat(r),
    className: p
  }, c), HA.map(t, function (y) {
    return y && zA(y) ? Ss.createElement("div", {
      key: y.props.source
    }, y.props.addLabel ? Ss.createElement(fe, {
      resource: s,
      label: y.props.label,
      source: y.props.source
    }, _u(y, E(i({}, y.props), {
      label: m(y.props.source),
      record: a,
      source: u(y.props.source, r)
    }))) : typeof y == "string" ? y : _u(y, E(i({}, y.props), {
      label: m(y.props.source),
      record: a,
      source: u(y.props.source, r)
    }))) : null;
  }));
}, "TranslatableFieldsTabContent"),
    qA = "RaTranslatableFieldsTabContent",
    jA = _A("div", {
  name: qA,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref140) {
  var e = _ref140.theme;
  return {
    flexGrow: 1,
    padding: e.spacing(2),
    borderRadius: 0,
    borderBottomLeftRadius: e.shape.borderRadius,
    borderBottomRightRadius: e.shape.borderRadius,
    border: "1px solid ".concat(e.palette.divider),
    borderTop: 0
  };
});

var ooe = n(function (e) {
  var t = e.defaultLocale,
      o = e.locales,
      _e$groupKey2 = e.groupKey,
      r = _e$groupKey2 === void 0 ? "" : _e$groupKey2,
      _e$selector2 = e.selector,
      a = _e$selector2 === void 0 ? zn.createElement(Vu, {
    groupKey: r
  }) : _e$selector2,
      s = e.children,
      p = e.resource,
      c = e.className,
      d = GA(e),
      m = QA({
    defaultLocale: t,
    locales: o
  });
  return zn.createElement(KA, {
    className: c
  }, zn.createElement(XA, {
    value: m
  }, a, o.map(function (u) {
    return zn.createElement(Hu, {
      key: u,
      locale: u,
      record: d,
      resource: p,
      groupKey: r
    }, s);
  })));
}, "TranslatableFields"),
    JA = "RaTranslatableFields",
    KA = UA("div", {
  name: JA,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref141) {
  var e = _ref141.theme;
  return {
    flexGrow: 1,
    marginTop: e.spacing(1),
    marginBottom: e.spacing(.5)
  };
});
l();
import * as Ep from "react";
import { memo as YA } from "react";
import ZA from "lodash/get";
import { Typography as e$, Link as t$ } from "@mui/material";
import { useRecordContext as o$ } from "ra-core";
var jr = YA(function (e) {
  var c = e,
      t = c.className,
      o = c.emptyText,
      r = c.source,
      a = f(c, ["className", "emptyText", "source"]),
      s = o$(e),
      p = ZA(s, r);
  return p == null ? Ep.createElement(e$, i({
    component: "span",
    variant: "body2",
    className: t
  }, X(a)), o) : Ep.createElement(t$, i({
    className: t,
    href: p,
    variant: "body2"
  }, X(a)), p);
});
jr.propTypes = q;
jr.displayName = "UrlField";
l();
import * as Es from "react";
var zu = n(function (_ref142) {
  var e = _ref142.children;
  return Es.createElement(Es.Fragment, null, e);
}, "WrapperField");
zu.displayName = "WrapperField";
zu.propTypes = q;
l();
import * as Wn from "react";
import { Children as r$, isValidElement as n$ } from "react";
import { styled as a$ } from "@mui/material/styles";
import { Stack as s$ } from "@mui/material";
import qn from "prop-types";
import i$ from "clsx";
import { useRecordContext as l$, OptionalRecordContextProvider as p$ } from "ra-core";
var Np = n(function (e) {
  var c = e,
      t = c.className,
      o = c.children,
      r = c.divider,
      _c$spacing = c.spacing,
      a = _c$spacing === void 0 ? 1 : _c$spacing,
      s = f(c, ["className", "children", "divider", "spacing"]);
  return l$(e) ? Wn.createElement(p$, {
    value: e.record
  }, Wn.createElement(c$, i({
    className: t
  }, m$(s)), Wn.createElement(s$, {
    spacing: a,
    divider: r,
    className: Ns.stack
  }, r$.map(o, function (d) {
    return d && n$(d) ? Wn.createElement(fe, {
      key: d.props.source,
      className: i$("ra-field", d.props.source && "ra-field-".concat(d.props.source), Ns.row, d.props.className)
    }, d) : null;
  })))) : null;
}, "SimpleShowLayout");
Np.propTypes = {
  children: qn.node,
  className: qn.string,
  record: qn.object,
  spacing: qn.any,
  sx: qn.any
};
var Bp = "RaSimpleShowLayout",
    Ns = {
  stack: "".concat(Bp, "-stack"),
  row: "".concat(Bp, "-row")
},
    c$ = a$("div", {
  name: Bp,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref143) {
  var _ref144;

  var e = _ref143.theme;
  return _ref144 = {
    flex: 1,
    padding: "".concat(e.spacing(1), " ").concat(e.spacing(2))
  }, _defineProperty(_ref144, "& .".concat(Ns.stack), {}), _defineProperty(_ref144, "& .".concat(Ns.row), {
    display: "inline"
  }), _ref144;
}),
    m$ = n(function (s) {
  var p = s,
      e = p.record,
      t = p.resource,
      o = p.initialValues,
      r = p.translate,
      a = f(p, ["record", "resource", "initialValues", "translate"]);
  return a;
}, "sanitizeRestProps");
var Lp = {
  show: {
    component: function component(e) {
      return Ur.createElement(Np, i({}, e));
    },
    representation: function representation(e, t) {
      return "        <SimpleShowLayout>\n".concat(t.map(function (o) {
        return "            ".concat(o.getRepresentation());
      }).join("\n"), "\n        </SimpleShowLayout>");
    }
  },
  array: {
    component: function component(o) {
      var r = o,
          e = r.children,
          t = f(r, ["children"]);
      return Ur.createElement(Or, i({}, t), Ur.createElement(ro, null, e));
    },
    representation: function representation(e, t) {
      return "<ArrayField source=\"".concat(e.source, "\"><Datagrid>").concat(t.map(function (o) {
        return o.getRepresentation();
      }).join("\n"), "</Datagrid></ArrayField>");
    }
  },
  boolean: {
    component: Mr,
    representation: function representation(e) {
      return "<BooleanField source=\"".concat(e.source, "\" />");
    }
  },
  date: {
    component: _r,
    representation: function representation(e) {
      return "<DateField source=\"".concat(e.source, "\" />");
    }
  },
  email: {
    component: Hr,
    representation: function representation(e) {
      return "<EmailField source=\"".concat(e.source, "\" />");
    }
  },
  id: {
    component: at,
    representation: function representation(e) {
      return "<TextField source=\"".concat(e.source, "\" />");
    }
  },
  number: {
    component: Go,
    representation: function representation(e) {
      return "<NumberField source=\"".concat(e.source, "\" />");
    }
  },
  reference: {
    component: zr,
    representation: function representation(e) {
      return "<ReferenceField source=\"".concat(e.source, "\" reference=\"").concat(e.reference, "\"><TextField source=\"id\" /></ReferenceField>");
    }
  },
  referenceChild: {
    component: function component(e) {
      return Ur.createElement(at, i({
        source: "id"
      }, e));
    },
    representation: function representation() {
      return '<TextField source="id" />';
    }
  },
  referenceArray: {
    component: Vn,
    representation: function representation(e) {
      return "<ReferenceArrayField source=\"".concat(e.source, "\" reference=\"").concat(e.reference, "\"><TextField source=\"id\" /></ReferenceArrayField>");
    }
  },
  referenceArrayChild: {
    component: function component(e) {
      return Ur.createElement(at, i({
        source: "id"
      }, e));
    },
    representation: function representation() {
      return '<TextField source="id" />';
    }
  },
  richText: {
    component: Is,
    representation: function representation(e) {
      return "<RichTextField source=\"".concat(e.source, "\" />");
    }
  },
  string: {
    component: at,
    representation: function representation(e) {
      return "<TextField source=\"".concat(e.source, "\" />");
    }
  },
  url: {
    component: jr,
    representation: function representation(e) {
      return "<UrlField source=\"".concat(e.source, "\" />");
    }
  }
};
l();
import * as Bs from "react";
import { useEffect as d$, useState as u$ } from "react";
import Wu from "inflection";
import { ShowBase as f$, InferredElement as g$, getElementsFromRecords as y$, useResourceContext as b$, useShowContext as h$ } from "ra-core";
var qu = n(function (e) {
  var t = b$(e),
      _h$ = h$(),
      o = _h$.record,
      _u$ = u$(null),
      _u$2 = _slicedToArray(_u$, 2),
      r = _u$2[0],
      a = _u$2[1];

  return d$(function () {
    if (o && !r) {
      var s = y$([o], Lp),
          p = new g$(Lp.show, null, s);
      process.env.NODE_ENV !== "production" && console.log("Guessed Show:\n\nexport const ".concat(Wu.capitalize(Wu.singularize(t)), "Show = () => (\n    <Show>\n").concat(p.getRepresentation(), "\n    </Show>\n);")), a(p.getElement());
    }
  }, [o, r, t]), Bs.createElement(Ar, i({}, e), r);
}, "ShowViewGuesser");
qu.propTypes = Ar.propTypes;
var Hoe = n(function (r) {
  var a = r,
      e = a.id,
      t = a.queryOptions,
      o = f(a, ["id", "queryOptions"]);
  return Bs.createElement(f$, {
    id: e,
    queryOptions: t
  }, Bs.createElement(qu, i({}, o)));
}, "ShowGuesser");
l();
import * as Ne from "react";
import { Children as Ap, cloneElement as $p, isValidElement as Uu, useState as I$ } from "react";
import go from "prop-types";
import { styled as F$ } from "@mui/material/styles";
import { Divider as Xu } from "@mui/material";
import { Outlet as S$, Routes as E$, Route as Qu } from "react-router-dom";
import { useRecordContext as N$, OptionalRecordContextProvider as B$ } from "ra-core";
l();
import * as ju from "react";
import { Children as R$, cloneElement as T$, isValidElement as P$ } from "react";
import x$ from "prop-types";
import C$ from "@mui/material/Tabs";
import { useParams as v$ } from "react-router-dom";
var kp = n(function (a) {
  var s = a,
      e = s.children,
      t = s.syncWithLocation,
      o = s.value,
      r = f(s, ["children", "syncWithLocation", "value"]);
  var c = v$()["*"];
  return ju.createElement(C$, i({
    indicatorColor: "primary",
    value: t ? c : o
  }, r), R$.map(e, function (d, m) {
    if (!d || !P$(d)) return null;
    var u = wp(d, m);
    return T$(d, {
      context: "header",
      value: t ? u : m,
      syncWithLocation: t
    });
  }));
}, "TabbedShowLayoutTabs"),
    wp = n(function (e, t) {
  return "".concat(e.props.path ? "".concat(e.props.path) : t > 0 ? t : "");
}, "getShowLayoutTabFullPath");
kp.propTypes = {
  children: x$.node
};
var L$ = n(function (e) {
  var T = e,
      t = T.children,
      o = T.className,
      r = T.spacing,
      a = T.divider,
      _T$syncWithLocation = T.syncWithLocation,
      s = _T$syncWithLocation === void 0 ? !0 : _T$syncWithLocation,
      _T$tabs = T.tabs,
      p = _T$tabs === void 0 ? k$ : _T$tabs,
      c = T.value,
      d = f(T, ["children", "className", "spacing", "divider", "syncWithLocation", "tabs", "value"]),
      m = N$(e),
      u = Ap.toArray(t).filter(function (x) {
    return x !== null;
  }),
      _I$ = I$(0),
      _I$2 = _slicedToArray(_I$, 2),
      g = _I$2[0],
      y = _I$2[1],
      b = n(function (x, C) {
    s || y(C);
  }, "handleTabChange");

  if (!m) return null;
  var P = n(function () {
    return $p(p, {
      onChange: b,
      syncWithLocation: s,
      value: g
    }, u);
  }, "renderTabHeaders");
  return Ne.createElement(B$, {
    value: e.record
  }, Ne.createElement(w$, i({
    className: o
  }, A$(d)), s ? Ne.createElement(E$, null, Ne.createElement(Qu, {
    path: "/*",
    element: Ne.createElement(Ne.Fragment, null, P(), Ne.createElement(Xu, null), Ne.createElement("div", {
      className: Op.content
    }, Ne.createElement(S$, null)))
  }, Ap.map(u, function (x, C) {
    return Uu(x) ? Ne.createElement(Qu, {
      path: wp(x, C),
      element: $p(x, {
        context: "content",
        spacing: r,
        divider: a
      })
    }) : null;
  }))) : Ne.createElement(Ne.Fragment, null, P(), Ne.createElement(Xu, null), Ne.createElement("div", {
    className: Op.content
  }, Ap.map(u, function (x, C) {
    return !Uu(x) || g !== C ? null : $p(x, {
      context: "content",
      spacing: r,
      divider: a
    });
  })))));
}, "TabbedShowLayout");
L$.propTypes = {
  children: go.node,
  className: go.string,
  record: go.object,
  spacing: go.any,
  sx: go.any,
  syncWithLocation: go.bool,
  tabs: go.element,
  value: go.number
};
var k$ = Ne.createElement(kp, null),
    Gu = "RaTabbedShowLayout",
    Op = {
  content: "".concat(Gu, "-content")
},
    w$ = F$("div", {
  name: Gu,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref145) {
  var e = _ref145.theme;
  return _defineProperty({
    flex: 1
  }, "& .".concat(Op.content), {
    padding: "".concat(e.spacing(1), " ").concat(e.spacing(2))
  });
}),
    A$ = n(function (c) {
  var d = c,
      e = d.record,
      t = d.resource,
      o = d.initialValues,
      r = d.staticContext,
      a = d.translate,
      s = d.tabs,
      p = f(d, ["record", "resource", "initialValues", "staticContext", "translate", "tabs"]);
  return p;
}, "sanitizeRestProps");
l();
import * as Xr from "react";
import { isValidElement as $$ } from "react";
import Ye from "prop-types";
import { Link as O$, useLocation as D$ } from "react-router-dom";
import { Tab as M$, Stack as V$ } from "@mui/material";
import { useTranslate as _$ } from "ra-core";
import Ju from "clsx";
var H$ = n(function (y) {
  var b = y,
      e = b.children,
      t = b.contentClassName,
      o = b.context,
      r = b.className,
      a = b.divider,
      s = b.icon,
      p = b.label,
      c = b.record,
      _b$spacing = b.spacing,
      d = _b$spacing === void 0 ? 1 : _b$spacing,
      _b$syncWithLocation = b.syncWithLocation,
      m = _b$syncWithLocation === void 0 ? !0 : _b$syncWithLocation,
      u = b.value,
      g = f(b, ["children", "contentClassName", "context", "className", "divider", "icon", "label", "record", "spacing", "syncWithLocation", "value"]);

  var P = _$(),
      T = D$(),
      x = {
    component: O$,
    to: E(i({}, T), {
      pathname: u
    })
  };

  return o === "header" ? n(function () {
    return Xr.createElement(M$, i(i({
      key: "tab-header-".concat(u),
      label: typeof p == "string" ? P(p, {
        _: p
      }) : p,
      value: u,
      icon: s,
      className: Ju("show-tab", r)
    }, m ? x : {}), g));
  }, "renderHeader")() : n(function () {
    return Xr.createElement(V$, {
      className: t,
      spacing: d,
      divider: a
    }, Xr.Children.map(e, function (I) {
      return I && $$(I) ? Xr.createElement(fe, {
        key: I.props.source,
        className: Ju("ra-field", I.props.source && "ra-field-".concat(I.props.source), I.props.className)
      }, I) : null;
    }));
  }, "renderContent")();
}, "Tab");
H$.propTypes = {
  className: Ye.string,
  contentClassName: Ye.string,
  children: Ye.node,
  context: Ye.oneOf(["header", "content"]),
  icon: Ye.element,
  label: Ye.oneOfType([Ye.string, Ye.element]).isRequired,
  path: Ye.string,
  spacing: Ye.any,
  value: Ye.oneOfType([Ye.string, Ye.number])
};
l();
import * as yo from "react";
import { styled as z$ } from "@mui/material/styles";
import { Typography as Ku } from "@mui/material";
import W$ from "@mui/icons-material/Inbox";
import { useTranslate as q$, useResourceDefinition as j$, useResourceContext as U$, useGetResourceLabel as X$ } from "ra-core";
var Yu = n(function (e) {
  var t = e.className,
      _j$ = j$(e),
      o = _j$.hasCreate,
      r = U$(e),
      a = q$(),
      s = X$(),
      p = a("resources.".concat(r, ".forcedCaseName"), {
    smart_count: 0,
    _: s(r, 0)
  }),
      c = a("ra.page.empty", {
    name: p
  }),
      d = a("ra.page.invite");

  return yo.createElement(Q$, {
    className: t
  }, yo.createElement("div", {
    className: Qr.message
  }, yo.createElement(W$, {
    className: Qr.icon
  }), yo.createElement(Ku, {
    variant: "h4",
    paragraph: !0
  }, a("resources.".concat(r, ".empty"), {
    _: c
  })), o && yo.createElement(Ku, {
    variant: "body1"
  }, a("resources.".concat(r, ".invite"), {
    _: d
  }))), o && yo.createElement("div", {
    className: Qr.toolbar
  }, yo.createElement(ln, {
    variant: "contained"
  })));
}, "Empty"),
    Ls = "RaEmpty",
    Qr = {
  message: "".concat(Ls, "-message"),
  icon: "".concat(Ls, "-icon"),
  toolbar: "".concat(Ls, "-toolbar")
},
    Q$ = z$("span", {
  name: Ls,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref147) {
  var _ref148;

  var e = _ref147.theme;
  return _ref148 = {
    flex: 1
  }, _defineProperty(_ref148, "& .".concat(Qr.message), {
    textAlign: "center",
    opacity: e.palette.mode === "light" ? .5 : .8,
    margin: "0 1em",
    color: e.palette.mode === "light" ? "inherit" : e.palette.text.primary
  }), _defineProperty(_ref148, "& .".concat(Qr.icon), {
    width: "9em",
    height: "9em"
  }), _defineProperty(_ref148, "& .".concat(Qr.toolbar), {
    textAlign: "center",
    marginTop: "2em"
  }), _ref148;
});
l();
import * as Mp from "react";
import ee from "prop-types";
import { ListBase as bO } from "ra-core";
l();
import * as jt from "react";
import { styled as sO } from "@mui/material/styles";
import { Children as iO, cloneElement as ef } from "react";
import H from "prop-types";
import lO from "@mui/material/Card";
import pO from "clsx";
import { ComponentPropType as cO, useListContext as mO } from "ra-core";
l();
import * as gt from "react";
import { memo as G$ } from "react";
import { styled as J$ } from "@mui/material/styles";
import Bt from "prop-types";
import { Toolbar as K$ } from "@mui/material";
var Dp = G$(function (e) {
  var s = e,
      t = s.filters,
      o = s.actions,
      r = s.className,
      a = f(s, ["filters", "actions", "className"]);
  return Array.isArray(t) ? gt.createElement(rt.Provider, {
    value: t
  }, gt.createElement(Zu, {
    className: r
  }, gt.createElement(br, null), gt.createElement("span", null), o && gt.cloneElement(o, i(i({}, a), o.props)))) : gt.createElement(Zu, {
    className: r
  }, t && gt.cloneElement(t, E(i({}, a), {
    context: "form"
  })), gt.createElement("span", null), o && gt.cloneElement(o, i(E(i({}, a), {
    filters: t
  }), o.props)));
});
Dp.propTypes = {
  filters: Bt.oneOfType([Bt.element, Bt.arrayOf(Bt.element)]),
  actions: Bt.oneOfType([Bt.bool, Bt.element]),
  exporter: Bt.oneOfType([Bt.func, Bt.bool])
};
var Y$ = "RaListToolbar",
    Zu = J$(K$, {
  name: Y$,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref149) {
  var _ref150;

  var e = _ref149.theme;
  return _ref150 = {
    justifyContent: "space-between",
    alignItems: "flex-end",
    minHeight: "auto"
  }, _defineProperty(_ref150, e.breakpoints.up("sm"), {
    paddingRight: 0
  }), _defineProperty(_ref150, e.breakpoints.up("xs"), {
    paddingLeft: 0
  }), _defineProperty(_ref150, e.breakpoints.down("sm"), {
    paddingLeft: e.spacing(2),
    backgroundColor: e.palette.background.paper
  }), _ref150;
});
l();
import * as jn from "react";
import { cloneElement as Z$, useMemo as eO, useContext as tO } from "react";
import Oe from "prop-types";
import { sanitizeListRestProps as oO, useListContext as rO, useResourceContext as nO, useResourceDefinition as aO } from "ra-core";
var ks = n(function (e) {
  var P = e,
      t = P.className,
      o = P.filters,
      r = P.hasCreate,
      a = f(P, ["className", "filters", "hasCreate"]),
      _rO = rO(e),
      s = _rO.sort,
      p = _rO.displayedFilters,
      c = _rO.filterValues,
      d = _rO.exporter,
      m = _rO.showFilter,
      u = _rO.total,
      g = nO(e),
      _aO = aO(e),
      y = _aO.hasCreate,
      b = tO(rt) || o;

  return eO(function () {
    return jn.createElement(xt, i({
      className: t
    }, oO(a)), o ? Z$(o, {
      resource: g,
      showFilter: m,
      displayedFilters: p,
      filterValues: c,
      context: "button"
    }) : b && jn.createElement(Do, null), y && jn.createElement(ln, null), d !== !1 && jn.createElement(ii, {
      disabled: u === 0,
      resource: g,
      sort: s,
      filterValues: c
    }));
  }, [g, p, c, o, m, b, u, t, s, d, y]);
}, "ListActions");
ks.propTypes = {
  className: Oe.string,
  sort: Oe.any,
  displayedFilters: Oe.object,
  exporter: Oe.oneOfType([Oe.func, Oe.bool]),
  filters: Oe.element,
  filterValues: Oe.object,
  hasCreate: Oe.bool,
  resource: Oe.string,
  onUnselectItems: Oe.func.isRequired,
  selectedIds: Oe.arrayOf(Oe.any),
  showFilter: Oe.func,
  total: Oe.number
};
ks.defaultProps = {
  selectedIds: [],
  onUnselectItems: function onUnselectItems() {
    return null;
  }
};
var dO = jt.createElement(ks, null),
    uO = jt.createElement(vn, null),
    fO = jt.createElement(Yu, null),
    gO = lO,
    Gr = n(function (e) {
  var L = e,
      _L$actions = L.actions,
      t = _L$actions === void 0 ? dO : _L$actions,
      o = L.aside,
      r = L.filters,
      a = L.bulkActionButtons,
      s = L.emptyWhileLoading,
      p = L.hasCreate,
      _L$pagination = L.pagination,
      c = _L$pagination === void 0 ? uO : _L$pagination,
      d = L.children,
      m = L.className,
      _L$component = L.component,
      u = _L$component === void 0 ? gO : _L$component,
      g = L.title,
      _L$empty = L.empty,
      y = _L$empty === void 0 ? fO : _L$empty,
      b = f(L, ["actions", "aside", "filters", "bulkActionButtons", "emptyWhileLoading", "hasCreate", "pagination", "children", "className", "component", "title", "empty"]),
      _mO = mO(e),
      P = _mO.defaultTitle,
      T = _mO.data,
      x = _mO.error,
      C = _mO.total,
      v = _mO.isLoading,
      I = _mO.filterValues;

  if (!d || !T && v && s || x) return null;
  var N = n(function () {
    return jt.createElement("div", {
      className: Jr.main
    }, (r || t) && jt.createElement(Dp, {
      filters: r,
      actions: t,
      hasCreate: p
    }), jt.createElement(u, {
      className: Jr.content
    }, a && d ? ef(iO.only(d), {
      bulkActionButtons: a
    }) : d), c !== !1 && c);
  }, "renderList"),
      F = n(function () {
    return y !== !1 && ef(y, {
      hasCreate: p
    });
  }, "renderEmpty"),
      S = !v && C === 0 && !Object.keys(I).length && y !== !1;
  return jt.createElement(yO, i({
    className: pO("list-page", m)
  }, b), jt.createElement(je, {
    title: g,
    defaultTitle: P
  }), S ? F() : N(), o);
}, "ListView");
Gr.propTypes = {
  actions: H.oneOfType([H.bool, H.element]),
  aside: H.element,
  children: H.element,
  className: H.string,
  component: cO,
  sort: H.shape({
    field: H.string.isRequired,
    order: H.string.isRequired
  }),
  data: H.any,
  defaultTitle: H.string,
  displayedFilters: H.object,
  emptyWhileLoading: H.bool,
  exporter: H.oneOfType([H.func, H.bool]),
  filterDefaultValues: H.object,
  filters: H.oneOfType([H.element, H.arrayOf(H.element)]),
  filterValues: H.object,
  hasCreate: H.bool,
  hideFilter: H.func,
  ids: H.array,
  loading: H.bool,
  onSelect: H.func,
  onToggleItem: H.func,
  onUnselectItems: H.func,
  page: H.number,
  pagination: H.oneOfType([H.element, H.bool]),
  perPage: H.number,
  refresh: H.func,
  resource: H.string,
  selectedIds: H.array,
  setFilters: H.func,
  setPage: H.func,
  setPerPage: H.func,
  setSort: H.func,
  showFilter: H.func,
  title: No,
  total: H.number
};
var Un = "RaList",
    Jr = {
  main: "".concat(Un, "-main"),
  content: "".concat(Un, "-content"),
  actions: "".concat(Un, "-actions"),
  noResults: "".concat(Un, "-noResults")
},
    yO = sO("div", {
  name: Un,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref151) {
  var _$concat6, _ref152;

  var e = _ref151.theme;
  return _ref152 = {
    display: "flex"
  }, _defineProperty(_ref152, "& .".concat(Jr.main), {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column"
  }), _defineProperty(_ref152, "& .".concat(Jr.content), (_$concat6 = {
    position: "relative"
  }, _defineProperty(_$concat6, e.breakpoints.down("sm"), {
    boxShadow: "none"
  }), _defineProperty(_$concat6, "overflow", "inherit"), _$concat6)), _defineProperty(_ref152, "& .".concat(Jr.actions), {
    zIndex: 2,
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap"
  }), _defineProperty(_ref152, "& .".concat(Jr.noResults), {
    padding: 20
  }), _ref152;
});
var tf = n(function (g) {
  var y = g,
      e = y.debounce,
      t = y.disableAuthentication,
      o = y.disableSyncWithLocation,
      r = y.exporter,
      a = y.filter,
      s = y.filterDefaultValues,
      p = y.perPage,
      c = y.queryOptions,
      d = y.resource,
      m = y.sort,
      u = f(y, ["debounce", "disableAuthentication", "disableSyncWithLocation", "exporter", "filter", "filterDefaultValues", "perPage", "queryOptions", "resource", "sort"]);
  return Mp.createElement(bO, {
    debounce: e,
    disableAuthentication: t,
    disableSyncWithLocation: o,
    exporter: r,
    filter: a,
    filterDefaultValues: s,
    perPage: p,
    queryOptions: c,
    resource: d,
    sort: m
  }, Mp.createElement(Gr, i({}, u)));
}, "List");
tf.propTypes = {
  actions: ee.oneOfType([ee.bool, ee.element]),
  aside: ee.element,
  children: ee.element.isRequired,
  className: ee.string,
  emptyWhileLoading: ee.bool,
  filter: ee.object,
  filterDefaultValues: ee.object,
  filters: ee.oneOfType([ee.element, ee.arrayOf(ee.element)]),
  pagination: ee.oneOfType([ee.element, ee.bool]),
  perPage: ee.number.isRequired,
  sort: ee.shape({
    field: ee.string,
    order: ee.string
  }),
  sx: ee.any,
  title: No,
  disableSyncWithLocation: ee.bool,
  hasCreate: ee.bool,
  hasEdit: ee.bool,
  hasList: ee.bool,
  hasShow: ee.bool,
  resource: ee.string
};
tf.defaultProps = {
  filter: {},
  perPage: 10
};
l();
import * as ws from "react";
import { useState as BO, useEffect as af } from "react";
import sf from "inflection";
import { useListController as LO, getElementsFromRecords as kO, InferredElement as wO, ListContextProvider as AO, useListContext as $O, useResourceContext as OO } from "ra-core";
l();
import * as Ko from "react";
l();
import * as Kr from "react";
import { styled as hO } from "@mui/material/styles";
import { cloneElement as RO, Children as TO } from "react";
import Ut from "prop-types";
import PO from "@mui/material/LinearProgress";
import { sanitizeListRestProps as xO, useListContext as CO, useResourceContext as vO, RecordContextProvider as of, ComponentPropType as IO, useCreatePath as FO } from "ra-core";
var Vp = n(function (e) {
  var u = e,
      t = u.className,
      o = u.children,
      _u$linkType = u.linkType,
      r = _u$linkType === void 0 ? "edit" : _u$linkType,
      _u$component = u.component,
      a = _u$component === void 0 ? SO : _u$component,
      s = f(u, ["className", "children", "linkType", "component"]),
      _CO = CO(e),
      p = _CO.data,
      c = _CO.isLoading,
      d = vO(e),
      m = FO();

  return c === !0 ? Kr.createElement(PO, null) : Kr.createElement(a, i({
    className: t
  }, xO(s)), p.map(function (g, y) {
    var P, T;
    var b = r ? m({
      resource: d,
      type: r,
      id: g.id
    }) : !1;
    return b ? Kr.createElement(of, {
      value: g,
      key: (P = g.id) != null ? P : "row".concat(y)
    }, Kr.createElement(Hn, {
      className: nf.link,
      to: b,
      onClick: EO
    }, RO(TO.only(o), {
      record: g,
      resource: d,
      onClick: NO
    }))) : Kr.createElement(of, {
      value: g,
      key: (T = g.id) != null ? T : "row".concat(y)
    }, o);
  }));
}, "SingleFieldList");
Vp.propTypes = {
  children: Ut.element.isRequired,
  classes: Ut.object,
  className: Ut.string,
  component: IO,
  data: Ut.any,
  ids: Ut.array,
  linkType: Ut.oneOfType([Ut.string, Ut.bool]),
  resource: Ut.string
};
var rf = "RaSingleFieldList",
    nf = {
  link: "".concat(rf, "-link")
},
    SO = hO("div", {
  name: rf,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref153) {
  var e = _ref153.theme;
  return _defineProperty({
    display: "flex",
    flexWrap: "wrap",
    marginTop: e.spacing(-1),
    marginBottom: e.spacing(-1)
  }, "& .".concat(nf.link), {
    textDecoration: "none"
  });
}),
    EO = n(function (e) {
  return e.stopPropagation();
}, "stopPropagation"),
    NO = n(function () {}, "handleClick");
var _p = {
  table: {
    component: function component(e) {
      return Ko.createElement(ro, i({
        rowClick: "edit"
      }, e));
    },
    representation: function representation(e, t) {
      return "        <Datagrid rowClick=\"edit\">\n".concat(t.map(function (o) {
        return "            ".concat(o.getRepresentation());
      }).join("\n"), "\n        </Datagrid>");
    }
  },
  array: {
    component: function component(o) {
      var r = o,
          e = r.children,
          t = f(r, ["children"]);
      return Ko.createElement(Or, i({}, t), Ko.createElement(Vp, null, Ko.createElement(On, {
        source: e.length > 0 && e[0].props.source
      })));
    },
    representation: function representation(e, t) {
      return "<ArrayField source=\"".concat(e.source, "\"><SingleFieldList><ChipField source=\"").concat(t.length > 0 && t[0].getProps().source, "\" /></SingleFieldList></ArrayField>");
    }
  },
  boolean: {
    component: Mr,
    representation: function representation(e) {
      return "<BooleanField source=\"".concat(e.source, "\" />");
    }
  },
  date: {
    component: _r,
    representation: function representation(e) {
      return "<DateField source=\"".concat(e.source, "\" />");
    }
  },
  email: {
    component: Hr,
    representation: function representation(e) {
      return "<EmailField source=\"".concat(e.source, "\" />");
    }
  },
  id: {
    component: at,
    representation: function representation(e) {
      return "<TextField source=\"".concat(e.source, "\" />");
    }
  },
  number: {
    component: Go,
    representation: function representation(e) {
      return "<NumberField source=\"".concat(e.source, "\" />");
    }
  },
  reference: {
    component: zr,
    representation: function representation(e) {
      return "<ReferenceField source=\"".concat(e.source, "\" reference=\"").concat(e.reference, "\"><TextField source=\"id\" /></ReferenceField>");
    }
  },
  referenceChild: {
    component: function component(e) {
      return Ko.createElement(at, i({
        source: "id"
      }, e));
    },
    representation: function representation() {
      return '<TextField source="id" />';
    }
  },
  referenceArray: {
    component: Vn,
    representation: function representation(e) {
      return "<ReferenceArrayField source=\"".concat(e.source, "\" reference=\"").concat(e.reference, "\"><TextField source=\"id\" /></ReferenceArrayField>");
    }
  },
  referenceArrayChild: {
    component: function component(e) {
      return Ko.createElement(at, i({
        source: "id"
      }, e));
    },
    representation: function representation() {
      return '<TextField source="id" />';
    }
  },
  richText: void 0,
  string: {
    component: at,
    representation: function representation(e) {
      return "<TextField source=\"".concat(e.source, "\" />");
    }
  },
  url: {
    component: jr,
    representation: function representation(e) {
      return "<UrlField source=\"".concat(e.source, "\" />");
    }
  }
};
var Dne = n(function () {
  var e = LO({
    queryOptions: {
      keepPreviousData: !1
    }
  });
  return ws.createElement(AO, {
    value: e
  }, ws.createElement(lf, i({}, e)));
}, "ListGuesser"),
    lf = n(function (e) {
  var _$O = $O(e),
      t = _$O.data,
      o = OO(),
      _BO = BO(null),
      _BO2 = _slicedToArray(_BO, 2),
      r = _BO2[0],
      a = _BO2[1];

  return af(function () {
    a(null);
  }, [o]), af(function () {
    if (t && t.length > 0 && !r) {
      var s = kO(t, _p),
          p = new wO(_p.table, null, s);
      process.env.NODE_ENV !== "production" && console.log("Guessed List:\n\nexport const ".concat(sf.capitalize(sf.singularize(o)), "List = () => (\n    <List>\n").concat(p.getRepresentation(), "\n    </List>\n);")), a(p.getElement());
    }
  }, [t, r, o]), ws.createElement(Gr, i({}, e), r);
}, "ListViewGuesser");
lf.propTypes = Gr.propTypes;
l();
import * as xe from "react";
import { styled as UO } from "@mui/material/styles";
import { isValidElement as Wp } from "react";
import be from "prop-types";
import { Avatar as qp, List as XO, ListItem as QO, ListItemAvatar as GO, ListItemButton as JO, ListItemIcon as cf, ListItemSecondaryAction as KO, ListItemText as mf } from "@mui/material";
import { Link as YO } from "react-router-dom";
import { RecordContextProvider as ZO, sanitizeListRestProps as eD, useListContext as tD, useResourceContext as oD, useCreatePath as rD } from "ra-core";
l();
import * as Ze from "react";
import { styled as DO } from "@mui/material/styles";
import Yr from "prop-types";
import pf from "@mui/material/Avatar";
import MO from "@mui/material/List";
import VO from "@mui/material/ListItem";
import _O from "@mui/material/ListItemAvatar";
import HO from "@mui/material/ListItemSecondaryAction";
import zO from "@mui/material/ListItemText";
import { useTimeout as WO } from "ra-core";
var Hp = n(function (e) {
  var m = e,
      t = m.className,
      o = m.hasLeftAvatarOrIcon,
      r = m.hasRightAvatarOrIcon,
      a = m.hasSecondaryText,
      s = m.hasTertiaryText,
      _m$nbFakeLines = m.nbFakeLines,
      p = _m$nbFakeLines === void 0 ? 5 : _m$nbFakeLines,
      c = f(m, ["className", "hasLeftAvatarOrIcon", "hasRightAvatarOrIcon", "hasSecondaryText", "hasTertiaryText", "nbFakeLines"]);
  return WO(1e3) ? Ze.createElement(qO, i({
    className: t
  }, c), jO(p, function (u) {
    return Ze.createElement(VO, {
      key: u
    }, o && Ze.createElement(_O, null, Ze.createElement(pf, null, "\xA0")), Ze.createElement(zO, {
      primary: Ze.createElement("div", null, Ze.createElement(Lo, {
        className: As.primary
      }), s && Ze.createElement("span", {
        className: As.tertiary
      }, Ze.createElement(Lo, null))),
      secondary: a ? Ze.createElement(Lo, null) : void 0
    }), r && Ze.createElement(HO, null, Ze.createElement(pf, null, "\xA0")));
  })) : null;
}, "SimpleListLoading");
Hp.propTypes = {
  className: Yr.string,
  hasLeftAvatarOrIcon: Yr.bool,
  hasRightAvatarOrIcon: Yr.bool,
  hasSecondaryText: Yr.bool,
  hasTertiaryText: Yr.bool,
  nbFakeLines: Yr.number
};
var zp = "RaSimpleListLoading",
    As = {
  primary: "".concat(zp, "-primary"),
  tertiary: "".concat(zp, "-tertiary")
},
    qO = DO(MO, {
  name: zp,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(function (_ref155) {
  var _ref156;

  var e = _ref155.theme;
  return _ref156 = {}, _defineProperty(_ref156, "& .".concat(As.primary), {
    width: "30vw",
    display: "inline-block",
    marginBottom: e.spacing()
  }), _defineProperty(_ref156, "& .".concat(As.tertiary), {
    float: "right",
    opacity: .541176,
    minWidth: "10vw"
  }), _ref156;
}),
    jO = n(function (e, t) {
  return Array.from({
    length: e
  }, function (o, r) {
    return t(r);
  });
}, "times");
var nD = n(function (e) {
  var v = e,
      t = v.className,
      o = v.hasBulkActions,
      r = v.leftAvatar,
      a = v.leftIcon,
      _v$linkType = v.linkType,
      s = _v$linkType === void 0 ? "edit" : _v$linkType,
      p = v.primaryText,
      c = v.rightAvatar,
      d = v.rightIcon,
      m = v.secondaryText,
      u = v.tertiaryText,
      g = v.rowStyle,
      y = f(v, ["className", "hasBulkActions", "leftAvatar", "leftIcon", "linkType", "primaryText", "rightAvatar", "rightIcon", "secondaryText", "tertiaryText", "rowStyle"]),
      _tD = tD(e),
      b = _tD.data,
      P = _tD.isLoading,
      T = _tD.total,
      x = oD(e);

  if (P === !0) return xe.createElement(Hp, {
    className: t,
    hasLeftAvatarOrIcon: !!a || !!r,
    hasRightAvatarOrIcon: !!d || !!c,
    hasSecondaryText: !!m,
    hasTertiaryText: !!u
  });
  var C = n(function (I, N) {
    var F = N(I, I.id);
    return typeof F == "string" && (F.startsWith("http") || F.startsWith("data:")) ? xe.createElement(qp, {
      src: F
    }) : xe.createElement(qp, null, F);
  }, "renderAvatar");
  return T == null && (b == null ? void 0 : b.length) > 0 || T > 0 ? xe.createElement(sD, i({
    className: t
  }, eD(y)), b.map(function (I, N) {
    return xe.createElement(ZO, {
      key: I.id,
      value: I
    }, xe.createElement(QO, {
      disablePadding: !0
    }, xe.createElement(aD, {
      linkType: s,
      resource: x,
      id: I.id,
      record: I,
      style: g ? g(I, N) : void 0
    }, a && xe.createElement(cf, null, a(I, I.id)), r && xe.createElement(GO, null, C(I, r)), xe.createElement(mf, {
      primary: xe.createElement("div", null, Wp(p) ? p : p(I, I.id), !!u && (Wp(u) ? u : xe.createElement("span", {
        className: uf.tertiary
      }, u(I, I.id)))),
      secondary: !!m && (Wp(m) ? m : m(I, I.id))
    }), (c || d) && xe.createElement(KO, null, c && xe.createElement(qp, null, C(I, c)), d && xe.createElement(cf, null, d(I, I.id))))));
  })) : null;
}, "SimpleList");
nD.propTypes = {
  className: be.string,
  leftAvatar: be.func,
  leftIcon: be.func,
  linkType: be.oneOfType([be.string, be.bool, be.func]),
  primaryText: be.oneOfType([be.func, be.element]),
  rightAvatar: be.func,
  rightIcon: be.func,
  secondaryText: be.oneOfType([be.func, be.element]),
  tertiaryText: be.oneOfType([be.func, be.element]),
  rowStyle: be.func
};
var aD = n(function (e) {
  var u = e,
      t = u.classes,
      o = u.linkType,
      r = u.resource,
      a = u.id,
      s = u.children,
      p = u.record,
      c = f(u, ["classes", "linkType", "resource", "id", "children", "record"]),
      d = rD(),
      m = typeof o == "function" ? o(p, a) : o;
  return m === !1 ? xe.createElement(mf, i({
    component: "div"
  }, c), s) : xe.createElement(JO, i({
    component: YO,
    to: d({
      resource: r,
      id: a,
      type: m
    })
  }, c), s);
}, "LinkOrNot"),
    df = "RaSimpleList",
    uf = {
  tertiary: "".concat(df, "-tertiary")
},
    sD = UO(XO, {
  name: df,
  overridesResolver: function overridesResolver(e, t) {
    return t.root;
  }
})(_defineProperty({}, "& .".concat(uf.tertiary), {
  float: "right",
  opacity: .541176
}));
l();
import * as Xn from "react";
import { createElement as iD } from "react";
import { CoreAdminUI as lD } from "ra-core";
var pD = n(function (o) {
  var r = o,
      e = r.notification,
      t = f(r, ["notification"]);
  return Xn.createElement(Xn.Fragment, null, Xn.createElement(lD, i({}, t)), iD(e));
}, "AdminUI");
pD.defaultProps = {
  layout: Uc,
  catchAll: zi,
  loading: _i,
  loginPage: ds,
  notification: ji
};
l();
import * as jp from "react";
import { CoreAdminContext as cD } from "ra-core";
var mD = n(function (e) {
  var a = e,
      _a$theme = a.theme,
      t = _a$theme === void 0 ? Zd : _a$theme,
      o = a.children,
      r = f(a, ["theme", "children"]);
  return jp.createElement(cD, i({}, r), jp.createElement(Zc, {
    theme: t
  }, o));
}, "AdminContext");
mD.displayName = "AdminContext";
export { im as AddItemButton, _a as AddSavedQueryDialog, fd as AddSavedQueryIconButton, mD as AdminContext, pD as AdminUI, Ci as AppBar, So as AppBarClasses, Or as ArrayField, Xi as ArrayInput, va as ArrayInputContext, BU as AutocompleteArrayInput, ym as AutocompleteInput, hm as AutocompleteInputClasses, Mr as BooleanField, Ba as BooleanInput, gl as BulkActionsToolbar, pt as BulkActionsToolbarClasses, Xs as BulkDeleteButton, Ws as BulkDeleteWithConfirmButton, js as BulkDeleteWithUndoButton, Ny as BulkExportButton, yc as BulkUpdateButton, Gs as BulkUpdateWithConfirmButton, Ks as BulkUpdateWithUndoButton, U as Button, $i as CLOSED_DRAWER_WIDTH, UR as CardContentInner, xH as CardContentInnerClasses, DC as CheckboxGroupInput, Lm as CheckboxGroupInputClasses, On as ChipField, lg as CloneButton, xo as Confirm, Eo as ConfirmClasses, rL as Create, aL as CreateActions, ln as CreateButton, _s as CreateButtonClasses, Sr as CreateClasses, Kl as CreateView, Ai as DRAWER_WIDTH, Si as DashboardMenuItem, ro as Datagrid, ml as DatagridBody, nl as DatagridCell, $ as DatagridClasses, Da as DatagridHeader, dl as DatagridHeaderCell, zm as DatagridHeaderCellClasses, s4 as DatagridInput, fl as DatagridLoading, km as DatagridRoot, cl as DatagridRow, _r as DateField, Al as DateInput, pE as DateTimeInput, ri as DeleteButton, ti as DeleteWithConfirmButton, ei as DeleteWithUndoButton, pz as DeviceTestWrapper, TL as Edit, tp as EditActions, ai as EditButton, Br as EditClasses, y8 as EditGuesser, Nr as EditView, Hr as EmailField, Yu as Empty, Qr as EmptyClasses, Li as Error, Me as ErrorClasses, sl as ExpandRowButton, ii as ExportButton, bw as FileField, Dl as FileInput, Ft as FileInputClasses, IF as Filter, Do as FilterButton, Pl as FilterButtonMenuItem, dd as FilterClasses, rt as FilterContext, br as FilterForm, nd as FilterFormBase, sd as FilterFormClasses, bl as FilterFormInput, Ma as FilterFormInputClasses, ud as FilterList, S5 as FilterListItem, Wa as FilterListItemClasses, $5 as FilterLiveSearch, pu as FormTab, lp as FormTabHeader, Cw as FunctionField, xi as HideOnScroll, li as IconButtonWithTooltip, vu as ImageField, Dn as ImageFieldClasses, J4 as ImageInput, Z as InputHelperText, Tm as InputPropTypes, fe as Labeled, Ca as LabeledClasses, Uc as Layout, ar as LayoutClasses, Be as LinearProgress, Hn as Link, Eu as LinkClasses, tf as List, ks as ListActions, ci as ListButton, Jr as ListClasses, Dne as ListGuesser, Dp as ListToolbar, Gr as ListView, ha as Loading, Ta as LoadingClasses, bi as LoadingIndicator, la as LoadingIndicatorClasses, _i as LoadingPage, z0 as LocalesMenuButton, Rc as LocalesMenuButtonClasses, ds as Login, Fr as LoginClasses, Gl as LoginForm, Ir as LoginFormClasses, Ti as Logout, Fc as LogoutClasses, Di as Menu, ya as MenuClasses, fn as MenuItemLink, fa as MenuItemLinkClasses, aA as NonEmptyReferenceField, zi as NotFound, ir as NotFoundClasses, ji as Notification, Yt as NotificationClasses, VE as NullableBooleanInput, Bd as NullableBooleanInputClasses, Go as NumberField, ts as NumberInput, vn as Pagination, Bl as PaginationActions, Pd as PaginationLimit, _J as PasswordInput, Lo as Placeholder, hn as PureDatagridBody, $a as PureDatagridRow, Dd as RadioButtonGroupInput, _d as RadioButtonGroupInputClasses, pm as ReOrderButtons, Vn as ReferenceArrayField, Su as ReferenceArrayFieldClasses, Iu as ReferenceArrayFieldView, rs as ReferenceArrayInput, zr as ReferenceField, Lu as ReferenceFieldClasses, vs as ReferenceFieldView, ns as ReferenceInput, ku as ReferenceManyField, wu as ReferenceManyFieldView, Au as ReferenceOneField, yh as RefreshButton, fi as RefreshIconButton, lm as RemoveItemButton, Ha as RemoveSavedQueryDialog, gd as RemoveSavedQueryIconButton, Tr as ResettableTextField, xr as ResettableTextFieldClasses, Hl as ResettableTextFieldStyles, Is as RichTextField, gi as SaveButton, R6 as SavedQueriesList, xn as SavedQueriesListClasses, hd as SavedQueryFilterListItem, qa as SavedQueryFilterListItemClasses, F3 as SearchInput, Wd as SelectArrayInput, ss as SelectArrayInputClasses, Sp as SelectField, Nn as SelectInput, $k as Show, dp as ShowActions, zs as ShowButton, $r as ShowClasses, Hoe as ShowGuesser, Ar as ShowView, ki as Sidebar, Ce as SidebarClasses, nc as SidebarToggleButton, Kn as SidebarToggleButtonClasses, pp as SimpleForm, Na as SimpleFormIterator, Ae as SimpleFormIteratorClasses, Ia as SimpleFormIteratorContext, sm as SimpleFormIteratorItem, Sa as SimpleFormIteratorItemContext, Zt as SimpleFormIteratorPrefix, nD as SimpleList, uf as SimpleListClasses, Hp as SimpleListLoading, As as SimpleListLoadingClasses, Np as SimpleShowLayout, Ns as SimpleShowLayoutClasses, Vp as SingleFieldList, nf as SingleFieldListClasses, xc as SkipNavigationButton, Xg as SortButton, H$ as Tab, ZL as TabbedForm, sp as TabbedFormClasses, rp as TabbedFormTabs, ap as TabbedFormView, L$ as TabbedShowLayout, Op as TabbedShowLayoutClasses, kp as TabbedShowLayoutTabs, at as TextField, Fe as TextInput, Zc as ThemeProvider, je as Title, No as TitlePropType, W_ as ToggleThemeButton, wn as Toolbar, Lr as ToolbarClasses, om as TopToolbar, ooe as TranslatableFields, Mu as TranslatableFieldsTab, Hu as TranslatableFieldsTabContent, wK as TranslatableInputs, Ud as TranslatableInputsTab, ls as TranslatableInputsTabClasses, Qd as TranslatableInputsTabContent, Jd as TranslatableInputsTabContentClasses, Xd as TranslatableInputsTabs, cs as TranslatableInputsTabsClasses, jr as UrlField, ma as UserMenu, un as UserMenuClasses, pa as UserMenuContext, zu as WrapperField, EG as areValidSavedQueries, Zd as defaultTheme, cp as editFieldTypes, ao as extractValidSavedQueries, A7 as findTabsWithErrors, Wq as getArrayInputError, HI as getFilterFormValues, wp as getShowLayoutTabFullPath, np as getTabbedFormTabFullPath, ld as isValidSavedQuery, _p as listFieldTypes, MI as mergeInitialValuesWithDefaultValues, xA as removeTags, sn as sanitizeButtonRestProps, X as sanitizeFieldRestProps, ne as sanitizeInputRestProps, Lp as showFieldTypes, nm as useArrayInput, lU as useCreateSuggestionContext, Hc as useResetErrorBoundaryOnLocationChange, no as useSavedQueries, ht as useSidebarState, Fa as useSimpleFormIterator, Ea as useSimpleFormIteratorItem, mr as useSupportCreateSuggestion, sa as useTheme, dq as useUserMenu };